const zh = {
wholesaleQtyLabel: "几件起批发",
priceLabels: "价格标签",
bankLedgerMenu: "银行账务",
// Common
    save: "保存", cancel: "取消", delete: "删除", edit: "编辑", add: "添加",
    search: "搜索", loading: "加载中...", confirm: "确认", close: "关闭",
    clear: "清空", print: "打印", export: "导出", all: "全部",
    actions: "操作", noData: "暂无数据", noResults: "无结果", noSearchResult: "未找到匹配商品",
    operationFailed: "操作失败", addSuccess: "添加成功", updateSuccess: "更新成功",
    deleteSuccess: "删除成功", deleteFailed: "删除失败", loadFailed: "加载失败",
    deleteConfirm: "确定删除?", fillCompleteInfo: "请填写完整信息",
    // Auth
    username: "用户名", password: "密码", login: "登录", logout: "退出登录",
    deviceVerifyTitle: "新设备首次登录，验证码已发到邮箱", deviceVerifyResent: "验证码已重新发送", deviceVerifyResend: "重发验证码", deviceVerifyHelp: "10 分钟内有效。收不到？让老板在后台「可信设备」放行，或联系 Sellox 支持。", trustedDevicesMenu: "🔐 可信设备", adminTabMerchantHint: "商家请点「商家登录」页签（输入商户ID + 用户名 + 密码）", adminLogin: "管理员登录", tenantLogin: "商家登录", posLogin: "前台收银", posLoginHint: "收银员专用 - 登录后直接进入收银台", enterPos: "进入收银台",
    fillAllFields: "请填写所有字段", tenantIdLabel: "商家ID", providedByAdmin: "由管理员提供",
    pointsLookup: "会员积分查询", loyaltyTierBenefits: "等级权益", pointsHistory: "积分明细",
    memberCode: "会员编码", cancelled: "已取消",
    unitPcs: "件",
    plan_basic: "基础版", plan_pro: "专业版", plan_enterprise: "企业版",
    plan_lifetime_1: "普通版 · 单店（终身）", plan_lifetime_2: "商业版 · 2 店（终身）", plan_lifetime_4: "企业版 · 4 店（终身）", plan_lifetime_6: "旗舰版 · 门店不限（终身）", plan_lifetime_5: "企业版 · 11 店（终身·旧）",
    plan_trial: "试用版",
    upgradePlan: "升级套餐",
    upgradePlanCurrent: "当前套餐",
    upgradePlanTo: "升级到",
    upgradePlanConfirm: "确认升级",
    upgradePlanSuccess: "套餐升级成功",
    upgradePlanCurrentLimits: "当前限额",
    upgradePlanUsers: "个用户",
    upgradePlanStores: "家门店",
    upgradePlanUnlimited: "无限",
    deleteTenant: "删除租户",
    deleteTenantWarning: "删除后该租户的所有数据将永久丢失，无法恢复！",
    deleteEnterPassword: "请输入管理员密码确认删除",
    deletePasswordWrong: "密码错误，删除取消",
    deleteTenantConfirm: "确认删除",
    shopUrl: "商城链接",
    // Admin sidebar
    dashboard: "仪表盘", storeManagement: "门店管理", warehouseManagement: "仓库管理",
    productManagement: "商品管理", transferManagement: "调货管理",
    customerManagement: "客户管理", supplierManagement: "供应商",
    purchaseManagement: "采购管理", salesManagement: "销售管理",
    onlineOrders: "网店订单", reports: "报表统计", exchangeRates: "汇率设置",
    paymentSettings: "支付设置", salesReport: "销售报告",
    saasManagement: "SaaS商家管理", adminManual: "管理员手册", videoTutorials: "视频教程", userManual: "使用手册",
    // Dashboard
    todaySales: "今日销售", onlineOrderTotal: "网店订单", totalProducts: "商品总数",
    pendingOrders: "待处理订单", recentSales: "最近销售", quickActions: "快捷操作",
    // Products
    productCode: "编码", productName: "商品名称", category: "分类",
    unit: "单位", costPrice: "成本价", margin: "利率",
    price1: "价格1", price2: "价格2", price3Box: "价格3(整箱)",
    boxQuantity: "每箱数量", status: "状态", active: "在售", inactive: "下架",
    addProduct: "添加商品", editProduct: "编辑商品", priceSettings: "价格设置",
    marginFormula: "成本 × (1 + 利率%)",
    searchProduct: "搜索商品名称/编码...",
    // Product Import
    importProducts: "导入商品", selectFile: "选择文件",
    supportedFormats: "支持格式", importSuccess: "导入成功",
    importFailed: "导入失败", downloadTemplate: "下载模板",
    importCount: "导入数量", skipDuplicate: "跳过重复", overwriteDuplicate: "覆盖重复",
    duplicateHandling: "重复处理", startImport: "开始导入",
    importing: "导入中...", importResult: "导入结果",
    created: "新增", updated: "更新", skipped: "跳过", failed: "失败",
    // POS
    posTitle: "POS", currency: "币种", shift: "班次",
    openShift: "开班", openingCashFloat: "开班备用金", openingCashHint: "抽屉里现在有多少现金？用来找零。结班时系统会自动减掉这个金额对账。",
    startShift: "当班", endShift: "交班", noShift: "未当班",
    shiftSince: "当班开始", salesOrder: "销售单", items: "件",
    products: "商品", quantity: "数量", priceType: "价格类型",
    unitPrice: "单价", amount: "金额", total: "合计",
    sendToCashier: "📨 发送到收银台", checkout: "收款", scanOrSearch: "扫描条码 / 搜索商品名称...",
    box: "整箱", boxes: "箱", pieces: "件",
    paymentMethod: "支付方式", cash: "现金", card: "刷卡", giftCard: "🎫 购物券",
    received: "收到金额", change: "找零", changeInBs: "找零给 Bs", changeInUsd: "找零给 $", confirmPayment: "确认收款", orderComplete: "订单已完成", skip: "跳过",
    // Stores
    storeCode: "门店编码", storeName: "门店名称", addStore: "添加门店",
    editStore: "编辑门店", headquarters: "总部", associatedWarehouse: "关联仓库",
    physicalStore: "实体门店", onlineStore: "网店",
    selectWarehouse: "选择仓库",
    // Warehouses
    warehouseCode: "仓库编码", warehouseName: "仓库名称", addWarehouse: "添加仓库",
    setMainWarehouse: "设为总部仓库", inventoryQty: "库存数量",
    reservedQty: "预留数量", availableQty: "可用数量",
    noInventoryData: "暂无库存数据", inventoryList: "库存列表",
    // Customers
    customerCode: "客户编码", customerName: "客户名称", addCustomer: "添加客户",
    searchCustomerPlaceholder: "搜索客户名称、电话...",
    memberLevel: "会员等级", points: "积分", balance: "余额",
    normal: "普通", vip: "VIP",
    // Suppliers
    supplierCode: "供应商编码", supplierName: "供应商名称", addSupplier: "添加供应商",
    contact: "联系人",
    // Purchases
    createPurchaseOrder: "新建采购单", orderNo: "单号", itemCount: "商品数",
    purchaseNoProducts: "暂无商品，请先在「商品管理」中添加商品",
    purchaseBatchSelect: "勾选商品（可多选）",
    purchaseBatchAdd: "批量添加到采购单",
    purchaseAddedItems: "已添加商品",
    purchaseItemsAdded: "个商品已添加",
    purchaseSelectAtLeastOne: "请至少勾选一个商品",
    purchaseNotesPlaceholder: "备注（选填）",
    transferBatchSelect: "勾选要调货的商品（可多选）",
    transferBatchConfirm: "批量调货",
    transferSelectAtLeastOne: "请至少勾选一个商品",
    transferNoStock: "该仓库暂无有库存的商品",
    transferSelectWarehouseFirst: "请先选择源仓库",
    transferQty: "调货数量",
    reportCurrency: "货币显示",
    reportBoth: "双币",
    reportExchangeRate: "当前汇率",
    reportUsdSales: "美元收款",
    reportBsSales: "玻利瓦尔收款",
    dbBusinessOverview: "经营总览",
    dbPurchaseIn: "进货统计",
    dbTotalPO: "采购单总数",
    dbReceived: "已入库",
    dbPendingReceive: "待入库",
    dbTotalPurchaseItems: "进货总件数",
    dbTotalPurchaseAmount: "进货总金额",
    dbDamageLoss: "损耗统计",
    dbLossRecords: "损耗记录数",
    dbLossQty: "损耗数量",
    dbLossValue: "损耗金额",
    dbRetailSales: "零售出单",
    dbTotalOrders: "总订单",
    dbTotalItems: "总件数",
    dbTotalRevenue: "总收入",
    dbWholesale: "批发出单",
    dbCompleted: "已完成",
    dbPending: "待处理",
    dbTotalPaid: "已收款",
    dbUnpaid: "欠款未收",
    dbPaidToSupplier: "已付供应商",
    dbSupplierDebt: "欠供应商",
    poRecordPay: "付款",
    poPayAmount: "本次付款金额",
    poPayAll: "全额支付",
    poPaySuccess: "付款成功",
    posStockLookup: "库存查询",
    posReserved: "预留",
    posAvailable: "可用",
    posMinStock: "最低库存",
    posOutOfStock: "缺货",
    posLowStock: "低库存",
    allWarehouses: "全部仓库",
    posCartEmpty: "点击左边商品添加",
    posNeedShift: "请先开始班次后才能收款",
    totalAmount: "总金额", createTime: "创建时间",
    receiveGoods: "入库", receivedStatus: "已入库", pendingReceive: "待入库",
    selectSupplier: "选择供应商", selectProduct: "选择商品",
    receiveWarehouse: "入库仓库", createSuccess: "创建成功",
    addItems: "添加商品",
    // Sales
    otherPayment: "其他", completedStatus: "已完成", pendingStatus: "待处理",
    // Transfer
    newTransfer: "新建调货单", sourceWarehouse: "来源仓库",
    targetWarehouse: "目标仓库", product: "商品", transferConfirm: "确认调货",
    inventoryOverview: "各仓库库存概览", transferHistory: "调货记录",
    stock: "库存", time: "时间", source: "来源", target: "目标",
    sameWarehouseError: "来源和目标仓库不能相同",
    transferSuccess: "调货成功", transferFailed: "调货失败",
    // Sales Report
    salesReportTitle: "销售报告", storeFilter: "门店筛选",
    dateFrom: "开始日期", dateTo: "结束日期", generateReport: "生成报告",
    printReport: "打印报告", totalSales: "总销售额", totalOrders: "总订单数", avgPerOrder: "单均", byCurrency: "按币种统计", byPaymentMethod: "按支付方式",
    totalItems: "总商品数", storeSalesDetail: "分店销售明细",
    productSalesDetail: "商品销售明细", soldQuantity: "售出数量",
    salesAmount: "销售额", topProducts: "热销商品",
    // Shop
    shopTitle: "网上商店", myOrders: "我的订单", addToCart: "加入购物车",
    cart: "购物车", checkoutTitle: "结账", orderSuccess: "下单成功",
    orderLookup: "查单", orderNumber: "订单号", phone: "电话",
    shippingInfo: "收货信息", paymentInfo: "支付信息",
    // Online/Offline
    online: "联网", offline: "断网", offlineMode: "断网模式",
    cachedData: "缓存", offlineCacheMode: "离线模式 - 使用本地缓存数据，订单将在恢复网络后自动同步",
    offlineNoCache: "离线且无缓存数据 - 请先联网登录一次",
    pendingSync: "待同步", syncNow: "立即同步", syncSuccess: "同步成功",
    offlineWarning: "当前处于断网模式，数据将在恢复联网后自动同步",
    // Stores/Warehouses
    location: "地址", type: "类型",
    retail: "零售店", warehouse: "仓库", mainWarehouse: "总仓库",
    // Customers/Suppliers
    name: "名称", contactPhone: "联系电话", email: "邮箱", address: "地址",
    // Purchase
    purchaseOrder: "采购单", supplier: "供应商",
    received_status: "已入库", pending: "待处理",
    // Language
    language: "语言", chinese: "中文", english: "English", spanish: "Español",
    // Extra
    discount: "折扣", orderDetail: "订单明细", shipping: "运费",
    paid: "已付", processing: "处理中", shipped: "已发货", completed: "已完成",
    customer: "客户", date: "日期",
    // New features
    systemSettings: "系统参数", employees: "员工管理", stockAlerts: "库存预警", stockTaking: "库存盘点",
    stockLoss: "报损", stockLossManagement: "报损管理", newStockLoss: "新建报损", stockLossSuccess: "报损登记成功",
    stockLossSearchProduct: "搜索商品名称或编码...", stockLossQty: "报损数量", stockLossReason: "报损原因",
    stockLossNotePlaceholder: "补充说明（选填）", stockLossCostEstimate: "预计损失", confirmStockLoss: "确认报损",
    stockLossOnlyManagers: "仅管理员/店长可操作报损", totalLossRecords: "报损记录", totalLossQty: "报损数量",
    totalCostLoss: "损失金额", costLoss: "损失", operator: "操作人", allReasons: "全部原因",
    companyName: "公司名称", taxId: "税号", companyAddress: "公司地址", companyPhone: "公司电话",
    invoiceHeader: "发票抬头", invoiceFooter: "发票底部", printFormat: "打印格式",
    shopTheme: "网店背景主题", businessType: "店铺类型", shopDescription: "店铺描述 (显示在网店首页)", shopDescPlaceholder: "例如: 新鲜蔬果 每日直送", shopPreview: "网店链接预览",
    themeSupermarket: "超市", themeRestaurant: "餐馆", themeDepartment: "百货", themePharmacy: "药房", themeBakery: "面包店", themeClothing: "服装", themeElectronics: "电子产品", themeButcher: "肉铺", themeGeneral: "通用", themeCustom: "自定义图片",
    uploadBackground: "上传背景图片 (建议 1920x800, 最大 5MB)", selectImage: "选择图片", uploadSuccess: "上传成功",
    autoPrint: "自动打印", printSuccess: "已发送到打印机", receiptCopies: "打印份数", scannerEnabled: "扫码枪",
    printerConfig: "打印机选项", posReceiptPrinter: "零售收据打印机(POS)", reportPrinter: "报表打印机", fiscalPrinter: "税务打印机",
    printerName: "打印机名称", printerModel: "打印机型号", connectionPort: "连接端口", paperSize: "纸张大小",
    thermal: "热敏", enableCashDrawer: "启用钱箱控制", printItemCode: "打印货品编号 (仅税务单据)",
    silentPrintTip: "静默打印设置 (不弹出打印对话框)", setDefaultPrinter: "将XP-80C设为Windows默认打印机", downloadShortcut: "下载快捷方式文件，放到桌面双击打开", closeAllBrowserFirst: "使用独立进程模式，无需关闭其他浏览器窗口",
    chromeKioskTip: "Edge/Chrome快捷方式 → 右键属性 → 目标末尾加：", autoPrintTip: "用此快捷方式打开浏览器，付款后自动静默打印",
    reportPrinterDesc: "用于打印销售报表、库存报表等A4文档", testPrint: "测试打印",
    qzNotConnected: "静默打印未连接 - 安装QZ Tray实现自动打印", download: "下载",
    wholesaleEnabled: "批发功能", wholesaleMinQty: "批发起订量", wholesaleDiscount: "批发折扣",
    refund: "退货退款", refundReason: "退货原因", holdOrder: "挂单", recallOrder: "取单",
    dailySettlement: "日结报表", grossProfit: "毛利润", netSales: "净销售",
    permission: "权限", canDiscount: "允许打折", canRefund: "允许退货", maxDiscount: "最大折扣",
    wholesale: "批发", retailMode: "零售模式", wholesaleMode: "批发模式",
    receipt80mm: "80mm小票", receiptA4: "A4发票", printReceipt: "打印", reprintReceipt: "重印收据", receiptDetail: "收据详情",
    bestSellers: "畅销商品", slowSellers: "滞销商品", actualQty: "实际数量", systemQty: "系统数量",
    difference: "差异", enterQty: "输入数量",
    // Exchange Rates
    systemRates: "系统汇率", categoryRates: "分类汇率",
    categoryRateDesc: "配置各分类的独立汇率",
    productRate: "商品汇率", productRateDesc: "商品价格 $ 转 Bs 用的汇率",
    salesExchangeRate: "销售汇率", salesExchangeRateDesc: "POS收银/小票显示用的汇率 (BCV自动更新)",
    salesRate: "销售汇率", salesRateDesc: "选择$开单时，用销售汇率计算应收美金（公式：商品价 × 销售汇率 ÷ 商品汇率）",
    noSalesRates: "未添加销售汇率，点击右上角添加",
    localSymbol: "本地货币符号", saveRates: "保存汇率", ratesUpdated: "汇率已更新",
    quickConverter: "快速换算", example: "示例",
    // Payment Settings
    bankTransfer: "银行转账", mobilePay: "移动支付",
    bankName: "银行名称", accountNumber: "账户号码",
    accountHolder: "账户持有人", idNumber: "身份证号",
    selectBank: "选择银行", saveSettings: "保存设置", settingsSaved: "设置已保存",
    saveFailed: "保存失败", preview: "预览",
    transferData: "转账信息", mobilePayData: "移动支付信息",
    bank: "银行", account: "账户", holder: "持有人",
    whatsappContact: "WhatsApp联系",
    whatsappNumber: "WhatsApp号码",
    whatsappHint: "输入带国家代码的号码，不加+或空格",
    whatsappEnabled: "客户下单后可通过WhatsApp联系您",
    casheaBNPL: "先买后付", casheaDesc: "客户通过Cashea分期付款，无利息",
    casheaCedula: "客户身份证号", casheaAmount: "Cashea支付金额",
    casheaProcessing: "正在通过Cashea处理...", casheaSettingsDesc: "先买后付 - 无利息分期",
    casheaKeyHint: "没有API Key则以演示模式运行。请在 soporte@cashea.com 申请",
    casheaDemoMode: "演示模式 - 付款自动批准", casheaLiveMode: "实时模式 - 已连接Cashea",
    saving: "保存中...",
    notes: "备注",
    printReceipt80mm: "打印小票", printInvoiceA4: "打印发票",
    printPriceLabels: "打印价格标签", printPreview: "打印预览",
    labelDisplayMode: "标签显示", labelModeP1: "价格1(零售)", labelModeP3: "价格3(批发)", labelModeWholesale: "整箱价格(批发)", labelModeP1P3: "价格1+价格3", labelModeP1W: "价格1+整箱价格", labelModeUsdP1: "外币价格1(零售)", labelShowForeign: "显示外币($)", labelNoDecimals: "不含小数", labelShowBarcode: "显示条码", labelPaperSize: "标签纸", labelSize80mm: "80mm 热敏", labelSize50x30: "50x30mm 标签", labelBilingual: "双语(ES+CN)",
    selectProducts: "选择商品", selectAll: "全选",
    deselectAll: "取消全选", selectedCount: "已选",
    printSelected: "打印选中", time: "时间",
    connectPrinter: "连接打印机", printerReady: "已连接", printerConnected: "打印机已连接", printerConnectFailed: "连接失败", directPrintFailed: "直连打印失败", printing: "打印中...",
    // Pricing mode
    pricingMode: "外币定价模式",
    pricingLocalBased: "外币价格按本地价格计算",
    pricingLocalDesc: "Bs.价格=进货价×分类汇率, USD=Bs.÷销售汇率（适用黑市汇率）",
    pricingForeignDirect: "外币价格按本身价格",
    pricingForeignDesc: "直接使用商品设定的USD价格（适用央行汇率）",
    dailySettlement: "日结报表", grossProfit: "毛利润",
    refundHistory: "退款记录", refundReason: "原因", expenseManagement: "开支管理", addExpense: "新增开支", totalExpenses: "总开支", expenseCount: "笔数", expenseByStore: "各门店开支", avgOrder: "平均客单", expenseDesc: "描述", expense_rent: "房租", expense_utilities: "水电", expense_salary: "工资", expense_supplies: "耗材", expense_maintenance: "维修", expense_transport: "运输", expense_food: "餐饮", expense_tax: "税费", expense_other: "其他", selectStore: "选择门店", categoryManagement: "分类管理",
    categoryRateDesc: "每个分类可设置独立汇率，用于计算Bs.价格",
    usdPricingMode: "$开单模式",
    originalUsd: "按录入的 $ 价（默认，¥/$ 定价的店用这个）",
    bsToUsd: "Bs 货架价 ÷ 汇率（货架按 Bs 标价的店）",
    originalUsdDesc: "前台 $ 开单和网店都直接用商品录入的 $ 价（¥ 显示 = $ × ¥汇率）",
    bsToUsdDesc: "前台$开单时，用 Bs 售价 ÷ 当前汇率反算 $ 价格；网店同样以 Bs 价为准",
    systemRates: "系统汇率",
    // New Features Phase 2
    profitAnalysis: "利润分析", revenue: "营业额", cost: "成本", profit: "利润",
    profitMargin: "毛利率", overallMargin: "整体毛利率", totalRevenue: "总营收",
    totalCost: "总成本", totalProfit: "总利润",
    categoryAnalysis: "分类/汇率分析", categoryBreakdown: "按分类统计", dailyBreakdown: "按日统计",
    govtGoods: "政府汇率拿货", blackMarketGoods: "黑市拿货", rateLabel: "汇率:", blackMarket: "黑市",
    salesUsd: "销售额($)", salesBs: "销售额(Bs)", costUsd: "成本($)", profitUsd: "利润($)",
    pricingMode: "定价模式", margin: "利润率", totalSales: "总销售额",
    thisWeek: "本周", thisMonth: "本月", lastMonth: "上月",
    today: "今天", allStores: "所有门店", categoryName: "分类", exchangeRate: "汇率",
    orders: "订单", sales: "销售额", items: "件数",
    grossProfit: "毛利润", netProfit: "净利润", expenses: "日常开支", stockLoss: "损坏/报损",
    expenseBreakdown: "开支明细", lossBreakdown: "损坏/报损明细",
    damage: "损坏", expired: "过期", personalUse: "自用", sample: "样品", other: "其他",
    rateType: "选择汇率", selectedRate: "当前汇率", usdEquivalent: "折合美元",
    expenseRent: "房租", expenseUtilities: "水电", expenseSalary: "工资", expenseSupplies: "耗材",
    expenseMaintenance: "维修", expenseTransport: "运输", expenseFood: "餐饮", expenseTax: "税费",
    exchangeProfit: "汇兑收益", buyUsdCash: "买美金现金", cardToCash: "刷卡换现金",
    usdAmount: "美金金额($)", buyRate: "买入汇率", sellRate: "卖出汇率",
    cardAmount: "刷卡金额(Bs)", cashGiven: "给出现金(Bs)", bsCost: "Bs成本", bsValue: "Bs价值",
    profitBs: "利润(Bs)", profitUsd: "利润($)", commissionPct: "手续费率",
    todayProfitBs: "今日利润(Bs)", todayProfitUsd: "今日利润($)",
    exchangeProfitDetail: "汇兑收益明细", cashMustBeLess: "现金应小于刷卡金额",
    note: "备注", details: "详情", type: "类型",
    purchaseHistory: "消费记录", totalSpent: "累计消费", orderCount: "订单数",
    addPoints: "充积分", redeemPoints: "兑换积分", topupBalance: "充值", pointsLog: "积分记录",
    balanceLog: "余额记录", earn: "获得", redeem: "兑换", topup: "充值",
    auditLog: "操作日志", action: "操作", targetType: "对象类型", targetId: "对象ID",
    detail: "详情", operator: "操作员",
    promotions: "促销活动", promoName: "活动名称", promoType: "活动类型",
    discount_promo: "折扣", fullReduction: "满减", buyGet: "买赠", flashSale: "限时特价",
    startDate: "开始日期", endDate: "结束日期", minAmount: "最低金额",
    discountValue: "折扣值", addPromotion: "添加活动",
    accountsReceivable: "应收账款", accountsPayable: "应付账款",
    receivable: "应收", payable: "应付", creditor: "欠款方",
    dueDate: "到期日", paidAmount: "已付金额", remainingAmount: "剩余金额",
    markPaid: "收款", addReceivable: "添加应收", addPayable: "添加应付",
    partialPaid: "部分已付",
    dataBackup: "数据备份", exportBackup: "导出备份", backupDesc: "导出全部数据为JSON文件",
    salesTrend: "销售趋势", last7Days: "最近7天", last30Days: "最近30天",
    rolePermissions: "角色权限", admin: "管理员", manager: "经理", store_manager: "店长", cashier: "收银员", order_taker: "开单员（手机开单·不收款）", staff: "员工", warehouse: "仓管员", finance: "财务", price_checker: "查价员", stock_viewer: "库存查看员", wholesale_clerk: "批发开单员",
    discountAboveCostOnly: "不能低于成本价", discountAboveCostDesc: "打折后价格不能低于进货成本价",
    marketing: "营销管理",
    mktDesc: "邮件、短信、通知客户营销活动",
    mktNewCampaign: "新建活动",
    mktCreateCampaign: "创建活动",
    mktCampaigns: "营销活动",
    mktNoCampaigns: "暂无营销活动",
    mktNameRequired: "活动名称和消息内容为必填",
    mktCampaignCreated: "活动创建成功",
    mktSentTo: "已发送给 {count} 位客户",
    mktSendError: "发送失败",
    mktDeleted: "已删除",
    mktName: "活动名称",
    mktType: "类型",
    mktSegment: "客户分群",
    mktSubject: "邮件主题",
    mktMessage: "消息内容",
    mktVariablesHint: "可用变量: {nombre}, {telefono}, {puntos}",
    mktSend: "发送",
    mktRecipients: "收件人",
    mktAllCustomers: "全部客户",
    mktVipCustomers: "VIP客户",
    mktInactiveCustomers: "不活跃客户 (30天+)",
    mktBirthdayToday: "今天生日",
    mktNamePlaceholder: "周末促销活动",
    mktSubjectPlaceholder: "专属优惠等你来",
    mktMessagePlaceholder: "您好 {nombre}，我们为您准备了特别优惠...",
    mktEmail: "邮件",
    mktSms: "短信",
    mktWhatsapp: "WhatsApp",
    mpLoginRequired: "请先登录",
    mpSearchPlaceholder: "搜索商品...",
    mpAllCategories: "全部",
    mpLoading: "加载中...",
    mpNoResults: "没有找到商品",
    mpItems: "件商品",
    mpTotal: "合计",
    mpEmpty: "购物车是空的",
    mpCharge: "去结账",
    mpPaymentTitle: "收款",
    mpCash: "现金",
    mpCard: "银行卡",
    mpTransfer: "转账",
    mpZelle: "Zelle",
    mpPagoMovil: "Pago Movil",
    mpConfirm: "确认支付",
    mpSaleComplete: "交易完成",
    exportSalesReport: "导出销售报表", exportInventoryReport: "导出库存报表",
    exporting: "导出中...",
    usePoints: "使用积分", pointsAvailable: "可用积分", pointsEarned: "获得积分",
    pointsDiscount: "积分抵扣", pointsIssued: "发放积分", pointsRecon: "积分对账", pointsMonthly: "积分月报", pointsVoidClaw: "作废扣回", pointsRefundClaw: "退货扣回", pointsRestoreUsed: "退还已用积分", pointsManualAdjust: "手动调整", last6Months: "近6个月", pointsRate: "积分比例", noCustomerNoPoints: "选择客户后可使用积分",
    clerkLimitTitle: "网店AI客服每日上限", clerkLimitDesc: "防止路人聊天烧光学分，超限后自动请顾客转 WhatsApp 人工（0 = 不限制）", featBgRemove: "抠图", featBeautify: "美图 Pro", featRetouch: "修图 Pro", featPoster: "AI 海报", featBanner: "AI 横幅", featLegalChat: "法律顾问", featPayroll: "工资月结 AI",
    // Phase 3
    vipRules: "会员等级规则", autoUpgrade: "自动升级", minSpent: "最低消费", pointsMultiplier: "积分倍率",
    silver: "银卡", gold: "金卡", vip: "VIP", normal: "普通",
    wholesale: "批发", wholesaleOrder: "批发订单", createWholesaleOrder: "创建批发订单",
    wholesaleStats: "批发统计", pendingOrders: "待处理订单", totalRevenue: "总收入",
    totalPaid: "已收款", totalItems: "总件数", orderDetail: "订单详情",
    deliveryAddress: "送货地址", deliveryDate: "送货日期", orderNotes: "订单备注",
    markCompleted: "标记完成", markDelivered: "标记已送达", cancelOrder: "取消订单",
    wholesalePrice: "批发价", retailPrice: "零售价", paidAmount: "已付金额",
    unpaidAmount: "未付金额", recordPayment: "登记付款", paymentAmount: "付款金额",
    orderCancelled: "订单已取消", statusPending: "待处理", statusCompleted: "已完成",
    statusDelivered: "已送达", statusCancelled: "已取消", printOrder: "打印订单",
    wholesaleCustomer: "批发客户", itemCount: "商品数",
    attendance: "考勤", clockIn: "上班打卡", clockOut: "下班打卡", hours: "工时", present: "出勤",
    salesTarget: "销售目标", targetAmount: "目标金额", actual: "实际", progress: "完成率",
    setTarget: "设定目标", monthly: "月度", quarterly: "季度",
    purchaseReturn: "采购退货", returnReason: "退货原因", approve: "审批",
    bundles: "商品套餐", bundleName: "套餐名称", bundlePrice: "套餐价", originalPrice: "原价",
    fixedItems: "固定商品", optionalGroups: "可选配件", addGroup: "添加可选组",
    addOptionalGroup: "添加可选组", groupName: "组名称", defaultOption: "默认选项",
    optGroupHint: "至少添加2个选项，顾客购买套餐时从中选一个",
    optGroupNeedTwoOptions: "可选组至少需要2个选项",
    addBundleHint: "创建套餐组合，提升客单价",
    comboAnalytics: "套餐销售分析", comboOrders: "套餐订单数", comboRevenue: "套餐营收",
    comboOrderRatio: "占总订单", activeCombos: "活跃套餐数", avgComboValue: "套餐均价",
    comboRanking: "套餐销售排行", comboSalesDistribution: "套餐销量分布",
    comboTrend: "套餐销售趋势", optionStats: "配件选择统计",
    comboRankingTable: "套餐销售明细", noComboSalesYet: "暂无套餐销售数据",
    createComboHint: "创建套餐后，销售数据将在这里展示",
    addToCart: "加入购物车", saving: "节省", options: "选项",
    noItems: "暂无固定商品", noOptGroups: "暂无可选组",
    costHistory: "进货价变动", notifications: "通知中心", stockLow: "库存不足",
    overdueAccount: "逾期账款", pendingOrdersNotif: "待处理订单",
    uploadImage: "上传图片", deleteImage: "删除图片", restoreBackup: "恢复备份",
    restoreDesc: "从JSON备份文件恢复数据", restoreWarning: "恢复将覆盖现有数据",
    commission: "员工提成", commissionRules: "提成规则", commissionReport: "提成报表",
    baseTier: "基础", standardTier: "达标", excellentTier: "超额",
    commissionRate: "提成比例", estimatedCommission: "预估提成",
    totalCommission: "提成合计", tier: "等级", selectMonth: "选择月份",
    addEmployee: "添加员工", editEmployee: "编辑员工",
    role: "角色", deleteEmployeeConfirm: "确定删除该员工？",
    rolePresetHint: "角色（点击应用预设权限）",
    permPOS: "POS收银", permDiscount: "打折", permSwitchPrice: "切换价格1/2/整箱", permRefund: "退货", permVoid: "撤销交易",
    permProducts: "商品管理", permInventory: "库存管理", permPurchases: "采购管理",
    permCustomers: "客户管理", permReports: "查看报表", permExport: "导出数据",
    permCostPrice: "查看进货价", permEmployees: "员工管理", permSettings: "系统设置",
    permPromotions: "促销管理",
    permEditOrders: "改单", permDescEditOrders: "修改已完成订单的商品和数量（留审计记录）",
    permTakeOnline: "网店接单", permDescTakeOnline: "在POS前台接网店/批发订单、确认开单、打印单据、发货",
    permDescPOS: "使用POS收银", permDescDiscount: "允许打折", permDescSwitchPrice: "前台可切换价格1/价格2/整箱价", permDescRefund: "处理退货",
    permDescVoid: "撤销交易", permDescProducts: "添加/编辑商品、加库存", permDeleteProducts: "删除商品 / 减库存", permDescDeleteProducts: "删除·停用商品、手动减库存、报损——不勾则只能新增和加库存，删减要老板来",
    permDescInventory: "管理库存和调拨", permDescPurchases: "创建采购单",
    permDescCustomers: "管理客户数据", permDescReports: "查看销售报表",
    permDescExport: "导出数据到Excel", permDescCostPrice: "查看商品进货价",
    permDescEmployees: "管理员工", permDescSettings: "系统设置", permDescPromotions: "管理促销活动",
    permGroupWholesale: "🏭 批发", permWsEditPrice: "改批发单价", permWsCredit: "赊账开单", permWsCreditLimit: "改客户信用额度", permWsEditOrders: "改/取消已开批发单", permWsReturns: "批发退货", wsMaxDiscountPercent: "批发折扣上限",
    permDescWsEditPrice: "可手动把批发单价改到价表以上；关掉则只能按批发价表开单", permDescWsCredit: "可给客户赊账开单", permDescWsCreditLimit: "可修改客户的信用额度/账期", permDescWsEditOrders: "不需店长扫码即可改或取消批发单", permDescWsReturns: "可处理批发退货",
    permGroupPOS: "POS收银", permGroupCatalog: "商品目录", permGroupCRM: "客户关系",
    permGroupReports: "报表", permGroupSystem: "系统",
    passwordKeepHint: "留空保持不变",
    enabledCount: "已启用",
    maxDiscountPercent: "最大折扣",
    superAdmin: "超级管理员",
    shops: "商家管理",
    shop: "网店",
    changePassword: "修改密码",
    oldPassword: "旧密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    passwordChanged: "密码修改成功",
    passwordMismatch: "两次密码不一致",
    taxReport: "税务报表",
    // Analytics Center
    analyticsCenter: "数据分析中心",
    acOverview: "概览",
    acCustomerAnalysis: "客户分析",
    acCategoryAnalysis: "品类分析",
    acTrendAnalysis: "趋势分析",
    acRevenue: "营业额",
    acOrders: "订单数",
    acAvgOrder: "客单价",
    acCustomers: "客户数",
    acRevenueTrend: "营业额趋势",
    acTotalCustomers: "总客户数",
    acActiveCustomers: "活跃客户",
    acActivityRate: "活跃率",
    acTopCustomersChart: "客户消费TOP10",
    acCustomerRanking: "客户排名",
    acTotalRevenue: "总营业额",
    acCategoryCount: "品类数量",
    acTopCategory: "最佳品类",
    acCategoryShare: "品类占比",
    acCategoryRevenue: "品类营业额",
    acCategoryDetail: "品类明细",
    acProductCount: "商品数",
    acShare: "占比",
    acPeakHour: "高峰时段",
    acPeakDay: "最佳日",
    acHourlySales: "每小时销售分布",
    acWeekdaySales: "每周销售分布",
    acExportProfit: "导出利润报表",
    ac_week: "本周",
    ac_month: "本月",
    ac_year: "本年",
    acDayUnit: "天",
    acDays: "天",
    acLast: "近",
    // Shift Reports
    shiftReports: "交班记录",
    shiftReport: "交班报表",
    shiftStart: "开始时间",
    shiftEnd: "结束时间",
    shiftDuration: "时长",
    shiftCount: "班次数",
    shiftActive: "进行中",
    shiftEnded: "已结束",
    shiftTxCount: "交易笔数",
    shiftTxCount2: "笔交易",
    shiftSalesDetail: "销售明细",
    shiftReconciliationPrint: "逐笔对账单 (刷卡机/收银对账)",
    printA4: "A4打印",
    printTicket: "小票打印",
    exportExcel: "导出Excel",
    poInvoiceNo: "供应商单号 (发票/送货单号, 选填)",
    shiftNetTotal: "净收入",
    shiftEndConfirmMsg: "确认交班后将生成详细对账报表",
    shiftGenerateReport: "生成交班报表",
    // Stock Alerts
    saTotal: "预警商品总数",
    saCritical: "缺货",
    saWarning: "低库存",
    saOutOfStock: "库存为零",
    saLowStock: "低于安全库存",
    saValueAtRisk: "风险库存价值",
    saCurrentStock: "当前库存",
    saMinStock: "安全库存",
    saShortage: "缺口",
    saSuggestedOrder: "建议采购",
    saOrderCost: "采购成本",
    saLevel: "级别",
    saItemsAffected: "个商品需要关注",
    saTotalSuggestedCost: "建议采购总成本",
    saBatchThreshold: "批量设置阈值",
    saBatchThresholdDesc: "调整商品的安全库存阈值，低于此值将触发预警",
    saUpdated: "已更新",
    saAllGood: "库存充足",
    saAllGoodDesc: "所有商品库存正常，无需担心",
    saAlertBanner: "库存预警提醒",
    saAutoReorder: "一键补货",
    saAutoReorderDesc: "选择供应商和仓库，系统将根据建议采购量自动生成采购订单",
    saSelectSupplier: "请选择供应商",
    saSelectWarehouse: "请选择仓库",
    saSelectSupplierWarehouse: "请选择供应商和仓库",
    saGeneratePO: "生成采购订单",
    saPoGenerated: "采购订单已生成:",
    supplier: "供应商",
    // Dashboard customization
    dbCustomize: "自定义布局",
    dbEditing: "编辑中",
    dbResetLayout: "重置布局",
    dbDragHint: "拖拽卡片调整位置，拖拽边角调整大小",
    // Email Reports
    emailReports: "邮件报表",
    erSmtpConfig: "邮箱设置",
    erSmtpHost: "SMTP服务器",
    erSmtpPort: "端口",
    erSmtpUser: "账号",
    erSmtpPassword: "密码",
    erSenderEmail: "发件邮箱",
    erSenderName: "发件人名称",
    erTestEmail: "发送测试",
    erTestSent: "测试邮件已发送",
    erConfigSaved: "邮箱配置已保存",
    erConfigured: "邮箱已配置",
    erNotConfigured: "邮箱未配置",
    erConfigHint: "请先配置SMTP邮箱以启用邮件报表",
    erAddSchedule: "添加定时报表",
    erReportType: "报表类型",
    erFrequency: "发送频率",
    erRecipients: "收件人",
    erAddRecipient: "添加收件人",
    erDaily: "每天",
    erWeekly: "每周",
    erMonthly: "每月",
    erDailySales: "每日销售汇总",
    erProfitSummary: "利润汇总",
    erSendNow: "立即发送",
    erSentTo: "已发送给",
    erLastSent: "上次发送",
    erDisabled: "已禁用",
    erNoSchedules: "暂无定时报表",
    erNoSchedulesDesc: "配置邮箱后，添加定时报表自动发送给指定收件人",
    // Mobile POS
    mobilePOS: "手机收银",
    mpSelectStore: "选择门店开始收银",
    mpViewCart: "查看购物车",
    mpCart: "购物车",
    mpEmptyCart: "购物车是空的",
    mpCheckout: "去结账",
    mpPayment: "收款",
    mpConfirmPay: "确认收款",
    backToAdmin: "返回管理后台",
    transfer: "转账",
    clearCart: "清空",
    // Store Comparison
    acStoreComparison: "门店对比",
    acStoreCount: "门店数量",
    acTopStore: "最佳门店",
    acStoreRevenue: "门店营业额对比",
    acStoreDetail: "门店明细",
    // POS Shortcuts
    editQty: "改数量",
    editPrice: "改价格",
    uiThemeTitle: "界面主题",
    uiThemeHint: "全店统一，所有收银机和后台生效",
    accentColorLabel: "主题色（按钮/高亮颜色）",
    defaultColor: "默认绿",
    customColor: "自定义颜色",
    uiThemeSaveHint: "👆 点击即时预览，别忘了点右上角\"保存\"让全店生效",
    aiLegalAdvisor: "AI法律顾问",
    editPriceNeedAuth: "改价需要授权（扫码或密码）",
    usdPriceHint: "美金价（Bs ÷ 汇率）",
    bsPriceLabel: "Bs 价格",
    usdPriceLabel: "$ 美金价格",
    priceBelowCostConfirm: "价格低于成本！确定继续吗？",
    shortcutHint: "按上下箭头选择商品, F5改数量, F6改价格",
    splitPayment: "拆分支付", addNote: "备注", itemNote: "商品备注", orderNote: "订单备注",
    enterNote: "输入备注...", enterOrderNote: "输入订单备注...", clearNote: "清除",
    noSugar: "无糖", lessIce: "少冰", extraHot: "加辣", noOnion: "不要洋葱", takeaway: "外带", urgent: "加急",
    exact: "刚好", addPaymentMethod: "添加支付方式",
    // Loyalty Program
    loyaltyProgram: "会员忠诚度",
    loyaltyDesc: "管理会员等级、积分规则和奖励机制",
    loyaltyTiers: "会员等级",
    loyaltyMembers: "会员总数",
    loyaltyTotalPoints: "积分总量",
    loyaltyIssued30d: "30天发放积分",
    loyaltyRedeemed30d: "30天兑换积分",
    loyaltyLevelDist: "会员等级分布",
    loyaltyTopMembers: "积分排行榜",
    loyaltyRecentActivity: "最近积分活动",
    loyaltyAddTier: "添加会员等级",
    loyaltyTierColor: "等级颜色",
    loyaltyPointsConfig: "积分规则",
    loyaltyEarnRate: "积分获取比例",
    loyaltyPtsPerDollar: "积分/美元",
    loyaltyRedeemRate: "积分兑换比例",
    loyaltyPtsEqDollar: "积分=1美元",
    loyaltyBonusConfig: "奖励设置",
    loyaltyWelcomeBonus: "注册奖励",
    loyaltyWelcomeBonusDesc: "新客户注册时赠送积分",
    loyaltyBirthdayBonus: "生日奖励",
    loyaltyBirthdayBonusDesc: "客户生日当天赠送积分",
    loyaltyReferralBonus: "推荐奖励",
    loyaltyReferralBonusDesc: "推荐新客户时赠送积分",
    // Sales Channels
    salesChannels: "销售渠道",
    salesChannelsDesc: "查看各销售渠道的业绩和趋势",
    channel_pos: "POS零售",
    channel_online: "网店",
    channel_wholesale: "批发",
    channelGrandTotal: "总营业额",
    channelShare: "渠道占比",
    channelRevenue: "渠道营业额",
    channelTrend: "渠道趋势",
    channelDetails: "渠道明细",
    channelName: "渠道名称",
    // Member Lookup QR
    loyaltyQrCode: "查询二维码",
    loyaltyQrCodeDesc: "打印此二维码放置在收银台，顾客扫码即可查询积分",
    loyaltyQrLink: "查询链接",
    loyaltyQrPrint: "可截图打印贴在柜台供顾客扫码使用",
    loyaltyNoTenant: "请先创建商户",
    selectTenant: "选择商户",
    copied: "已复制",
    // Points Mall
    pointsMall: "积分商城",
    pointsMallDesc: "管理积分兑换商品和兑换订单",
    mallItems: "兑换商品",
    mallOrders: "兑换订单",
    mallAddItem: "添加商品",
    mallEditItem: "编辑商品",
    mallNoItems: "暂无兑换商品，点击添加",
    mallType_coupon: "优惠券",
    mallType_gift: "礼品",
    mallType_balance: "余额充值",
    mallStock: "库存",
    mallUnlimited: "不限",
    mallRedeemed: "已兑换",
    mallFillRequired: "请填写商品名称和所需积分",
    mallPerLimit: "每人限兑",
    mallCouponSettings: "优惠券设置",
    mallCouponType: "优惠类型",
    mallDiscountAmount: "满减金额",
    mallDiscountPercent: "折扣比例",
    mallMinOrder: "最低消费",
    mallValidDays: "有效天数",
    mallBalanceSettings: "余额充值设置",
    mallBalanceAmount: "充值金额",
    mallGiftSettings: "礼品设置",
    mallGiftInfo: "礼品说明",
    mallGiftInfoPlaceholder: "如：到店领取精美礼品一份",
    mallItemName: "商品名称",
    mallComplete: "完成",
    mallStatus_pending: "待处理",
    mallStatus_completed: "已完成",
    mallStatus_cancelled: "已取消",
    active: "启用",
    inactive: "停用",
    mallTimed: "限时",
    mallTimedSale: "限时抢兑",
    mallStartTime: "开始时间",
    mallEndTime: "结束时间",
    mallUploadImage: "上传图片",
    mallPendingUpload: "保存后上传",
    mallImageHint: "支持 JPG/PNG/WebP 格式，建议正方形图片",
    // Member Lookup Page
    memberNormal: "普通会员", memberSilver: "银卡会员", memberGold: "金卡会员", memberVip: "VIP会员",
    memberPhonePlaceholder: "请输入手机号", memberCodePlaceholder: "请输入会员编码",
    memberInvalidLink: "无效的查询链接", memberNotFound: "未找到该会员信息", memberSearchFailed: "查询失败，请重试",
    memberRedeemSuccess: "兑换成功！", memberRedeemFail: "兑换失败",
    memberInsufficient: "积分不足", memberSoldOut: "已售罄", memberLimitReached: "已达兑换上限",
    memberMyProfile: "我的", memberMallTab: "积分商城", memberOrdersTab: "兑换记录",
    memberPointsEarn: "积分获取", memberPointsRedeem: "积分兑换",
    memberTimedEnded: "已结束", memberTimedNotStarted: "未开始", memberRedeemBtn: "兑换",
    memberTrialExpired: "已过期", memberTrialDays: "试用{days}天",
    memberTrialRemaining: "剩余 {days} 天",
    memberUpgradeProgress: "升级进度", memberNeedSpend: "还需消费", memberMaxLevel: "已达最高等级",
    mallFlashSale: "限时抢兑", couponCode: "券码",
    // Video Tutorials Page
    vidCatPos: "POS 收银", vidCatProducts: "商品管理", vidCatInventory: "库存管理",
    vidCatSales: "销售管理", vidCatCustomers: "客户管理", vidCatReports: "报表",
    vidCatSettings: "系统设置", vidCatGeneral: "其他",
    vidRecStart: "录屏开始！操作完成后点击停止", vidRecFail: "无法启动录屏",
    vidUploadSuccess: "视频上传成功！", vidUploadFail: "上传失败",
    vidDeleteConfirm: "确定删除此视频？", vidDeleted: "已删除", vidDeleteFail: "删除失败",
    vidUpdated: "已更新", vidUpdateFail: "更新失败",
    vidUploadBtn: "上传视频", vidUploading: "上传中...",
    vidRecHint: "请操作您要演示的功能，完成后点击「停止录屏」",
    vidNoData: "点击「开始录屏」录制操作教程，或「上传视频」上传已有视频",
    vidTitleLabel: "标题", vidDefaultTitle: "教程视频", vidVideoTitle: "视频标题",
    vidSaveUpload: "保存并上传",
    startRecording: "开始录屏", stopRecording: "停止录屏", recording: "正在录屏",
    vidPreviewTitle: "录屏预览",
    vidGenerating: "正在生成教程视频...",
    vidGenerateBtn: "生成语音解说教程",
    vidGeneratingBtn: "生成中...",
    vidGenerateSuccess: "教程视频生成完成！",
    vidGenerateFail: "生成失败",
    vidGenerateDesc: "系统正在自动录制操作并生成语音解说教程视频。",
    vidProgress: "进度",
    vidGenerateComplete: "录制完成！",
    done: "完成", close: "关闭",
    // Tenant Management & Subscription
    tenantManagement: "租户管理",
    addTenant: "添加租户",
    totalTenants: "总租户数",
    activeTenants: "活跃租户",
    inactiveTenants: "停用租户",
    tenantName: "租户名称",
    tenantBusinessName: "商户名称",
    contactPerson: "联系人",
    details: "详情",
    plan: "套餐",
    subSubscription: "订阅",
    subAlerts: "订阅提醒",
    subExpired: "已过期",
    subExpiringSoon: "即将到期",
    subActive: "有效",
    subNone: "未设置",
    subExpiringSoonList: "即将到期租户",
    subExpiredList: "已过期租户",
    subDaysLeft: "后到期",
    subExpiryDate: "到期日",
    subRenew: "续费",
    subSuspend: "暂停",
    subActivate: "激活",
    subAnnualRevenue: "年收入",
    subStartDate: "开始日期",
    subYears: "订阅年数",
    subYear: "年",
    subAnnualFee: "年费",
    subNote: "备注",
    subNotePlaceholder: "订阅备注信息...",
    subTrialAccount: "试用账户",
    subTrialDays: "试用天数",
    subAdminAccount: "管理员账户",
    subStatus: "订阅状态",
    subCurrentExpiry: "当前到期日",
    subRenewYears: "续费年数",
    subConfirmRenew: "确认续费",
    subTrial: "试用",
    subDashExpiring: "即将到期提醒",
    subDashDesc: "以下租户订阅即将到期或已过期",
    subCopyReminder: "复制提醒",
    subReminderCopied: "提醒消息已复制到剪贴板",
    subRenewReminder: "续费提醒",
    subLastReminded: "上次提醒",
    superAdmin: "超级管理员",
    // Trial Conversion
    trialTitle: "试用期即将结束",
    trialSubTitle: "订阅即将到期",
    trialExpiredBadge: "已到期",
    trialRemaining: "后到期",
    trialOverdue: "已过期",
    trialExpiredMsg: "您的使用权限已到期，请联系管理员续费以继续使用所有功能。",
    trialExpiringMsg: "请及时续费以确保系统正常使用，所有数据将安全保留。",
    trialProducts: "商品数",
    trialCustomers: "客户数",
    trialSales: "订单数",
    trialRevenue: "总营业额",
    trialStores: "门店数",
    trialSeeValue: "查看您的经营成果",
    trialValueTitle: "您已取得的成果",
    trialValueMsg: "您已录入 {products} 个商品、服务了 {customers} 位客户、完成了 {sales} 笔交易，总营业额达到 ${revenue}。这些宝贵数据都将在续费后继续为您服务。",
    trialAnnualFee: "年费",
    trialContactAdmin: "请联系管理员办理续费，续费后即可继续使用所有功能。您的数据安全无忧！",
    // Self-Registration
    regTitle: "免费试用 Sellox",
    regSubtitle: "7天免费体验，无需信用卡",
    regCompanyName: "公司/店铺名称",
    regCompanyPlaceholder: "输入您的公司或店铺名称",
    regContactPerson: "联系人",
    regContactPlaceholder: "您的姓名",
    regContactPhone: "联系电话",
    regPhonePlaceholder: "手机号码",
    regAccountSection: "设置您的管理员登录账号",
    regAdminUsername: "管理员用户名",
    regUsernamePlaceholder: "至少3个字符",
    regPassword: "密码",
    regConfirmPassword: "确认密码",
    regPasswordMismatch: "两次密码不一致",
    regPasswordTooShort: "密码至少6位",
    regTrialNote: "注册即获得14天免费试用，包含所有功能。试用结束后可联系我们续费升级。",
    regSubmit: "立即注册",
    regBackToLogin: "已有账号？返回登录",
    regFreeTrialLink: "还没有账号？免费试用 7 天",
    regSuccess: "注册成功！",
    regSuccessTitle: "注册成功",
    regSuccessDesc: "您的试用账号已创建，请妥善保存以下登录信息",
    regTrialPeriod: "试用期限",
    regDays: "天",
    regSaveCredentials: "请务必记住您的商家ID和用户名，登录时需要使用。建议截图或复制保存。",
    regGoLogin: "前往登录",
    regCopied: "已复制到剪贴板",
    creditManagement: "赊账管理",
    referralRewards: "推荐奖励",
    categoryImportSuccess: "分类导入成功",
    enterCategoryName: "请输入分类名称",
    addCategory: "添加分类",
    catCode: "编码",
    catNameRequired: "名称",
    catRateLabel: "汇率",
    catNote: "备注",
    systemRate: "系统汇率",
    usdByRate: "按汇率",
    receiptSentEmail: "收据已发送到邮箱",
    sendFailed: "发送失败",
    changeFailed: "修改失败",
    confirmChange: "确认修改",
    importDepartments: "导入分类",
    downloadDeptTemplate: "下载分类模板",
    // Warehouse Edit/Delete
    editWarehouse: "编辑仓库",
    deleteWarehouseConfirm: "确定删除该仓库？",
    cannotDeleteMainWarehouse: "主仓库不能删除",
    warehouseHasStock: "仓库内还有库存，无法删除",
    // POS Credit Payment
    credit: "赊账",
    creditPayment: "赊账",
    selectCustomerForCredit: "赊账必须选择客户",
    creditRecorded: "赊账已记录",
    // POS Hardcoded strings
    paymentCurrencyLabel: "支付货币",
    bsPayment: "Bs 支付",
    usdPayment: "$ 支付",
    selectPrinter: "选择打印机：",
    scanQrReceipt: "顾客扫码查看电子小票",
    emailSendReceipt: "邮件发送收据",
    bsPaid: "Bs支付",
    usdPaid: "$支付",
    // Receipt Public Page
    invalidLink: "链接无效",
    receiptNotFound: "收据不存在或已过期",
    paymentSuccess: "支付成功",
    orderNoLabel: "单号",
    customerLabel: "客户",
    discountLabel: "优惠",
    subtotalLabel: "合计",
    bsReference: "Bs. 参考",
    paymentMethodLabel: "支付方式",
    thankYou: "感谢您的惠顾",
    pmCash: "现金",
    pmCard: "刷卡",
    pmTransfer: "转账",
    pmMixed: "混合",
    // CreditPage
    creditManage: "赊账管理",
    newCredit: "新增赊账",
    totalCreditAmount: "总赊账金额",
    creditRecovered: "已收回",
    creditOutstanding: "未收回",
    creditPendingCount: "待收笔数",
    debtRanking: "欠款排行",
    creditCount: "笔",
    searchCustomerName: "搜索客户名...",
    creditStatusPending: "未还",
    creditStatusPartial: "部分还款",
    creditStatusPaid: "已结清",
    creditCustomer: "客户",
    creditAmount: "赊账金额",
    creditPaid: "已还",
    creditBalance: "余额",
    creditDate: "日期",
    creditStatus: "状态",
    creditAction: "操作",
    repayment: "还款",
    repaymentRecord: "还款记录：",
    noCreditRecord: "暂无赊账记录",
    selectCustomerRequired: "请选择客户",
    enterAmount: "请输入金额",
    creditAdded: "赊账记录已添加",
    enterRepayAmount: "请输入还款金额",
    repaySuccess: "还款成功",
    repayAmount: "还款金额",
    repayMethod: "支付方式",
    remarkLabel: "备注",
    remarkPlaceholder: "选填...",
    monthlyGoods: "月份货款...",
    selectedLabel: "已选",
    // Dashboard
    importDemoData: "导入演示数据",
    demoDataImported: "演示数据已导入",
    copyCatalogLink: "复制目录链接",
    catalogLinkCopied: "商品目录链接已复制",
    // ProductsPage
    extraBarcodes: "额外条码",
    importProductsLabel: "导入商品",
    deptIdAsRate: "分类ID当汇率",
    deptIdAsRateDesc: "将Excel中\"货品部门ID\"列的数字作为汇率，自动将Bs价格转换为$价格（$=Bs÷汇率）",
    deptImportFormat: "分类导入格式：编码、名称、汇率、排序",
    deptImportExample: "例：C001, 手机壳, 600, 1",
    // SalesPage
    allOrders: "全部单据",
    normalView: "常规视图",
    adminVerify: "管理员验证",
    enterPinToView: "请输入管理PIN码查看全部单据",
    showAllOrders: "显示全部单据",
    pinError: "PIN错误",
    // Refund dialog
    refundAmountLabel: "退款金额",
    refundReasonPlaceholder: "退货原因（选填）",
    enterOrderNumber: "输入订单号搜索",
    refundOnlyManagers: "仅管理员/店长可处理退款",
    refundSearchHint: "或按条件搜索历史订单",
    refundKeywordPlaceholder: "订单号、商品名、客户...",
    refundSearchOrders: "搜索订单",
    refundResultsFound: "条订单",
    refundClickToSelect: "点击选择退货",
    refundSearchTip: "输入订单号直接查找，或按商品名、日期等搜索历史订单",
    back: "返回",
    // Promotions
    promoDiscount: "折扣",
    promoFullReduction: "满减",
    promoBuyGet: "买赠",
    promoFlashSale: "限时特价",
    promoStatusInactive: "已停用",
    promoStatusEnded: "已结束",
    promoStatusPending: "未开始",
    promoStatusActive: "进行中",
    promoEnabled: "已启用",
    promoDisabled: "已停用",
    promoAllActivities: "全部活动",
    promoActiveCount: "进行中",
    promoUpcomingCount: "未开始",
    promoName: "活动名称",
    promoType: "活动类型",
    promoContent: "优惠内容",
    promoScope: "适用范围",
    promoTime: "活动时间",
    promoDiscountTitle: "折扣活动",
    promoDiscountDesc: "对商品按百分比打折。例：全场8折、指定分类9折",
    promoDiscountFieldVal: "折扣值(%)",
    promoDiscountFieldValHint: "输入折扣百分比。例：输入20表示打8折（优惠20%）",
    promoDiscountFieldMin: "最低金额($)",
    promoDiscountFieldMinHint: "订单满多少才能使用。0=无门槛",
    promoDiscountExample: "示例：「全场8折」→ 折扣值=20, 最低金额=0",
    promoFullRedTitle: "满减活动",
    promoFullRedDesc: "消费满指定金额，减免固定金额。例：满$100减$10",
    promoFullRedFieldAmt: "减免金额($)",
    promoFullRedFieldAmtHint: "输入减免的美元金额",
    promoFullRedFieldMin: "满足金额($)",
    promoFullRedFieldMinHint: "消费需达到的最低金额",
    promoFullRedExample: "示例：「满$50减$5」→ 减免金额=5, 满足金额=50",
    promoBuyGetTitle: "买赠活动",
    promoBuyGetDesc: "买指定数量商品，免费赠送。例：买2送1",
    promoBuyQty: "购买数量",
    promoBuyQtyHint: "顾客需购买的数量",
    promoGetQty: "赠送数量",
    promoGetQtyHint: "免费赠送的数量",
    promoBuyGetExample: "示例：「买3送1」→ 购买数量=3, 赠送数量=1",
    promoFlashTitle: "限时特价",
    promoFlashDesc: "指定商品在活动期间以特价销售。必须设置起止日期",
    promoFlashPrice: "特价($)",
    promoFlashPriceHint: "活动期间的特价金额",
    promoFlashMinHint: "不适用，可留0",
    promoFlashExample: "示例：原价$65的蓝牙耳机 → 特价=39.9",
    promoNamePlaceholder: "例：全场8折、满100减10...",
    promoDiscountValLabel: "折扣值 (%)",
    promoPayPercent: "实付",
    promoMinSpendLabel: "最低消费金额 ($)",
    promoMinAmtLabel: "满足金额 ($)",
    promoReductionAmtLabel: "减免金额 ($)",
    promoOrigPriceRef: "原价参考 ($)",
    promoOptionalDisplay: "可选，仅用于显示",
    promoStartDate: "开始日期",
    promoEndDate: "结束日期",
    promoApplyScope: "适用范围",
    promoAllProducts: "全部商品",
    promoByCategory: "指定分类",
    promoByProduct: "指定商品",
    promoSelectCategories: "选择参与活动的分类：",
    promoMinOneCategory: "请至少选择一个分类",
    promoSelectProducts: "选择参与活动的商品：",
    promoSearchProduct: "搜索商品名称或编码",
    promoSelectedProducts: "已选",
    promoProducts: "个商品",
    promoMinOneProduct: "请至少选择一个商品",
    promoDescription: "活动说明（选填）",
    promoDescPlaceholder: "给顾客或员工的补充说明...",
    promoPreview: "活动预览：",
    promoFullDiscountLabel: "全场",
    promoLimitedOffer: "限时特价",
    promoCategories: "个分类",
    enterPromoName: "请输入活动名称",
    setPromoDate: "请设置活动起止日期",
    endBeforeStart: "结束日期不能早于开始日期",
    discountRange: "折扣值应在1-100之间",
    fullRedMinRequired: "满减活动必须设置最低金额",
    enterReductionAmt: "请输入减免金额",
    setFlashPrice: "请设置特价金额",
    editPromotion: "编辑促销活动",
    addPromotionDialog: "添加促销活动",
    fullRedLabel: "满",
    fullRedOff: "减",
    buyLabel: "买",
    getLabel: "送",
    specifiedCats: "指定分类",
    barcode: "条形码",
    specification: "规格/重量",
    specPlaceholder: "例：500g、1L、XL...",
    // Tenant ID
    merchantId: "商家ID",
    currentId: "当前ID",
    merchantIdDesc: "商家ID用于在线目录链接、在线商城等。修改后需重新登录。",
    changeMerchantId: "修改商家ID",
    newId: "新ID",
    merchantIdRule: "4-20个字符，只能包含小写字母、数字、横线、下划线",
    changeIdWarning: "修改后需要重新登录。在线商城和目录链接也会随之更改。",
    merchantIdPlaceholder: "例：my-shop-001",
    // B2B / Franchise HQ
    b2bPortal: "B2B批发门户", franchiseHQ: "连锁总部", franchiseOverview: "连锁总览",
    crossStoreInventory: "跨店库存", pushPrices: "统一调价", topProducts: "热销排行",
    b2bCustomers: "批发客户", creditLimit: "授信额度", paymentTerms: "账期",
    outstanding: "欠款", customerType: "客户类型", discountRate: "折扣率",
    retailCustomer: "零售客户", wholesaleCustomer: "批发客户", vipCustomer: "VIP客户",
    totalStores: "门店总数", todaySalesAll: "今日总销售", weekSalesAll: "本周总销售",
    monthSalesAll: "本月总销售", storePerformance: "门店业绩", storeName: "门店名称",
    storeAddress: "门店地址", noStoresYet: "暂无门店数据",
    pushPriceSuccess: "统一调价成功", selectProductsFirst: "请先选择商品",
    batchPriceUpdate: "批量调价", retailPrice: "零售价", wholesalePrice: "批发价",
    applyPriceChanges: "应用价格变更", priceUpdated: "价格已更新",
    allWarehouses: "所有仓库", totalQuantity: "总库存", headquarters: "总部",
    // Smart Restock
    smartRestock: "智能补货", restockSuggestions: "补货建议", salesVelocity: "销售速度",
    dailyAvgSales: "日均销量", weeklyAvgSales: "周均销量", daysUntilStockout: "预计断货天数",
    suggestedQty: "建议补货量", suggestedCost: "建议补货金额", urgencyLevel: "紧急程度",
    urgencyCritical: "断货", urgencyUrgent: "紧急", urgencyWarning: "预警", urgencyLow: "偏低", urgencyIncoming: "在途",
    urgencyOk: "正常", analysisPeriod: "分析周期", days30: "近30天", days60: "近60天", days90: "近90天",
    totalRestockCost: "总补货金额", restockItems: "需补货商品",
    salesTrend: "销售趋势", trendUp: "上升", trendDown: "下降", trendFlat: "持平",
    speedFast: "快销", speedMedium: "中速", speedSlow: "慢销", speedDead: "滞销",
    generatePO: "生成采购单", exportRestockList: "导出补货清单",
    currentStock: "当前库存", minStockLevel: "最低库存",
    periodSold: "期间销量",
    importToCategory: "导入到分类", importSelectCategory: "选择导入分类", importCategoryHint: "选择后所有导入商品将归入该分类，不选则使用文件中的分类", noCategoryAssign: "不指定（使用文件中的分类）",
    importFieldSelect: "选择导入字段", importFieldHint: "基本信息（编号、名称、规格）始终导入", allCategories: "全部分类",
    storeManagerPanel: "店长面板", dailySummary: "今日营业", viewInventory: "查看库存",
    printDailySummary: "打印营业汇总", viewOrderDetail: "查看订单明细",
    transferManagement: "调货管理", newTransferOrder: "新建调货单", transferOrderNo: "调货单号",
    fromWarehouse: "发出仓库", toWarehouse: "接收仓库", totalQuantity: "总数量",
    pendingReceive: "待收货", transferReceived: "已签收", receiveTransfer: "签收调货单",
    sentQuantity: "调出数量", receivedQuantity: "实收数量", confirmReceive: "确认签收",
    receiveSuccess: "签收成功", createAndPrint: "创建并打印", selectWarehouse: "选择仓库",
    addProducts: "添加商品", searchProduct: "搜索商品...",

    accountNumber: "账号",
    accountsPayable: "应付账款",
    action: "操作",
    activeCombos: "活跃套餐",
    actual: "实际",
    actualQty: "实际数量",
    add: "添加",
    addCustomer: "添加客户",
    addExpense: "添加支出",
    addGroup: "添加分组",
    addNote: "添加备注",
    addPayable: "添加应付",
    addPaymentMethod: "添加支付方式",
    addPromotion: "添加促销",
    addReceivable: "添加应收",
    addStore: "添加门店",
    addSuccess: "添加成功",
    addSupplier: "添加供应商",
    addWarehouse: "添加仓库",
    address: "地址",
    adminManual: "管理员手册",
    all: "全部",
    allCategories: "全部分类",
    allReasons: "全部原因",
    amount: "金额",
    amountRequired: "请输入金额",
    analysisPeriod: "分析周期",
    approve: "批准",
    associatedWarehouse: "关联仓库",
    availableQty: "可用数量",
    avgComboValue: "平均套餐金额",
    avgOrder: "平均订单",
    backupDesc: "备份说明",
    balance: "余额",
    batchDelete: "批量删除",
    bundleName: "套餐名称",
    bundlePrice: "套餐价格",
    businessType: "业务类型",
    cancel: "取消",
    cancelOrder: "取消订单",
    cancelled: "已取消",
    card: "刷卡",
    cash: "现金",
    casheaAmount: "Cashea金额",
    casheaDesc: "Cashea分期",
    casheaLiveMode: "Cashea正式模式 - 已连接",
    casheaSettingsDesc: "先买后付 - 免息分期",
    category: "分类",
    categoryManagement: "分类管理",
    categoryRates: "分类汇率",
    change: "找零",
    checkoutTitle: "结算",
    clearNote: "清除备注",
    cleared: "已清除",
    clockIn: "上班打卡",
    clockOut: "下班打卡",
    close: "关闭",
    closeAllBrowserFirst: "请先关闭所有浏览器窗口",
    code: "编号",
    comboOrders: "套餐订单",
    comboRevenue: "套餐收入",
    comboSalesDistribution: "套餐销售分布",
    commissionReport: "佣金报表",
    commissionRules: "佣金规则",
    companyAddress: "公司地址",
    companyPhone: "公司电话",
    completed: "已完成",
    completedStatus: "已完成",
    confirm: "确认",
    confirmClearPending: "确认清除待处理订单？",
    confirmDelete: "确认删除",
    confirmPayment: "确认付款",
    confirmReceive: "确认收货",
    confirmStockLoss: "确认损耗",
    connectionPort: "连接端口",
    cost: "成本",
    costLoss: "损耗金额",
    costPrice: "成本价",
    couponCode: "优惠码",
    createAndPrint: "创建并打印",
    createSuccess: "创建成功",
    createTime: "创建时间",
    createWholesaleOrder: "创建批发订单",
    creditLimit: "信用额度",
    creditor: "债权人",
    currency: "货币",
    customerName: "客户名称",
    customerType: "客户类型",
    dailySummary: "每日汇总",
    date: "日期",
    dateTo: "至",
    days30: "30天",
    days60: "60天",
    days90: "90天",
    daysUntilStockout: "预计断货天数",
    defaultOption: "默认选项",
    defaultWarehouse: "默认仓库",
    delete: "删除",
    deleteEmployeeConfirm: "确认删除该员工？",
    deleteFailed: "删除失败",
    deleteImage: "删除图片",
    deleteSelected: "删除选中",
    description: "描述",
    directPrintFailed: "直接打印失败",
    discountAboveCostDesc: "折扣后价格低于成本价",
    downloadShortcut: "下载快捷方式",
    downloadTemplate: "下载模板",
    edit: "编辑",
    editEmployee: "编辑员工",
    editProduct: "编辑商品",
    email: "邮箱",
    employees: "员工",
    enableCashDrawer: "启用钱箱",
    endShift: "结束班次",
    enterOrderNote: "输入订单备注",
    enterPos: "进入收银",
    estimatedCommission: "预估佣金",
    example: "示例",
    excellentTier: "卓越等级",
    exchangeRates: "汇率管理",
    expenseByStore: "各门店支出",
    expenseCount: "支出笔数",
    expenseDesc: "支出描述",
    expenseDescPlaceholder: "请输入支出说明",
    expenseManagement: "支出管理",
    export: "导出",
    exportBackup: "导出备份",
    exportInventoryReport: "导出库存报表",
    exportRestockList: "导出补货清单",
    extraHot: "加辣",
    failed: "失败",
    fillCompleteInfo: "请填写完整信息",
    fiscalPrinter: "税务打印机",
    franchiseHQ: "总部",
    franchiseOverview: "加盟概览",
    generateReport: "生成报表",
    gold: "金牌",
    grossProfit: "毛利润",
    groupName: "组名称",
    headquarters: "总部",
    holdOrder: "挂单",
    hours: "小时",
    html2canvas: "html2canvas",
    idNumber: "证件号",
    iframe: "iframe",
    importCategoryHint: "导入到指定分类",
    importFieldHint: "选择导入字段",
    importResult: "导入结果",
    importSelectCategory: "选择导入分类",
    importSuccess: "导入成功",
    inventoryList: "库存列表",
    inventoryQty: "库存数量",
    invoiceFooter: "发票页脚",
    itemCount: "商品数",
    itemNote: "商品备注",
    items: "件",
    jspdf: "jspdf",
    labelModeP1: "价格1(零售)",
    labelModeP1P3: "价格1+价格3",
    labelModeP1W: "价格1+整箱价格",
    labelModeP3: "价格3(批发)",
    labelModeUsdP1: "外币价格1(零售)",
    labelModeWholesale: "整箱价格(批发)",
    labelNoDecimals: "不含小数",
    labelShowBarcode: "显示条码",
    labelShowForeign: "显示外币($)",
    labelShowBs: "显示 Bs 价",    labelPaperSize: "标签纸",
    labelSize80mm: "80mm 热敏",
    labelSize50x30: "50x30mm 标签",
    labelBilingual: "双语(ES+CN)",
    last30Days: "最近30天",
    last7Days: "最近7天",
    lessIce: "少冰",
    loadFailed: "加载失败",
    loading: "加载中...",
    loginExpired: "登录已过期，请重新登录",
    login: "登录",
    logout: "退出登录",
    loyaltyTierBenefits: "等级权益",
    mainWarehouse: "主仓库",
    margin: "利润率",
    markDelivered: "标记已送达",
    maxDiscount: "最大折扣",
    memberCodePlaceholder: "输入会员码",
    memberGold: "金牌会员",
    memberLimitReached: "会员数已达上限",
    memberMallTab: "积分商城",
    memberMaxLevel: "最高等级",
    memberNeedSpend: "还需消费",
    memberNotFound: "未找到会员",
    memberOrdersTab: "消费记录",
    memberPointsRedeem: "积分兑换",
    memberRedeemBtn: "兑换",
    memberRedeemFail: "兑换失败",
    memberSearchFailed: "搜索失败",
    memberSilver: "银牌会员",
    memberSoldOut: "已售罄",
    memberTimedNotStarted: "活动未开始",
    memberTrialDays: "试用天数",
    memberVip: "VIP会员",
    minSpent: "最低消费",
    minStockLevel: "最低库存",
    mixed: "混合",
    mobilePay: "移动支付",
    monthly: "月度",
    newStockLoss: "新建损耗",
    newTransferOrder: "新建调拨单",
    noCategoryAssign: "未分配分类",
    noComboSalesYet: "暂无套餐销售",
    noCustomerNoPoints: "无客户无积分",
    noData: "暂无数据",
    noOnion: "不要洋葱",
    noOptGroups: "无可选组",
    noShift: "未开班",
    noStoresYet: "暂无门店",
    note: "备注",
    notifications: "通知",
    offline: "离线",
    offlineCacheMode: "离线缓存模式",
    offlineMode: "离线模式",
    onlineOrderTotal: "在线订单总额",
    onlineStore: "在线商店",
    operator: "操作员",
    optionStats: "选项统计",
    optionalGroups: "可选组",
    options: "选项",
    orderComplete: "订单完成",
    orderCount: "订单数",
    orderDetail: "订单详情",
    orderNo: "订单号",
    orderNote: "订单备注",
    orderNotes: "订单备注",
    originalPrice: "原价",
    overallMargin: "总体利润率",
    overwriteDuplicate: "覆盖重复",
    paidAmount: "已付金额",
    paperSize: "纸张尺寸",
    password: "密码",
    payable: "应付",
    paymentAmount: "付款金额",
    paymentInfo: "支付信息",
    pending: "待处理",
    pendingOrdersNotif: "待处理订单通知",
    pendingStatus: "待处理",
    phone: "电话",
    pieces: "个",
    plan_enterprise: "企业版",
    plan_pro: "专业版",
    points: "积分",
    pointsAvailable: "可用积分",
    pointsEarned: "获得积分",
    pointsHistory: "积分历史",
    pointsMultiplier: "积分倍率",
    pointsRate: "积分比率",
    posLogin: "前台收银",
    posLoginHint: "收银员登录",
    posMode: "收银模式",
    posReceiptPrinter: "POS小票打印机",
    present: "当前",
    price: "价格",
    price2: "价格2",
    price3Box: "价格3/整箱",
    priceSettings: "价格设置",
    priceType: "价格类型",
    pricing: "定价",
    printFormat: "打印格式",
    printInvoiceA4: "打印A4发票",
    printItemCode: "打印商品编号",
    printMethod: "打印方式",
    printOrder: "打印订单",
    printReceipt: "打印小票",
    printSuccess: "打印成功",
    printTime: "打印时间",
    printerConnectFailed: "打印机连接失败",
    printerConnected: "打印机已连接",
    printerGuide: "打印机指南",
    printerModel: "打印机型号",
    printerReady: "打印机就绪",
    printing: "打印中...",
    processing: "处理中...",
    product: "商品",
    productName: "商品名称",
    profit: "利润",
    progress: "进度",
    providedByAdmin: "由管理员提供",
    pushPrices: "推送价格",
    qty: "数量",
    quantity: "数量",
    quarterly: "季度",
    quickActions: "快捷操作",
    ratesUpdated: "汇率已更新",
    recallOrder: "取单",
    receiptCopies: "小票副本数",
    receiptDetail: "小票详情",
    receiveTransfer: "接收调拨",
    receivedQuantity: "接收数量",
    receivedStatus: "已接收",
    recordPayment: "记录付款",
    recording: "录制中",
    records: "记录",
    redeemPoints: "兑换积分",
    ref: "参考",
    refundReason: "退款原因",
    remaining: "剩余",
    remainingAmount: "剩余金额",
    reportPrinter: "报表打印机",
    reports: "报表",
    reprintReceipt: "重印小票",
    restockItems: "补货商品",
    restockSuggestions: "补货建议",
    restoreBackup: "恢复备份",
    restoreWarning: "恢复备份将覆盖当前数据",
    retailPrice: "零售价",
    returnReason: "退货原因",
    revenue: "收入",
    rightClickClear: "右键清除",
    salesExchangeRateDesc: "销售汇率说明",
    salesManagement: "销售管理",
    salesOrder: "销售订单",
    salesRateDesc: "销售汇率说明",
    salesVelocity: "销售速度",
    saveRates: "保存汇率",
    saveSettings: "保存设置",
    scale: "电子秤",
    scanOrSearch: "扫码或搜索",
    scannerEnabled: "扫码器已启用",
    searchProducts: "搜索商品",
    selectAll: "全选",
    selectCustomer: "选择客户",
    selectImage: "选择图片",
    selectProduct: "选择商品",
    selectProductsFirst: "请先选择商品",
    selectStore: "选择门店",
    selectedCount: "已选",
    setDefaultPrinter: "设为默认打印机",
    settingsSaved: "设置已保存",
    shipped: "已发货",
    shopDescPlaceholder: "例如: 新鲜蔬果 每日直送",
    shopDescription: "商店描述",
    shopPreview: "商店预览",
    skip: "跳过",
    skipDuplicate: "跳过重复",
    skipped: "已跳过",
    soldQuantity: "已售数量",
    staleDataInfo: "数据可能已过期",
    staleDataWarning: "数据过期警告",
    standardTier: "标准等级",
    startImport: "开始导入",
    status: "状态",
    statusCancelled: "已取消",
    statusCompleted: "已完成",
    statusPending: "待处理",
    stockAlerts: "库存预警",
    stockLossCostEstimate: "损耗成本估算",
    stockLossManagement: "损耗管理",
    stockLossQty: "损耗数量",
    stockLossReason: "损耗原因",
    stockLossSuccess: "损耗记录成功",
    stockLow: "库存不足",
    stockTaking: "盘点",
    stopRecording: "停止录制",
    storeFilter: "门店筛选",
    storeManagement: "门店管理",
    storeName: "门店名称",
    storePerformance: "门店绩效",
    stores: "门店",
    suggestedCost: "建议成本",
    supplierManagement: "供应商管理",
    supplierName: "供应商名称",
    syncPending: "同步待处理",
    systemQty: "系统数量",
    takeaway: "外带",
    targetAmount: "目标金额",
    targetType: "目标类型",
    taxId: "税号/RIF",
    tenantIdLabel: "租户ID",
    tenantLogin: "商家登录",
    testPrint: "测试打印",
    themeBakery: "面包店",
    themeButcher: "肉铺",
    themeClothing: "服装店",
    themeCustom: "自定义",
    themeDepartment: "百货",
    themeElectronics: "电子产品",
    themeGeneral: "通用",
    themePharmacy: "药店",
    themeRestaurant: "餐厅",
    tier: "等级",
    time: "时间",
    toWarehouse: "目标仓库",
    todaySalesAll: "今日总销售",
    topProducts: "热销商品",
    topupBalance: "充值余额",
    total: "合计",
    totalExpenses: "总支出",
    totalLossQty: "总损耗数量",
    totalLossRecords: "损耗记录总数",
    totalOrders: "总订单",
    totalProducts: "总商品数",
    totalProfit: "总利润",
    totalQuantity: "总数量",
    totalRevenue: "总收入",
    totalSales: "总销售额",
    totalSpent: "总消费",
    transferOrderNo: "调拨单号",
    trendFlat: "持平",
    type: "类型",
    updateSuccess: "更新成功",
    updated: "已更新",
    uploadSuccess: "上传成功",
    urgencyLevel: "紧急程度",
    urgencyLow: "低",
    urgencyUrgent: "紧急",
    urgencyWarning: "警告",
    urgent: "紧急",
    userManual: "用户手册",
    vidDefaultTitle: "教程视频",
    vidDeleteFail: "删除视频失败",
    vidDeleted: "视频已删除",
    vidRecFail: "录制失败",
    vidUpdateFail: "更新视频失败",
    vidUploadFail: "上传视频失败",
    vidUploading: "上传中...",
    vidVideoTitle: "视频标题",
    videoTutorials: "视频教程",
    viewInventory: "查看库存",
    viewOrderDetail: "查看订单详情",
    vip: "VIP",
    vipCustomer: "VIP客户",
    warehouse: "仓库",
    warehouseManagement: "仓库管理",
    warehouseName: "仓库名称",
    weekSalesAll: "本周总销售",
    weeklyAvgSales: "周均销售",
    wholesaleDiscount: "批发折扣",
    wholesaleMinQty: "批发最低数量",
    wholesaleOrder: "批发订单",
    cashBalance: "现金余额",
    cashUsd: "美元现金",
    cashVes: "Bs现金",
    cashTransaction: "现金操作",
    cashDeposit: "存入",
    cashWithdraw: "取出",
    cashHandover: "上交",
    cashAdjustment: "调整",
    recentRecords: "最近记录",
    employeeAccounts: "员工账务",
    employee: "员工",
    newEmpTransaction: "新增员工账务",
    selectEmployee: "选择员工",
    loanToEmployee: "借款给员工",
    goodsCreditToEmployee: "赊货给员工",
    employeeRepayment: "员工还款",
    salaryDeduction: "工资扣除",
    transactionHistory: "交易记录",
    productInfo: "商品信息",
    productInfoPlaceholder: "赊货商品详情...",
    noEmployeeDebt: "暂无员工欠款记录",
    notePlaceholder: "备注...",
    owes: "欠款",
    loans: "借款",
    goodsCredit: "赊货",
    repaid: "已还",
    sale: "销售",
    exchange: "兑换",
    addEmployee: "添加员工",
    idCard: "身份证号",
    employeeStatement: "员工对账单",
    currentBalance: "当前欠款",
    orderNoLookup: "输入订单号自动查询",
    date: "日期",
    staff: "员工",
    cashier: "收银员",
    byCashier: "按收银员统计",
    filterByCashier: "筛选收银员",
    reconciliation: "对账",
    totalReceived: "总收款",
    printFiscal: "打印发票",
    printReceipt80mm: "80mm小票",
    searchByOrderNo: "搜索订单号",
    verifyPayment: "验证付款",
    paymentVerification: "Pago Móvil 验证",
    fixedQRTip: "固定二维码 — 可打印贴在收银台",
    autoRefresh: "自动刷新",
    recentUploads: "最近上传",
    waitingCustomerUpload: "等待顾客扫码上传...",
    noRef: "无参考号",
    matched: "已匹配",
    storeManager: "店长",
    employeeCredit: "员工赊账",
    printTime: "打印时间",
    paySalary: "发工资",
    grossSalary: "工资总额",
    deductFromSalary: "从工资扣除欠款",
    netPay: "实发",
    deductMax: "最大抵扣",
    noDeduct: "不抵扣 (全发现金)",
    repayByBs: "按 Bs 还款 →",
    repayByBsHint: "员工用 Bs 还款 → 自动换算 USD 抵扣欠款",
    rateManagerCustom: "店长: 自填汇率",
    rateStaffBcv: "员工: BCV 汇率",
    balance: "余额",
    employeeReceivables: "员工应收款",
    employeeReceivablesNote: "待收回",
    totalOwed: "总欠款",
    absencePenalty: "旷工罚款",
    creditLimit: "信用额度",
    creditLimitWarning: "超过信用额度!",
    currentOwed: "当前欠款",
    afterTxn: "操作后",
    overBy: "超出",
    todayAttendance: "今日考勤",
    clockIn: "上班",
    clockOut: "下班",
    onDuty: "上班中",
    offDuty: "已下班",
    notClockedIn: "未打卡",
    fullDay: "全天",
    halfDay: "半天",
    absent: "旷工",
    dailyRate: "日薪",
    fullDays: "全天",
    halfDays: "半天",
    absentDays: "旷工",
    currentDebt: "欠款",
    salaryCalcMode: "计算模式",
    autoCalc: "自动",
    manualInput: "手动",
    autoAdjustable: "自动可调",
    salaryAmount: "工资金额",
    payCycle: "发薪周期",
    weekly: "每周",
    biweekly: "每15天",
    monthly: "每月",
    siteMonitor: "站点监控",
    monitorCheckNow: "立即检查",
    monitorCurrentStatus: "当前状态",
    monitorUptime24h: "24小时可用率",
    monitorTotalChecks: "检查次数",
    monitorAlertConfig: "告警配置",
    monitorAlertEmail: "告警邮箱",
    monitorEmailRequired: "请输入告警邮箱",
    monitorKeyRequired: "请输入 Resend API Key",
    monitorSettingsSaved: "监控设置已保存",
    monitorConfigured: "已配置",
    monitorResendHelp: "在以下网站免费获取 API Key:",
    monitorResendHelp2: "即可接收宕机告警邮件。",
    monitorSendTest: "发送测试告警",
    monitorRecentLogs: "最近检查记录",
    monitorNoLogs: "暂无检查记录，系统每5分钟自动检查一次。",
    storeReceiptInfo: "发票/小票信息",
    storeReceiptInfoHint: "设置后，该门店打印小票将使用以下信息替代公司默认设置。",
    storeReceiptName: "发票抬头（店名）",
    storeReceiptNamePlaceholder: "例：ALFONZO SHOP C.A.",
    storeReceiptAddress: "发票地址1",
    storeReceiptAddress2: "发票地址2",
    storeReceiptPhone: "发票电话",
    inventoryDownloadTemplate: "下载模板",
    inventoryImport: "导入库存",
    inventoryTemplateDownloaded: "库存模板已下载",
    inventoryImportSuccess: "库存导入完成",
    importing: "导入中...",
    created: "新增",
    updated: "更新",
    skipped: "跳过",
    allStores: "全部门店",
    allowedHours: "允许登录时间（留空=不限制）",
    allowedHoursHint: "委内瑞拉时间 (UTC-4)。例: 07:00 ~ 22:00",
    allowedIPs: "IP白名单（留空=不限制）",
    allowedIPsHint: "多个IP用逗号隔开。管理员和经理不受此限制。",
    attendanceHistory: "打卡记录",
    avgPerOrder: "平均单价",
    bsCashGiven: "客户给美元 ($)",
    bsCost: "Bs成本",
    bsValue: "Bs金额",
    buyRate: "买入价",
    byCurrency: "按币种",
    byPaymentMethod: "按支付方式",
    cashGiven: "收到现金",
    categoryBreakdown: "分类明细",
    categoryName: "分类名称",
    clockedIn: "已打卡",
    costUsd: "成本 (USD)",
    dailyBreakdown: "每日明细",
    days: "天",
    downloadFailed: "下载失败",
    exchangeRate: "汇率",
    expenses: "支出",
    expenseFood: "餐饮",
    expenseSalary: "工资",
    expenseSupplies: "耗材",
    expenseTax: "税费",
    expenseTransport: "交通",
    expenseUtilities: "水电",
    expired: "已过期",
    lastDays: "最近天数",
    lastMonth: "上月",
    loadingData: "正在连接服务器并加载数据",
    lossBreakdown: "损耗明细",
    mixedPayment: "混合收款",
    netProfit: "净利润",
    nextPage: "下一页",
    noSearchResult: "未找到结果",
    prevPage: "上一页",
    print: "打印",
    profitUsd: "利润 (USD)",
    rateLabel: "汇率",
    sales: "销售",
    salesBs: "销售额 (Bs)",
    schedule: "时间",
    sellRate: "卖出价",
    showing: "显示",
    split: "拆分",
    store: "门店",
    subtotal: "小计",
    thisMonth: "本月",
    todayProfitUsd: "今日利润 (USD)",
    totalDue: "应付金额",
    totalEmployees: "员工总数",
    unassignedStore: "未分配门店",
    usdCashGiven: "客户给美元 ($)",
    usdEquivalent: "USD等值",
    selectedRate: "选定汇率",
    sample: "示例",
    other: "其他",
    personalUse: "自用",
    blackMarket: "黑市",
    blackMarketGoods: "黑市商品",
    buyUsdCash: "买入美元现金",
    cardToCash: "刷卡换现",
    cashMustBeLess: "现金不能超过总额",
    commissionPct: "佣金比例",
    installApp: "安装应用",
    installAppHint: "用Chrome浏览器打开可安装为App",
    // AI Feature
    aiFeatures: "AI智能功能",
    aiEnabled: "AI已开启",
    aiDisabled: "AI未开启",
    aiToggle: "AI开关",
    aiSubscriptionFee: "AI月费",
    aiFeatureNote: "AI功能需额外付费",
    aiRegDisclaimer: "AI智能功能（智能客服、支付凭证识别等）需额外订阅，不包含在基础套餐中。",
    aiCostPerMsg: "每条消息",
    aiCostPerImg: "每张图片识别",
    aiMonthlyFee: "AI月费($)",
    aiToggleOn: "开启AI",
    aiToggleOff: "关闭AI",
    // Auth Scan
    authRequired: "需要授权",
    authAction: "操作",
    authScanHint: "请让店长/管理员扫描授权二维码",
    authScanPlaceholder: "扫码或输入授权码...",
    verify: "验证",
    verifying: "验证中...",
    authSuccess: "授权成功",
    authFailed: "授权失败",
    authorizer: "授权人",
    authCodeGenerate: "生成授权码",
    authCodeRegenerate: "重新生成",
    authCodePrint: "打印二维码",
    noAuthCode: "未生成授权码",
    authCodeGenerated: "授权码已生成",
    priceSwitchNeedAuth: "切换价格等级需要店长授权",
    refundNeedAuth: "退货需要店长授权",
    onlyManagerCanSwitch: "仅店长/管理员可切换价格",
    boxModeNoStock: "库存不足一整箱",
    // Payment methods
    totalDue: "应付金额",
    totalPaid: "合计支付",
    remaining: "还差",
    // Credit overdue
    creditOverdue: "已逾期",
    creditDueSoon: "即将到期",
    creditDueDate: "到期日",
    creditAlerts: "赊账到期提醒",
    creditOverdaysDays: "逾期",
    creditDueSoonDays: "剩余",
    days: "天",
    noOverdueCredits: "暂无到期/逾期赊账",
    // Price check
    priceCheck: "查价",
    priceCheckSearch: "输入商品名/条码...",
    canViewPrices: "查看价格权限",
    // Wholesale order
    wholesaleOrder: "批发开单",
    selectCustomer: "选择客户",
    addCustomer: "添加客户",
    addProductsFirst: "搜索商品并添加到订单",
    orderSummary: "订单汇总",
    confirmOrder: "确认开单",
    orderCreated: "开单成功",
    orderNotes: "备注",
    creditLimit: "信用额度",
    creditLimitExceeded: "超出信用额度",
    amountWarning: "金额异常",
    largeAmountHint: "收到金额远超订单总额，请确认是否正确。",
    correctAmount: "修改金额",
    confirmCorrect: "确认无误",
    salesContacts: "卖手/联系人",
    addContact: "添加",
    noContacts: "暂无卖手",
    contactName: "姓名",
    contactPhone: "电话",
    editSupplier: "编辑供应商",
    printReceipt: "打印凭条",
    refundSuccess: "退货成功",
    salesperson: "卖手",
    selectSalesperson: "选择卖手",
    salespersonName: "卖手姓名（可选）",
    noSalesperson: "未指定卖手",
    filterBy: "筛选",
    clearFilter: "取消筛选",
    voidOrder: "作废订单",
    voided: "已作废",
    voidReason: "作废原因",
    voidReasonPlaceholder: "例如: 金额输错, 重复下单...",
    voidWarning: "作废后将退回库存，此操作不可撤销。",
    confirmVoid: "确认作废",
    voidSuccess: "已作废",
    // === HQ Monitor Center (StoreOverviewPage) ===
    hqTitle: "总部监控中心",
    hqAutoRefresh: "自动刷新60s",
    hqRefresh: "刷新",
    hqLoading: "加载中...",
    hqNoData: "无数据",
    hqLoadFailed: "加载失败",
    hqAiAnalysisFailed: "AI分析失败",
    hqTotalSales: "总销售额",
    hqToday: "今日",
    hqEmployeeDebt: "员工欠款",
    hqOnDutyCount: "在岗人数",
    hqActiveShifts: "活跃班次",
    hqStockWarning: "库存预警",
    hqLowStockItems: "库存不足商品",
    hqAiAssistant: "AI助手",
    hqStoreMonitor: "分店监控",
    hqEmployeeStatus: "员工状态",
    hqShiftHandover: "班次交接",
    hqSalesDetail: "销售明细",
    hqAlerts: "预警",
    hqCashFlow: "资金出入",
    hqAiHqAssistant: "AI 总部助手",
    hqAnalyzing: "分析中...",
    hqReAnalyze: "重新分析",
    hqStartAnalysis: "开始分析",
    hqAiClickToAnalyze: "点击\"开始分析\"让AI帮你分析所有分店数据",
    hqAiWillCheck: "AI将自动检查销售趋势、库存缺货、员工问题并给出建议",
    hqAiAnalyzingData: "AI正在分析所有分店数据...",
    hqAiAnalyzingIncludes: "包括销售对比、库存检查、员工欠款、班次差异等",
    hqViewRawData: "查看原始数据摘要",
    hqOperating: "营业中",
    hqOrders: "单",
    hqCurrentOnDuty: "当前在岗",
    hqSince: "从",
    hqCashBalanceUsd: "现金余额 USD",
    hqCashBalanceBs: "现金余额 Bs",
    hqTransactionCount: "交易笔数",
    hqProductLowStock: "商品库存不足",
    hqCollapseDetails: "收起详情",
    hqExpandDetails: "展开详情",
    hqUsdIn: "USD入",
    hqUsdOut: "USD出",
    hqBsIn: "Bs入",
    hqBsOut: "Bs出",
    hqTodayPayments: "今日各支付",
    hqStoreStaff: "店员",
    hqOnDuty: "在岗",
    hqOwes: "欠",
    hqOffline: "离线",
    hqBranch: "分店",
    hqClockIn: "打卡",
    hqIdCard: "身份证",
    hqPhone: "电话",
    hqLoans: "借款",
    hqGoodsCredit: "赊货",
    hqRepaid: "已还",
    hqDebt: "欠款",
    hqSalaryPaid: "已发工资",
    hqCurrentActiveShifts: "当前活跃班次",
    hqRecentShiftRecords: "最近班次交接记录",
    hqNoShiftRecords: "暂无交接记录",
    hqManager: "经理",
    hqDiscrepancy: "差异",
    hqAllStoresSalesSummary: "全部分店销售汇总",
    hqRefund: "退款",
    hqTodayDetails: "今日明细",
    hqLowStockWarning: "库存不足预警",
    hqAllStockOk: "所有商品库存充足",
    hqStock: "库存",
    hqOutOfStock: "缺货",
    hqHeadquarters: "总部",
    hqBorrow: "借",
    hqCreditShort: "赊",
    hqRepaidShort: "还",
    hqShiftDiscrepancyWarning: "班次差异预警",
    hqCrossStoreTransfer: "跨店调货建议",
    hqTransferSuggestionDesc: "以下商品在某店缺货，但其他店有库存，建议调货",
    hqStockIsZero: "库存为0",
    hqTransfer: "转账",
    hqTime: "时间",
    hqType: "类型",
    hqDirection: "方向",
    hqIn: "入",
    hqOut: "出",
    hqHas: "有",
    hqUnits: "个",
    hqPaymentWay: "支付方式",
    hqTransferNoCash: "转账不影响店现金余额",
    hqHolidayCalendar: "节日日历",
    hqHolidayTip: "点击日期标记/取消节日，节日上班算1.5倍工资 (LOTTT法)",
    hqHolidaysThisMonth: "本月节日",
    hqHolidaySet: "已设为节日 (1.5倍工资)",
    hqHolidayRemoved: "已取消节日",
    hqPrefillHolidays: "预填2026法定节日",
    hqHolidaysPrefilled: "已预填法定节日",
    hqNew: "个新增",
    price3: "价格3",
    boxPrice: "整箱",
    shopQRPoster: "网店推广二维码",
    shopQRPosterDesc: "生成精美海报，打印后张贴在店铺吸引客户扫码下单",
    shopQRUrl: "网店链接",
    managerAuth: "经理确认",
    managerApproved: "经理已确认",
    managerAuthRequired: "需要经理确认才能结束班次",
    actualCashCount: "实际清点金额",
    cashReconciliation: "清点对比",
    shiftNotes: "备注（如有差异请说明原因）",
    expected: "应收",
    actual: "实际",
    pendingShiftFound: "发现未完成的班次，请先交班",
    shiftEndAuthHint: "交接班需要经理扫码或输入密码确认",
    passwordAuth: "密码验证",
    scanCode: "扫码验证",
    authorize: "确认授权",
    clearInventory: "清空库存",
    copyFromMain: "从主仓复制",
    editQty: "修改数量",
    saveQty: "保存",
    onlyWithStock: "仅显示有库存",
    noStock: "无库存",
    action: "操作",
    legacyDebt: "历史欠款导入",
    legacyDebtHint: "只记录欠款金额，不扣现金余额",
    netCash: "净现金",
    currentShift: "当前班次",
    dailySummary: "全天汇总",
    noActiveShift: "没有活跃班次",
    addProductHint: "添加的商品会同步到所有分店，但只有本店有库存",
    initStock: "入库数量",
    overdue: "逾期",
    partial: "部分",
    paymentVerify: "验证付款",
    priceRequired: "请输入零售价",
    productNameRequired: "请输入商品名称",
    quickExchange: "快速换汇",
    quickExchangeDesc: "快速货币转换",
    reconciliation: "对账",
    scanBarcode: "扫码或输入条码后按回车",
    scanOrType: "扫码或手动输入",
    selectCategory: "选择分类",
    totalChange: "找零总额",
    totalReceived: "实收总额",
    goExchange: "去换汇",
    cashReconciliationNote: "对账备注",
    rptTitle: "交班报表",
    rptCashier: "收银员",
    rptStore: "门店",
    rptStart: "开始",
    rptClose: "关闭",
    rptManager: "经理",
    rptRate: "汇率",
    rptSalesByMethod: "各支付方式销售",
    rptCashRecon: "清点对比",
    rptSummary: "总结",
    rptCashUsd: "现金 USD",
    rptCashBs: "现金 Bs",
    rptCard: "刷卡",
    rptTransfer: "转账",
    rptTotalOrders: "总订单",
    rptTotalBs: "Bs合计",
    rptGrandTotal: "销售总额",
    rptNet: "净额",
    rptRefunds: "退款",
    rptExpected: "预期",
    rptActual: "实际",
    rptDiff: "差异",
    rptNote: "备注",
    rptMethod: "方式",
    rptUsdReceived: "收到美元",
    rptBsReceived: "收到Bs",
    // Shop checkout
    chkFillShipping: "请填写完整收货信息",
    chkRefOrProof: "请输入支付参考号或上传付款凭证",
    chkSelectBank: "请选择银行",
    chkOrderPlaced: "订单已提交!",
    chkTransferencia: "银行转账",
    chkPagoMovil: "Pago Movil",
    chkCashea: "Cashea 分期",
    chkCasheaSub: "现在购买,稍后付款",
    chkCredit: "赊账 / Credito",
    chkCredit7or15: "7 或 15 天",
    chkWhatsappPay: "联系商家付款",
    chkConfirmPedido: "确认下单",
    chkSending: "提交中...",
    chkCancel: "取消",
    chkReference: "参考号",
    chkProof: "付款凭证 (照片)",
    chkUploadProof: "上传凭证",

    // ===== Super Admin · Multi-Country & Industry Switch =====
    scTitle: "🌍 全球租户管控",
    scTitleSub: "多国家 / 超级管理员",
    scTotalTenants: "总租户",
    scCountries: "覆盖国家",
    scMonthRevenue: "本月全球营收 (USD)",
    scPluginsLive: "{total} 个插件 · {live} 个已上线",
    scMapTitle: "🗺 全球租户地图",
    scMapHint: "圆圈大小 = 本月营收 (USD 等值)",
    scTenantsUnit: "租户",
    scOrdersUnit: "单",
    scThisMonth: "本月",
    scCurrency: "货币",
    scTimezone: "时区",
    scPluginsTitle: "💳 支付插件库",
    scCountriesLabel: "国家",
    scByCountryTitle: "按国家分组的租户",
    scRefresh: "刷新",
    scThTenant: "租户名",
    scThStatus: "状态",
    scIndustryPlaceholder: "⚡ 切换行业…",
    scIndustryTitle: "切换行业模板",
    scIndustryConfirm: "将该租户切换到「{industry}」?\n会自动补种类目 + 启用行业功能 (餐馆还会建10张桌位)。现有数据不会受影响。",
    scIndustryOk: "✅ {tenant} → {industry} (新增类目 {cats}, 桌位 {tables})",
    scIndustryFail: "切换行业失败",
    scCountryConfirm: "切换租户国家为「{country}」?\n会同步货币 / 时区 / 税率 / 汇率",
    scCountryOk: "已切换 · 新汇率: {fx}",
    scCountryFail: "切换国家失败",
    scFxRefreshed: "汇率已刷新",
    scFxRefreshFail: "刷新失败",
    scLoadFail: "加载失败",

    // ===== Industry templates · 行业模板 =====
    // Sidebar label overrides (industry-aware)
    tplProductsRestaurant: "🍽️ 菜品管理",
    tplProductsFastFood: "🥡 餐品管理",
    tplProductsClothing: "👕 款式管理",
    tplProductsPharmacy: "💊 药品管理",
    tplProductsBeauty: "💅 服务项目",
    tplCategoriesRestaurant: "📋 菜系分类",
    tplCategoriesClothing: "🏷️ 季节分类",
    tplCategoriesBeauty: "🏷️ 服务分类",
    tplSalesRestaurant: "🧾 桌位账单",
    tplSalesBeauty: "🧾 服务账单",
    tplMenuTables: "🍽️ 桌位管理",
    tplMenuKds: "👨‍🍳 厨房大屏",
    tplMenuAppointments: "💅 预约管理",
    tplMenuGiftCards: "🎫 购物券",

    // Dashboard cards (4 new)
    dashRestoTitle: "今日桌位",
    dashRestoRevenue: "堂食总营收",
    dashRestoAvgTicket: "客单",
    dashRestoScanRate: "📱 扫码下单率",
    dashRestoOnlineCount: "单网店",
    dashRestoWalkinCount: "单堂食 POS",
    dashRestoTopTables: "🏆 桌位 TOP 5",
    dashRestoNoData: "今日还没有数据",
    dashRestoPeak: "⏰ 时段订单分布",
    dashRestoUnit: "单",
    dashRestoLoading: "载入餐馆数据中...",

    dashExpiryTitle: "💊 临期 / 过期商品",
    dashExpiryLoading: "载入临期数据中...",
    dashExpiryAllGood: "✅ 全部商品有效期良好",
    dashExpiryAllGoodSub: "未来 30 天内无商品到期",
    dashExpiryExpired: "已过期",
    dashExpiryCritical: "≤ 7 天",
    dashExpiryWarning: "≤ 30 天",
    dashExpiryStock: "库存",
    dashExpiryDays: "天",
    dashExpiryExpiredDays: "过期 {n} 天",
    dashExpiryMore: "+ {n} 更多商品... 请去 /admin/products 处理",

    dashApptsTitle: "💅 今日预约",
    dashApptsLoading: "载入今日预约...",
    dashApptsNone: "今日还没有预约",
    dashApptsGoto: "去添加 →",
    dashApptsScheduled: "待办",
    dashApptsDone: "完成",
    dashApptsNoShow: "未到",
    dashApptsCancelled: "取消",

    dashLoyalTitle: "🔄 忠实客户 · 30天回头 ≥ 2次",
    dashLoyalLoading: "载入中...",
    dashLoyalEmpty: "还没有忠实客户 — 鼓励客户留电话！",
    dashLoyalReturning: "位回头客 · 合计",
    dashLoyalVisits: "次",
    dashLoyalAvg: "客单",

    dashLeaderTitle: "🏆 购物券核销排行 · 30天",
    dashLeaderLoading: "载入中...",
    dashLeaderEmpty: "最近 30 天还没有核销购物券",
    dashLeaderTotal: "张 · 抵扣合计",
    dashLeaderIssue: "张核销",
    dashLeaderTopup: "充值",

    // Appointments page
    apptPageTitle: "💅 预约管理",
    apptPrevWeek: "← 上一周",
    apptThisWeek: "本周",
    apptNextWeek: "下一周 →",
    apptNew: "新预约",
    apptTotal: "共 {n} 个预约",
    apptToday: "今天",
    apptAddSlot: "+ 加预约",
    apptCustomer: "客户姓名",
    apptCustomerPhone: "客户电话",
    apptService: "服务项目",
    apptStaff: "服务人员 (选填)",
    apptStart: "开始时间",
    apptDuration: "时长 (分钟)",
    apptPrice: "价格 ($)",
    apptNote: "备注",
    apptCreate: "创建",
    apptCancel: "取消",
    apptStatusScheduled: "预约",
    apptStatusDone: "完成",
    apptStatusNoShow: "未到",
    apptStatusCancelled: "取消",
    apptCommissions: "员工提成",
    apptServicesDone: "服务次数",
    apptRevenue: "营业额",
    apptCommission: "提成",
    apptToPay: "应付提成",
    apptNoCommissionData: "本月暂无已完成的预约",
    apptCommissionHint: "修改百分比后自动保存，只统计\"已完成\"状态的预约",
    apptMarkDone: "完成",
    apptMarkNoShow: "未到",
    apptMarkCancelled: "取消",
    apptDelete: "删除",
    apptUnassigned: "未指派",
    apptMin: "分钟",
    apptCurrentStatus: "当前状态:",
    apptErrFill: "请填写客户姓名和服务项目",
    apptOk: "✅ 预约已创建",
    apptDelConfirm: "确定删除此预约?",

    // ===== Online shop (顾客端) =====
    shopErrPickTable: "请选择您的桌号",
    shopErrNamePhone: "请填写姓名和电话",
    shopBannerDineIn: "堂食 · {table}",
    shopBannerDineInUnset: "堂食 · 未选桌",
    shopBannerTakeout: "外带",
    shopBannerDelivery: "外送上门",
    shopPickTable: "选桌号",
    shopTablePrefix: "{n}号桌",
    shopChange: "更改",
    shopChkDineInTitle: "{table} · 联系方式",
    shopChkTakeoutTitle: "到店自取",
    shopOrderTypeTitle: "您要怎样点餐？",
    shopOrderTypeDineIn: "🍽️ 堂食",
    shopOrderTypeDineInSub: "在餐馆桌位用餐",
    shopOrderTypeTakeout: "🥡 外带",
    shopOrderTypeTakeoutSub: "到店自取",
    shopOrderTypeDelivery: "🛵 外送上门",
    shopOrderTypeDeliverySub: "我们送到您的地址",
    shopRetailModeTitle: "您要怎样收货？",
    shopRetailPickup: "🏪 到店自取",
    shopRetailPickupSub: "下单后到店取货，免运费",
    shopRetailDeliverySub: "我们送到您的地址",

    // 📦 Lot / batch tracking + FIFO
    lotsMenuLabel: "📦 批次/批号 (FIFO)",
    lotsPageTitle: "📦 批次/批号追踪 (FIFO 出库)",
    lotAdd: "新增批次",
    lotEdit: "编辑批次",
    lotNo: "批号",
    lotNoAutoGen: "留空自动生成",
    lotQtyRemaining: "剩余量",
    lotQtyUsed: "用量",
    lotActive: "活跃批次",
    lotExpired: "已过期",
    lotCritical: "≤ 7 天",
    lotWarning: "≤ 30 天",
    lotOk: "良好",
    lotExpiringSoon: "30 天内到期",
    lotProductsTracked: "追踪商品数",
    lotRecalled: "召回",
    lotRecallConfirm: "确定召回此批次?库存将归零并被禁用。",
    lotTraceability: "召回追溯",
    lotNoSales: "此批次还没有售出记录",
    lotSearchPlaceholder: "搜索商品 / 批号...",
    lotEmpty: "暂无批次。可手动新增,或在采购入库时填写批号/到期日。",
    lotFieldsRequired: "商品、仓库、数量为必填",
    lotCreated: "批次已创建",
    warehouseAll: "全部仓库",
    expiry: "到期日",

    // 🎯 RFM + WhatsApp broadcast
    rfmMenuLabel: "🎯 RFM 分群 + 群发",
    rfmTitle: "🎯 RFM 客户分群 + WhatsApp 一键群发",
    rfmSegment: "分群",
    rfmRecency: "上次",
    rfmFrequency: "次数",
    rfmMonetary: "消费",
    rfmAllSegments: "全部分群",
    rfmSegmentHint: "点击分群快速选择该群所有客户 → 一键预填促销文案",
    rfmSearchPlaceholder: "搜索姓名/电话...",
    rfmEmpty: "时间窗口内无消费客户",
    rfmShowingFirst: "已显示前 500 条 — 缩小筛选可看更多",
    rfmBroadcast: "WhatsApp 群发",
    rfmSelectFirst: "请先选择客户",
    rfmWaNotReady: "WhatsApp Web 未连接 — 请到 [📱 WhatsApp 自动连接] 扫码",
    rfmWaWarning: "WhatsApp Web 未连接,请到 [📱 WhatsApp 自动连接] 扫码后再群发。",
    rfmComposeMessage: "撰写群发消息",
    rfmRecipientCount: "收件人",
    rfmTemplateHint: "提示:使用 {name} 自动插入客户姓名(首名)",
    rfmPlaceholder: "您好 {name}!本周末全场 20% OFF 🎉",
    rfmPreview: "预览(以「玛丽亚」为例):",
    rfmSendNow: "立即发送",
    rfmJobRunning: "正在群发...",
    rfmBroadcastStarted: "🚀 群发已启动",
    rfmBroadcastDone: "✅ 群发完成",
    rfmMessageRequired: "消息不能为空",
    rfmWindow30: "最近 30 天",
    rfmWindow60: "最近 60 天",
    rfmWindow90: "最近 90 天",
    rfmWindow180: "最近 180 天",
    rfmWindow365: "最近一年",
    rfmAiTitle: "✨ AI 文案生成 (GPT-5.2)",
    rfmAiSubtitle: "根据您的行业 + 选定分群 + 客户购买行为,自动生成 3 条 WhatsApp 文案",
    rfmAiHintPlaceholder: "可选:母亲节促销 / 新品到货 / 周末特价...",
    rfmAiGenerate: "生成",
    rfmAiInsightsLabel: "AI 看到的数据",
    rfmAvgSpend: "人均消费",
    rfmAvgVisits: "人均来访",
    rfmAiNoVariants: "AI 未返回文案,请重试",
    rfmAiError: "AI 生成失败,请检查 Universal Key 余额",
    rfmAiVariantPicked: "已采用",
    rfmSegChampions: "👑 冠军客户",
    rfmSegLoyal: "❤️ 忠实客户",
    rfmSegPotentialLoyalists: "📈 潜力客户",
    rfmSegNewCustomers: "🆕 新客户",
    rfmSegPromising: "✨ 有希望",
    rfmSegNeedAttention: "⚠️ 需关注",
    rfmSegAtRisk: "🚨 流失风险",
    rfmSegHibernating: "🌙 沉睡客户",
    rfmSegOthers: "👥 其他",
    grossSales: "总销售 (毛额)",
    shiftReconcile: "🔧 重新对账 (从订单库)",
    shiftReconcileConfirm: "重新对账此班(从订单库重算总额)?",
    shiftReconcileForceClose: "同时强制结班?",
    shiftReconcileDone: "✅ 已重新对账",
    orphanCreditsMenu: "🔧 无主赊账修复",
    orphanCreditsTitle: "🔧 无主赊账修复",
    orphanCreditsFound: "发现无主赊账",
    orphanCreditsHint: "收银员点了「赊账」但没选客户/员工 — 请点击「挂账」补挂到正确的人",
    orphanCreditsNone: "✅ 没有无主赊账,所有赊账都已正确挂到客户/员工账上",
    orphanCreditsEmpty: "没有匹配的无主赊账",
    orphanAssign: "挂账",
    orphanAssigned: "✅ 已挂账",
    orphanPickTitle: "挂账给...",
    orphanPickEmployee: "👤 员工",
    orphanPickCustomer: "🧑‍🤝‍🧑 客户",
    orphanSearchPlaceholder: "搜索订单号 / 商品 / 收银员...",
    orphanSearchEmp: "搜索员工...",
    orphanSearchCust: "搜索客户/电话...",
    cashier: "收银员",
    outOfStock: "此商品已售罄",
    currentStock: "当前库存",
    agotadoHint: "请先补货或让经理开启「允许负库存」再继续销售",
    understood: "✓ 知道了 (Entendido)",

    // 🏆 Staff Performance (detail report)
    staffPerfMenu: "🏆 员工绩效详情",
    staffPerfTitle: "🏆 员工绩效详情",
    staffPerfEmployees: "员工数",
    staffPerfOrders: "订单数",
    staffPerfGross: "总销售",
    staffPerfRefunds: "退款",
    staffPerfNet: "净销售",
    staffPerfAvg: "客单价",
    staffPerfRate: "提成率 %",
    staffPerfEarnings: "提成金额",
    staffPerfCommission: "总提成",
    staffPerfTopProducts: "畅销 TOP 3",
    staffPerfEmpty: "此时段无销售记录",
    allStores: "全部门店",
    from: "起始",
    to: "结束",
    saveSchedule: "保存排班", saved: "已保存", weeklySalaryEstimate: "周薪预估", salary: "工资",
  pleaseConnectPrinter: "请先连接打印机",
  connectPrinterHint: "点击右上角⚡连接打印机按钮后重试",
  printError: "打印失败",
  labelPrinted: "标签已打印",
  labelsPrinted: "标签已打印",
  popupBlocked: "弹窗被拦截",
  printerCheckConnection: "请检查打印机是否开机并连接",
  selectProducts: "请选择产品",

  // E1_POS_I18N_V1
  pmVerifyTitle: '验证到账',
  pmRefPlaceholder: '参考号（至少4位）',
  pmRefMin4: '参考号至少4位',
  pmVerifyBtn: '验证',
  pmMustVerify: '🔒 必须验证到账成功且金额足够，才能收款',
  pmReused: '凭证已被使用过',
  pmVerdictOk: '已到账',
  pmInfoBank: '银行',
  pmInfoTime: '到账时间',
  pmInfoFrom: '付款人',
  pmInfoRef: '参考号',
  pmAmountShort: '金额少于应收:',
  pmNotFoundTitle: '未找到',
  pmNotFound: '付款还没到。若客户刚转账，等几秒再验证一次。',
  pmMarkPendingBtn: '⚠️ 短信未到/查不到 — 标记待核实收款',
  pmMarkPendingConfirm: '确定银行短信未到/查不到？本单将标记 ⚠️待核实，结班时老板必须核实。',
  pmPendingToast: '⚠️ 本单已标记待核实',
  pmPendingBanner: '可以收款，结班时管理员/老板必须核实此单。',
  pmBlockToast: '必须先验证到账，或标记待核实',
  pvTitle: '单待核实付款',
  pvHint: '收款时银行短信未到。结班前管理员/老板核实是否真的到账。',
  pvOk: '已到账',
  pvBad: '未到账',
  pvBadConfirm: '确认没收到这笔钱？将标记 ❌未到账（需追讨）。',
  pvStillNo: '❌ 还是查不到',
  reconciliationMenu: '每日对账',
  apartadosMenu: 'Aparta 留货',
  cameraBossMenu: '随手拍',
  pointsQrMenu: '积分查询二维码',
  deliveryMenu: '配送骑手',
  marketingBlastMenu: '群发营销',
  clothingVariantsMenu: '服装变体库存',
  aiCreditsMenu: 'AI 学分充值',
  waOutboxMenu: 'WhatsApp 待发',
  waConnectMenu: 'WhatsApp 连接+节日群发',
  syncQueueMenu: '离线同步队列',
  fxAlertsMenu: '汇率波动预警',
  bossPinMenu: '老板 WhatsApp PIN',
  reportsHubMenu: '数据分析中心',
  taxReportHint: '选择日期范围后点击生成报表',
  x_7b6a3713: '权限不足',
  x_930e724c: '请输入有效价格',
  x_58abd523: '缓存已清除，正在重新加载数据...',
  x_567717bd: '数据已刷新',
  x_13284485: '刷新失败:',
  x_c67c3701: '网络已恢复，正在刷新数据...',
  x_ec64f9ef: '🟢 服务器已连通',
  x_97249636: '🔴 无法连接服务器，已切换离线模式',
  x_srv_down: '🔴 Sellox 服务器无响应（你的网络正常），已切换离线模式：可继续收银，恢复后自动同步',
  x_de00636b: '💰 批发价已切换',
  x_3355b9c9: '✅ 班次已补登录服务器',
  x_cdcb5470: '令牌已自动续期',
  x_65deb2f1: '自动重新登录失败，请手动登录',
  x_066dcc67: '登录已过期，恢复网络后请重新登录以同步订单',
  x_05b73e1e: '🔁 已重新加入同步队列',
  x_4668b3da: '重新提交失败:',
  x_cfc81929: '确定清除所有待同步订单？',
  x_59462c81: '已清除',
  x_769d88e4: '完成',
  x_a3605cd3: '检测到未交班记录，请先交班',
  x_d3ab821c: '登录已过期，请重新登录',
  x_904b6b66: 'USB打印机已连接 (静默打印)',
  x_bfff47cd: '电子秤已连接',
  x_3b0e123b: '仅管理员/店长可操作报损',
  x_316b388f: '✅ 已挂单 (无新菜，未打印)',
  x_1c68b907: '当前购物车有商品，先挂起再切换桌位?',
  x_bd2ec68d: '找不到该桌挂单',
  x_4a61c29a: '离线模式',
  x_87dc2a1a: '离线模式无法登录 - 请先联网登录一次',
  x_e4bb7fff: '离线模式 - 使用缓存数据',
  x_c8d270fe: '⚠️ ATENCIÓN / 警告\\n\\n',
  x_428684a8: '服务器没响应，开班可能没成功上传。\\n\\n',
  x_990dd915: '已暂存到本机。如继续卖货时网络还断，销售会挂到临时班次，下班通知老板核对。',
  x_d04b8716: '⚠️ MODO OFFLINE / 离线模式\\n\\n',
  x_58f36ff7: '当前无网络。班次只会保存在本机。\\n\\n',
  x_59875eda: '如果网络一直不通，今日销售会归到临时班次，下班对账需多花时间。\\n\\n',
  x_d1737caf: '建议：等 1-2 分钟网络恢复再试。\\n\\n',
  x_05d979dc: '¿Continuar de todos modos? / 仍要继续吗?',
  x_3bddf726: '请先开班',
  x_bec775e5: '加载对账数据失败',
  x_d31c6a37: '⚠️ 这个班次还没有任何销售记录！\\n',
  x_d8e2e78b: '确定要结班吗？\\n¿Confirmas cerrar el turno?\\n\\n',
  x_cc49e31b: '(取消可继续营业)',
  x_6d35a343: '✅ 所有订单已上传服务器',
  x_ac03942e: '⚠ 结班 API 失败,已加入待同步队列。等网络恢复后会自动重试。',
  x_86c1eb39: '切换账号',
  x_2767058e: '客户添加成功',
  x_6452a055: '添加失败',
  x_8b2a8a38: '数据已自动同步',
  x_d23f4e73: '重量无效',
  x_b189550a: '已添加',
  x_a5366b92: '不可减到成本',
  x_c0297a24: 'El turno anterior expiró — abre un turno nuevo / 旧班次已过期，请先开班',
  x_da71e1f7: '离线模式 - 已自动开班',
  x_0bb666b2: '订单无法保存到本机！请立刻：\\n\\n',
  x_573ee6e2: '1) Foto al recibo / 拍照保留小票\\n',
  x_f474a85a: '3) Avisa al jefe / 通知老板手动补录\\n\\n',
  x_5e8eda89: '⚠️ 离线保存失败 — 拍照小票通知老板!',
  x_fef4f558: '❌ PEDIDO RECHAZADO / 订单被拒绝\\n\\n',
  x_0eccf7aa: 'Motivo / 原因:',
  x_4187e323: '订单没有入账！购物车已保留，请解决问题后重新收款。\\n',
  x_1bc8b552: '服务器无响应，本地也无法保存订单！立刻：\\n\\n',
  x_48449982: '3) Avisa al jefe / 通知老板手动补录',
  x_8c837c19: '⚠️ 完全无法保存 — 拍小票通知老板!',
  x_081947d7: '打印失败:',
  x_93fdb105: '已发送到打印机',
  x_a63bd9a0: '商家ID',
  x_b5caf579: '例如: 21da4d91',
  x_ca95bed3: '进入后台管理',
  x_bd0271ed: '正在加载...',
  x_e6e60286: '正在连接服务器并加载数据',
  x_81960a3b: '进入后台',
  x_3f685cd2: '清空客户',
  x_5e3d6f1e: '桌位',
  x_c5b1fdb6: '拆单',
  x_987d1310: '🔔 催菜已打印',
  x_3e0187a0: '催菜',
  x_4f9af33b: '当前购物车有商品，丢弃并清桌? (建议先按 F4 挂单)',
  x_93a34d2b: '清空桌位',
  x_2e0d8c60: '导出失败:',
  x_4429e2af: '手动输入今日 USD→Bs 汇率（例如 478）\\nManual rate for today:',
  x_496630eb: '汇率无效',
  x_632d6847: '汇率已同步到服务器',
  x_e1bbd792: '（正在上传…）',
  x_a66048b8: '（联网后自动上传）',
  x_a5596eed: '无待同步订单可导出',
  x_87bae330: 'USB 导出失败:',
  x_0d05c12d: '把待同步订单打包成 JSON 文件（可用 U 盘带到有网 PC 上传）',
  x_483b3198: '从其它 PC 导出的 sellox-usb-*.json 文件，合并到本机待同步队列',
  x_d6c969fc: 'USB 导入失败:',
  x_0257f05e: '格式错误',
  x_97072b48: '摄像头扫码',
  x_4aeb4434: '快速售卖 - 直接输入价格（烟/袋子/散货）',
  x_c017be6f: '购物车',
  x_9897d884: '商品',
  x_5d7dbac5: '服务费',
  x_e92b87e6: '✅ 没有待上传的单，全部已同步',
  x_ac05c6e0: '请先选客户',
  x_822d3b01: '创建失败',
  x_ece89972: '重新提交',
  x_47c14729: '确认删除？此订单记录将永久丢弃',
  x_c1d0ffe6: 'Venta Rápida / 快速售卖',
  x_703ccc54: '无条码商品：烟/袋子/散货等，直接输入价格即可加入购物车',
  x_0e9fd989: '价格',
  x_8d70d6cc: '名称（可选）',
  x_2ba4914f: '例如：烟 / Cigarro / 袋子',
  x_62d36990: '加入购物车',
  x_c542cafa: '此商品已售罄',
  x_cd14d6ac: '当前库存',
  x_f0f7c38e: '请先补货或让经理开启「允许负库存」再继续销售',
  x_b6fc6280: '✓ 知道了 (Entendido)',
  x_5e3c50d7: '已选客户',
  x_79283113: '请确认！下单后会自动清空',
  x_3a4e7b4a: '拆单',
  x_1a3e9cc8: '催菜',
  x_5a99b099: '今天是',
  x_69eccd2b: '的生日 — 要不要送个小礼物 / 免费赠品 / 生日折扣？ 🎁',
  x_d53b49d4: '关闭',
  x_71e5e874: '📡 离线中',
  x_bf349b27: '— 收银开单正常，单据已本地保存，联网后自动上传',
  x_5326b4f3: '⚠️ BCV 汇率过期',
  x_1d5e15a6: 'Vencido / 逾期:',
  x_02117218: 'Pronto / 即将到期:',
  x_c4d536c0: '📋 Reglas / 规则:',
  x_7f038370: '📱 Ver en línea / 在线查看:',
  x_56c29a7f: '¡Gracias! / 谢谢光临',
  x_f59fbcc6: '散装 · 输入重量',
  x_75c7e478: '🚫 被服务器拒绝的订单',
  x_9b109b95: '没有入账',
  x_261d3371: '🔁 重新提交',
  x_2300874f: '🗑 删除',
  x_faf1993a: '已全部处理 ✅',
  x_76ddec31: '注意：删除商品会影响所有分店！确认删除此商品吗？',
  x_69b0f684: '已停用',
  x_53ace430: '已启用',
  x_5fa802be: '操作失败',
  x_9424cd13: '打印失败: 请允许弹窗',
  x_e80262e7: '打印机已连接',
  x_ce79f0c8: '连接打印机失败',
  x_7aa71b32: '注意：删除商品会影响所有分店！',
  x_631cd220: '确认删除',
  x_35a7afeb: '个商品',
  x_0007d170: '删除成功',
  x_7775d70e: '选中商品中没有图片',
  x_d34bd225: 'AI 学分不足，已停止',
  x_54e5de42: '上传失败',
  x_7fb62b30: '批量删除',
  x_56b318c4: '批量上传图片',
  x_06a90552: '确定要按名称排序重新编码所有商品吗？(01, 02, 03...)',
  x_9708fbed: '编码重排完成',
  x_d959452f: '编码重排',
  x_7bf54e28: '已选',
  x_66eeacd9: '全选',
  x_a04144e4: '取消全选',
  x_cd0b9aca: '删除选中',
  x_3c237c07: '连接打印机',
  x_c5ea9c6a: '已连接',
  x_81ba5ea7: '打印中...',
  x_de2bc1d2: '标签显示',
  x_693b926b: '显示外币($)',
  x_3b64fbff: '显示 Bs',
  x_80806771: '不含小数',
  x_ac837e75: '显示条码',
  x_55c475bb: '标签纸',
  x_b2a6f7ae: '80mm 热敏',
  x_9e5dde5b: '50x30mm 标签',
  x_a7ad78bd: '双语(ES+CN)',
  x_5423e287: '无图片',
  x_9460a7d0: '尺码×颜色变体',
  x_5b02e434: '停用 (保留库存)',
  x_7b6defeb: '重新启用',
  x_2f4aaddd: '删除',
  x_4d775d4c: '显示',
  x_f4f85316: '上一页',
  x_b4e1b508: '下一页',
  x_8056acb6: '散装',
  x_8fe35fdc: '分钟',
  x_7d1f14ef: '0 = 关闭',
  x_dc90fae8: '库存调整',
  x_a59299fc: '调货管理',
  x_01dcb2bb: '请图失败,请先在 /admin/whatsapp-settings 配置老板号码',
  x_d5124910: '用 AI 抠图并换成白底？将扣 3 点 AI 学分',
  x_cfc6745d: 'AI 处理中',
  x_57553dee: 'AI 抠图完成！',
  x_94c6b3ba: 'AI 抠图失败',
  x_b4168dc5: '用原图重新 AI 抠图？再扣 1 点 AI 学分',
  x_afcaa4ef: 'AI 重新处理中...',
  x_b6cd67bb: '重新抠图完成！',
  x_164df077: '重新抠图失败',
  x_48fde72b: '恢复 AI 抠图前的原图？',
  x_80145d31: '已还原原图',
  x_7bd43c80: '还原失败',
  x_c74e4f1a: '选择导入分类',
  x_5fcb1e4d: '选择分类',
  x_45e49ae9: '不指定（使用文件中的分类）',
  x_7c60e550: '选择后所有导入商品将归入该分类',
  x_e111f522: '选择导入字段',
  x_41e49b1c: '基本信息（编号、名称、规格）始终导入',
  x_020f1ecd: '开始上传',
  x_92cd554e: '上传中...',
  x_794a4ecb: '全部商品',
  x_abaff128: '例: 10 = 成本涨10%',
  x_2fff577b: '请至少填一项',
  x_9fce5962: '分类:',
  x_2fb90b05: '处理中...',
  x_2901ac42: '确认调价',
  x_727dc210: '批量 AI 抠图',
  x_7385d670: '全选有图',
  x_625fb26b: '取消',
  x_a642d255: '店名:',
  x_04870124: '🏷️ 网店促销角标',
  x_d5acfdec: '无',
  x_6e41198f: '🔥 热卖',
  x_46a742e3: '✨ 新品',
  x_e1179aa4: '💥 折扣',
  x_47eddf7c: '🥬 散装 / 按克·公斤售卖',
  x_7c88c892: '（网店会显示"散装"标签，顾客可买 0.5 / 1.8 等小数）',
  x_28b47633: '👕 季节标签',
  x_7c8d6872: '— 未分类',
  x_2f1cc7f8: '🌸 春季',
  x_e87105bf: '☀️ 夏季',
  x_dded849e: '🍂 秋季',
  x_7c7a55ef: '❄️ 冬季',
  x_6047e490: '🗓️ 四季',
  x_89f7904f: '用于过季商品的批量打折管理。',
  x_9966d712: '🍽️ 上菜阶段',
  x_61541067: '— 同步上',
  x_efd81299: '🥗 凉菜先上',
  x_864dc4dc: '🍲 热菜',
  x_125653fe: '🍚 主食',
  x_c64f64c1: '🥤 饮料',
  x_c63fb6f7: '🍰 甜点最后',
  x_e091ce54: '厨房会按此分组打票 · Cocina agrupa por etapa',
  x_58b439e0: '⏱️ 出菜时间',
  x_210974b9: '用于排单和催菜判定',
  x_4a2ac468: '🖨️ 打厨房单',
  x_88ca75d5: '关闭后下单不发去厨房（适合饮料/外购商品）',
  x_ee4e4b38: '💊 批号',
  x_e7100153: '📅 有效期',
  x_1ac5191c: '⚠️ 处方药',
  x_52af7df5: '销售时会强制登记客户身份',
  x_ae0b0527: '📱 序列号',
  x_89d8ab7a: '🛡️ 保修月数',
  x_b5e44315: 'Variantes / 口味变体',
  x_5adfcd10: '(用逗号分隔)',
  x_72ee7c09: '批发起量 → 自动价格2',
  x_378c05db: '(ALFONZO SHOP 主仓)',
  x_c852c3dc: '其它仓库（只读，请用"库存调整"或"调货管理"修改）',
  x_5c0c578b: '📱 WhatsApp 请图',
  x_a1773715: '✨ AI 抠图',
  x_90f7259e: '🔄 重新抠图',
  x_e955fcb2: '↩️ 还原原图',
  x_ae5ad52a: '批量上传商品图片',
  x_7c5dc935: '使用方法：',
  x_eabafd4b: '1. 将图片文件按',
  x_f9d8b163: '商品编码',
  x_25c971d2: '命名',
  x_c2654942: '例如: 商品编码',
  x_d13c1bb8: '→ 图片命名为',
  x_1aeffd84: '2. 选中所有图片文件，一次性上传',
  x_3be0aaea: '3. 系统自动匹配编码，更新商品图片',
  x_b226d05e: '支持格式: JPG, JPEG, PNG, WEBP',
  x_f08afd1f: '已选择',
  x_6d03439d: '个文件，点击"开始上传"由服务器匹配编码',
  x_7b9de9b7: '未找到对应商品:',
  x_c4390da8: '错误:',
  x_b15d9127: '关闭',
  x_ec74c566: '批量改价',
  x_85f16ef9: '分类 / Categoría (留空=全部)',
  x_7f1fd8fd: '全部商品',
  x_ef7e66eb: '成本涨幅',
  x_ebb263a8: '新利润率 / Nuevo margen (%) — 留空不改',
  x_e93880f5: '利润1 (P1)',
  x_e105c7e7: '利润2 (P2)',
  x_af32ce55: '利润3 (P3)',
  x_3621e3c6: '公式: 新售价 = 新成本 × (1 + 利润率%)',
  x_0d2f0cb5: '例: 成本$1 + 利润30% = 售价$1.30',
  x_fc51faec: '网店背景主题',
  x_1dbb0d24: '店铺类型',
  x_faeff5ef: '超市',
  x_2580b405: '餐馆',
  x_2ac97357: '百货',
  x_3972c872: '药房',
  x_94f1c5f0: '面包店',
  x_d2fe24af: '服装',
  x_cdce861f: '电子产品',
  x_4c745eb9: '肉铺',
  x_aa05fd09: '通用',
  x_b42f3d0b: '自定义图片',
  x_470c8cb6: '上传背景图片 (建议 1920x800, 最大 5MB)',
  x_ba9fc45d: '选择图片',
  x_a7699ba7: '上传成功',
  x_97e448c5: '店铺描述 (显示在网店首页)',
  x_e90f3dd4: 'placeholder={t(\'shopDescPlaceholder\') || \'例如: 新鲜蔬果 每日直送\'} data-testid=',
  x_e4de2708: '网店链接预览',
  x_146c214c: '⚡ 快速收款(免确认弹窗)',
  x_847d3492: '访客网络',
  x_0d9614ed: '打印机选项',
  x_a305b265: '普通小票打印机(POS)',
  x_9d2ae79f: '打印机名称',
  x_37ba4d4d: '打印方式',
  x_e3127cc1: '格式',
  x_dc7ac037: '热敏',
  x_8419e5a2: '自动打印',
  x_b815bd61: '🖨 省纸模式',
  x_0a50b98b: '打印份数',
  x_95a11756: '测试打印',
  x_08d73983: '报表打印机',
  x_1822051b: '纸张大小',
  x_086f6c26: '用于打印销售报表、库存报表等A4文档',
  x_f6c5bb79: '税务打印机(Fiscal)',
  x_85fc7de8: '打印机型号',
  x_923f0558: '连接端口',
  x_9ec10f88: '启用钱箱控制',
  x_46886d25: '打印货品编号 (仅税务单据)',
  x_0d1eb73c: '静默打印设置 (不弹出打印对话框)',
  x_c530a752: '将XP-80C设为Windows默认打印机',
  x_f5dcc91d: '下载下面的快捷方式文件，放到桌面上双击打开',
  x_34c425af: '使用独立进程模式，无需关闭其他浏览器窗口',
  x_1f439178: '允许库存 0 / 负数时开单 (Allow overselling)',
  x_d28ccc95: '例: 5 = 减5%',
  x_89b146df: '例: 3 = 减3%',
  x_3b108349: '保存成功',
  x_6de920b4: '保存失败',
  x_667519a7: '清理缓存中...',
  x_715e78ba: '缓存已清理，即将刷新...',
  x_3d58a3f4: '清理失败，请手动刷新',
  x_635d85ed: '成本核算方式',
  x_9f3cdb13: '最新成本法 (进货价直接覆盖)',
  x_cdf4510f: '加权平均法 (旧库存×旧成本+新货×新价÷总量)',
  x_a2361773: '✓ 两种汇率混批拿货时，利润按平均成本计算更精确',
  x_8c332c85: 'Salario Minimo Legal (Bs/mes) 最低工资',
  x_1f1cb126: '当政府调整最低工资时，在这里修改即可。当前默认: Bs. 130.00',
  x_fcf71823: 'WiFi 客户扫码连网',
  x_a4162fc6: 'WiFi SSID (网络名称)',
  x_93952fec: 'WiFi Password (密码)',
  x_aea862e7: '客户PagoMovil付款时，验证窗口会显示WiFi二维码让客户扫码连网。',
  x_764327eb: '建议用路由器的"访客网络"(Red Invitado)设置2分钟自动断线。',
  x_d38fdd96: 'Kiosk (静默 - 推荐)',
  x_64ae72e7: 'USB 直连 (COM串口)',
  x_3ac81273: 'Kiosk (静默 - 和普通小票共用)',
  x_a27aa9d2: 'USB 直连 (COM串口 - 独立Fiscal打印机)',
  x_1fdcab60: '📦 库存规则 Inventory Rules',
  x_8c0b62d0: '⚠️ 已开启「允许超卖」',
  x_0b98802c: '🛡 严格模式（推荐）',
  x_3469dcde: '🏭 批发自动识别门槛（件）',
  x_abe9d5a5: '单笔订单任意一样 ≥ 此数量 → 自动判为批发单',
  x_66b516be: '🏭 批发订单 — 积分 / $1',
  x_44cdb632: '批发单用这个比例（通常比零售低，保护利润）',
  x_cad2cdb3: '📊 返利计算：',
  x_e9b42d03: '网店赊账折扣',
  x_c8ebef70: '现金折扣 %',
  x_b315c033: '7天赊账折扣 %',
  x_92f50a16: '15天赊账无折扣。折扣在网店结账时自动计算。',
  x_6a46e901: '保存折扣设置',
  x_aecb318e: '• 当前版本',
  x_fd044b72: '• 清理范围',
  x_c3c63335: '先验证储值卡',
  x_258b5e0a: '余额不足',
  x_6074ad12: 'Error al cobrar la tarjeta / 储值卡扣款失败',
  x_4091e27c: '折扣',
  x_952fe994: '拆分支付',
  x_d9b8f7dc: '卡号',
  x_df635901: '输入卡号和 PIN',
  x_44efeacf: 'Tarjeta inválida / 卡无效',
  x_cd8992b6: '验证',
  x_fbb9242b: '刚好',
  x_ac770469: '还差',
  x_855bfd60: '应付',
  x_a1b49020: '还差',
  x_c993e001: '找零',
  x_450efd2f: '合计',
  x_23d0eed8: '下一个',
  x_aaf7077a: '天数',
  x_249aba76: '天',
  x_1ceaeb7c: 'Buscar empleado / 搜索员工...',
  x_0c9d2b45: '支付方式',
  x_e83a256e: '确认',
  x_bf15f831: '原价',
  x_954a5f2c: '应付',
  x_a2e76886: '% 百分比',
  x_4ca7ca2e: '$ 减金额',
  x_62409e5c: '$ 最终价',
  x_4ea4474d: '任选一个: 填 3 → 97 折 · 或 减 $1.57 · 或 输最终 $50',
  x_f761deae: 'Seleccione un cliente / 请先选客户',
  x_719a6f48: 'Plazo de pago / 赊账天数',
  x_a2c1dba8: 'Seleccione un empleado / 请选择员工',
  x_203546f6: '已改价',
  x_2432b575: '备注',
  x_a8b0c204: '全部',
  x_4c37b31d: '该分类暂无商品',
  x_d8318796: '请输入商品名称',
  x_2d5bd318: '请输入成本价和P1利润率',
  x_3fdaeadf: '添加成功',
  x_26983664: '请输入还款金额',
  x_b58060b3: '📡 收款已存本机，联网后自动上传',
  x_ae5a8a24: '还款成功',
  x_8b649901: '还款失败',
  x_d594b77a: '请输入金额',
  x_305091bd: '请选择员工',
  x_e2079942: '请输入工资金额',
  x_cdef21ee: '扣除不能超过工资',
  x_43b972b2: '未找到该订单',
  x_0d66ed02: '查询失败',
  x_8093e392: '请输入姓名',
  x_08b1fa13: '请输入用户名',
  x_11524166: '密码至少4位',
  x_b5e12476: '员工添加成功',
  x_ea340b7c: '借款',
  x_3f01df5b: '赊货',
  x_4c95bf44: '还款',
  x_79ef16e5: '工资扣除',
  x_ded3cdfb: '发工资',
  x_029d48fa: '旷工罚款',
  x_5ba2fb47: '历史欠款',
  x_756048fc: '员工对账单',
  x_4ff1e74e: '日期',
  x_226b0912: '类型',
  x_4cf24aba: '金额',
  x_5a4fcfe2: '当前欠款',
  x_26068dad: '打印时间',
  x_d0de55dc: '打卡上班成功',
  x_15ffd5c7: '打卡下班成功',
  x_20cdb977: '打卡失败',
  x_bd4357f9: '全天',
  x_c31b1b99: '半天',
  x_02efd8b1: '旷工',
  x_95748d60: '✅ 该日缺勤欠款已自动撤销',
  x_40862774: '标记失败',
  x_b6838383: '房租',
  x_0ee0c81c: '水电',
  x_be11fc04: '工资',
  x_1f4beff9: '耗材',
  x_324712a3: '维修',
  x_0f3a252a: '运输',
  x_2a0ad6ff: '餐饮',
  x_638e3280: '税费',
  x_0d98c747: '其他',
  x_fdfd5d5f: '请先选择员工',
  x_50bcbd71: '发薪失败',
  x_36cb9c59: '排班已保存',
  x_57b08dd4: '没有员工',
  x_efafd9a3: '应用失败',
  x_8f21b986: '请输入模板名称',
  x_979b4faf: '模板已删除',
  x_acf0664a: '删除失败',
  x_1603b069: '周一',
  x_b5a6a07e: '周二',
  x_e60725e7: '周三',
  x_170fc8e2: '周四',
  x_eb79cea6: '周五',
  x_24575130: '周六',
  x_562d7476: '周日',
  x_f8fbeae1: '上午',
  x_e2eb289c: '下午',
  x_51147c21: '休',
  x_fbcf05da: '<!DOCTYPE html><html><head><meta charset="utf-8"><title>排班表<',
  x_e1adc7de: '<h2>员工排班表<',
  x_ae2703cb: '<table><tr><th>员工<',
  x_e3e234b4: '<span><span class="box" style="background:#d4edda"></span> 全天</span>',
  x_034dcc79: '<span><span class="box" style="background:#fff3cd"></span> 上午</span>',
  x_ebdf24a9: '<span><span class="box" style="background:#ffeaa7"></span> 下午</span>',
  x_13db7d6d: '<span><span class="box" style="background:#f0f0f0"></span> 休息</span></div></body></html>',
  x_bd626c2f: '签收成功',
  x_2bd5e2ab: '签收失败',
  x_c10a6c00: '请填写完整',
  x_1fbd718d: '现金应小于刷卡金额',
  x_c31eabb4: '刷卡',
  x_acaf665f: '转账',
  x_b416b575: '移动支付',
  x_41ce131a: '混合',
  x_3df74976: '赊账',
  x_0319bf13: '当日营业汇总',
  x_fbb493d0: '订单数',
  x_8bd00685: '店长面板',
  x_9c1d16fc: '今日营业',
  x_cc1987ec: '查看库存',
  x_78d078e8: '开支',
  x_29225555: '汇兑收益',
  x_e7c0908c: '现金',
  x_2f6805aa: '员工账',
  x_d37a7de1: '排班',
  x_fa3aee98: '添加商品',
  x_848704b1: '调货收货',
  x_94fea5cb: '全天汇总',
  x_843e649c: '当前班次',
  x_19940592: '没有活跃班次',
  x_b1423de3: '单均',
  x_5bc31fd0: '按支付方式',
  x_c2e5a8e2: '按币种统计',
  x_b634ce2e: 'Bs 开单',
  x_d0af2c40: '$ 开单',
  x_83958d46: '单',
  x_aded5d5b: '收',
  x_eddd9ee1: '对账',
  x_d97f0de8: '总收款',
  x_be77abaa: '按收银员统计',
  x_3960424f: '现金找零对账',
  x_2e8e048d: '收到现金',
  x_043d5f39: '找零合计',
  x_534097e9: '净现金',
  x_22b91744: '仅统计有记录收到金额的现金订单',
  x_21533faf: '打印营业汇总',
  x_a8e76489: '查看订单明细',
  x_dc9b2ec5: '筛选收银员',
  x_bfdaebfd: '收银员',
  x_654522d2: '币种',
  x_0bf60b32: '数量',
  x_da4abd3e: '单价',
  x_f599fcd3: '小计',
  x_26922a58: '收到',
  x_56ae8659: '所有仓库',
  x_adcd38b7: 'Buscar + Enter / 搜索商品名称/编码...',
  x_0aaf10c2: '未找到匹配商品',
  x_d3bc58b6: '汇率',
  x_f155c56c: '选择的汇率',
  x_37a3f5ca: '折合美元',
  x_ac502247: '买美金现金',
  x_2feedc17: '刷卡换现金',
  x_2ddd1415: '美金金额($)',
  x_735fcb9f: '买入汇率',
  x_27cae7b2: '卖出汇率',
  x_26431425: 'Bs成本',
  x_9aef4e3c: 'Bs价值',
  x_cb340191: '利润',
  x_b58c7549: '添加',
  x_f58a32cd: '刷卡金额(Bs)',
  x_d5dd40af: '给出现金(Bs)',
  x_171cc7f8: '利润(Bs)',
  x_f2d612ee: '手续费率',
  x_524d7e11: '今日利润(Bs)',
  x_58add0bd: '今日利润($)',
  x_19fcb9eb: '时间',
  x_f26225bd: '详情',
  x_e052f520: '利润($)',
  x_cbe408cd: '买美金',
  x_a185dea2: '刷卡换现',
  x_b9db8476: '暂无记录',
  x_c966e6db: '美元现金',
  x_d96c0531: 'Bs现金',
  x_b7b3fa73: '快速换汇',
  x_1c927ecc: '不用去换汇标签，直接在这里操作',
  x_b28432d4: '去换汇',
  x_661f8852: '现金操作',
  x_4cc6a2f6: '存入',
  x_7be8ae3a: '取出',
  x_474a556a: '上交',
  x_1827f06e: '调整',
  x_0367ebd1: '备注...',
  x_abe2c5d2: '提交中...',
  x_b66b2e82: '最近记录',
  x_676e5982: '操作员',
  x_7f0dc5e3: '销售',
  x_774e1765: '兑换',
  x_742440c4: '员工账务',
  x_2ef46a5f: '添加员工',
  x_60d0458a: '姓名',
  x_32ffa250: '身份证号',
  x_5a93d3f7: '电话',
  x_819767ad: '用户名',
  x_a8105204: '密码',
  x_464f3d4e: '角色',
  x_3887bfff: '普通员工',
  x_bbc407c7: '查价员',
  x_586a52f3: '信用额度',
  x_eeb4d5b7: '0 = 无限制',
  x_25cebe66: '工资金额',
  x_b5ca1dd9: '发薪周期',
  x_09b03b6d: '每周',
  x_93a158a9: '每15天',
  x_aa3d57c0: '每月',
  x_5e3640e4: '确认添加',
  x_4c998309: '打印二维码卡',
  x_8d7eb002: '工资单 + QR',
  x_2dbf283b: '对账单',
  x_e8da0032: '欠款',
  x_bbdd42a0: '已结清',
  x_620610c0: '已还',
  x_8577b01a: '员工提取存款',
  x_44ba3fed: '提取失败',
  x_7b1df363: '暂无员工欠款记录',
  x_7941da94: '一',
  x_2d8be272: '二',
  x_e662ff59: '三',
  x_21716cf3: '四',
  x_1fcc29d0: '五',
  x_61b45352: '六',
  x_3edddd85: '日',
  x_93849f29: '今日考勤',
  x_416b2ef6: '已下班',
  x_b767d98a: '上班中',
  x_6bc72d59: '未打卡',
  x_b4f0388f: '上班',
  x_96ed60cd: '下班',
  x_7b6e413b: '新增员工账务',
  x_37c140e9: '选择员工',
  x_99b437e5: '借款给员工',
  x_c06881f5: '赊货给员工',
  x_fbb40b61: '员工还款',
  x_783aaf86: '历史欠款导入',
  x_859e83a6: '只记录欠款金额，不扣现金余额',
  x_83ba80ef: '转账不影响店现金余额',
  x_27622285: '工资总额',
  x_a46225b3: '输入订单号自动查询',
  x_bee912d7: '查询',
  x_b433e6c6: '商品信息',
  x_f87737b3: '赊货商品详情...',
  x_2edddab1: '日薪',
  x_074eca2c: '从工资扣除欠款',
  x_20b7f99c: '实发',
  x_39ce9e78: '不抵扣 (全发现金)',
  x_82a6f2f0: '员工用 Bs 还款 → 自动换算 USD 抵扣欠款',
  x_162fe161: '店长: 自填汇率',
  x_7e21332c: '员工: BCV 汇率',
  x_767b82cb: '自填',
  x_9e3eba91: '计算模式',
  x_3aed2c11: '自动',
  x_2a3e7f5c: '手动',
  x_b4b4b75b: '自动可调',
  x_0a61f1ae: '超过信用额度!',
  x_c6403f20: '额度',
  x_28b24262: '操作后',
  x_2e81e23d: '超出',
  x_07b42ee9: '交易记录',
  x_2ed39222: '员工',
  x_e05e6f34: '余额',
  x_e25b7872: '添加新商品',
  x_1fd1d5c5: '商品名称',
  x_cc6c35a3: '编码',
  x_d0771a42: '分类',
  x_2e2ce286: '成本价',
  x_7a3da957: '利润率',
  x_2acbbffe: '系统自动算价格',
  x_650f9201: '整箱',
  x_3301f812: '每箱数量',
  x_2a79a737: '税率',
  x_72993534: '入库数量',
  x_39f76a9b: '条码',
  x_257a8023: '扫码/输入条码后按回车',
  x_4347fc1c: '添加的商品会同步到所有分店，但只有本店有库存',
  x_ae1c4d7f: '搜索客户/单号...',
  x_322ade24: '未还清',
  x_fa25eda2: '逾期',
  x_13992709: '部分还款',
  x_480018e8: '已还清',
  x_4403fca0: '清除',
  x_c624290a: '条记录',
  x_c75e2f5f: '待收',
  x_ff0b2077: '客户',
  x_1e8dc255: '订单号',
  x_6ffe81e2: '总额',
  x_57b642fc: '已付',
  x_499b9a62: '到期日',
  x_3fea7ca7: '状态',
  x_2b6bc0f2: '操作',
  x_45274498: '部分',
  x_1611cbc7: '待还',
  x_2722964b: '没有符合条件的记录',
  x_8e6adfe0: '还款金额',
  x_37fa12a4: '待收货调货单',
  x_694fc5ef: '刷新',
  x_bf08ab13: '没有待收货的调货单',
  x_4933ca41: '待收货',
  x_04531587: '发货',
  x_91bcfc81: '总仓',
  x_8690efe6: '发货数',
  x_a8974abd: '实收数',
  x_a18a1f0c: '确认签收',
  x_29825420: '仓库未加载，请稍后重试',
  x_38bbc161: '仓库未加载',
  x_1ba301c3: 'Enviado para aprobación del administrador / 已提交等待管理员审批',
  x_72520580: '本周',
  x_9c5f8689: '发薪给选中员工',
  x_ba4c8037: '保存排班',
  x_f8dfedcd: '已保存',
  x_0963bb54: '排班模板',
  x_cb86af8d: '{t(\'templateName\') || \'模板名\'}',
  x_eb347bdb: '+ 新建',
  x_26b5bd49: '加载中...',
  x_69a69eb0: '周薪预估',
  x_85a77ddc: '点击格子循环切换',
  x_80da96c6: '排班表',
  x_c59cae5e: '员工排班表',
  x_3a991a4c: '休息',
  x_10627c90: '出入数计算方法',
  x_955acdc0: '现金销售手动入账',
  x_cd06c6b3: '手动存入 / 调整增加',
  x_a9f5d26a: '手动取出 / 上交 / 调整减少',
  x_a20bbe5d: '工资发放 / 员工借款',
  x_d13feaa2: 'Biopago/刷卡/转账不计入现金余额（到银行）',
  x_aaa36041: 'VES金额 = 商品USD价 x BCV汇率',
  x_0e59b159: '节日上班 = 1.5倍工资 (自动计算)',
  x_63686703: '本月无节日',
  x_362bb8be: '工资单',
  x_79274ddb: 'Inventariar / 盘点',
  x_5d855937: '已逾期',
  x_dcc961ae: '已作废',
  x_a0bf20e8: '待同步',
  x_c2c0df04: '📡 已存本机',
  x_4650017d: '没有网络 — 赊账已本地保存并显示在列表(黄色待同步)，联网后自动上传',
  x_eb3eae91: '📡 收款已存本机',
  x_fa17371a: '没有网络 — 该还款已本地记录(黄色待同步)，联网后自动上传',
  x_1c97a7ce: '即将到期',
  x_a44f40d4: '未配置老板手机号，请到 WhatsApp 设置添加',
  x_464208d1: '发送失败',
  x_1cf1a230: '把到期账款汇总发到老板的 WhatsApp',
  x_24cc017a: '催款发送失败',
  x_6910a681: '自动给每个逾期/即将到期的客户发 WhatsApp 催款',
  x_aab87728: '已还清，无未结账单',
  x_a48948bf: '全部门店',
  x_a7da9234: '门店',
  x_6b0cbe98: '看右上角☁️',
  x_832af156: '联网自动上传',
  x_d2593e04: '必须用美金支付',
  x_8e0be5e5: '还款上传被拒绝，点右上角☁️处理',
  x_10efc391: '商品明细',
  x_1c40f543: '还款记录',
  x_d88fb1dd: '此赊账必须用美金支付',
  x_84857e3e: '赊账到期提醒',
  x_43b510ed: '剩余',
  x_bfc2bc5a: '暂无到期/逾期赊账',
  x_f3737dbf: '单号',
  x_7c5f7ff6: '💵 USD 未收',
  x_139bf01e: '🇻🇪 Bs 未收（USD 当值）',
  x_23414073: '⚠️ USD 与 Bs 不相加：USD 是实收美金；Bs 开单按当日汇率快照记成美金价值，收款时用当日实时汇率换算 Bs。',
  x_7b7d5246: '⚠️ 有还款失败',
  x_b3032ddd: '@当天',
  x_6845ced0: '欠款总额',
  x_1302a371: '还款记录:',
  x_d7e9237c: '条码未匹配商品',
  x_ef48633e: '请选择不同的仓库',
  x_dd2124ee: '请添加商品',
  x_1fc560de: '📡 网络不稳 — 调货单已离线保存',
  x_b56601bf: '恢复网络后自动上传。请稍后在调货列表确认它真的出现了！',
  x_028e7279: '调货单创建成功',
  x_861505e1: '调货单已取消',
  x_8ae6036e: '⚠️ 您把全部商品的实收数量都填成了 0。\\n\\n这意味着 MANUEL 仓库一件也不会增加。\\n\\n如果货物真的完全未到，点"确定"继续。\\n如果是误操作，点"取消"返回重填。',
  x_d2875199: '新建调货单',
  x_7c5e97eb: '已签收',
  x_cc1bacb5: '条',
  x_7031d352: '调货单号',
  x_b683d031: '发出仓库',
  x_8dda8a9c: '接收仓库',
  x_8887e33b: '总数量',
  x_2111ccbb: '已取消',
  x_e699aa3c: '复制整单',
  x_ef091458: '取消调货单',
  x_f89fa9b6: '选择仓库',
  x_6b705e8c: '搜索商品 / 扫码...',
  x_14545603: '摄像头扫码',
  x_b26107b6: '创建中...',
  x_73de67b8: '创建并打印',
  x_a9aa4fae: '签收调货单',
  x_bf09ef8b: '发出',
  x_15e9238b: '接收',
  x_6edb92ec: '调出数量',
  x_7a6e939a: '实收数量',
  x_7e28d689: '已自动调整到可用数量，请确认后再次提交',
  x_3e71abd0: '调货单',
  x_ea887bd0: '规格',
  x_ebb67faf: '发货签名: _______________',
  x_6afdc8b0: '收货签名: _______________',
  x_4c271bd8: '调 货 单 · Orden de Transferencia',
  x_8d4312cd: '发出仓库',
  x_8a90ed66: '接收仓库',
  x_cd50b523: '创建日期:',
  x_b5e8e5c3: '操 作 人:',
  x_55bea7c5: '备注:',
  x_0a64548c: '商品名称',
  x_50b98e79: '调货数量',
  x_031a18b8: '发货人签名 · 日期',
  x_81cb422e: '收货人签名 · 日期',
  x_90d971c7: '⚠️ 源仓库库存不足',
  x_59d31a31: '/ 需',
  x_3cd9e10d: '源仓库会显示负库存，请记得后续补货',
  x_866b795e: '加载失败',
  x_acc47889: '✅ 已添加',
  x_acd5cb84: '失败',
  x_c4ebcdbf: '确定删除此桌?',
  x_cec8924c: '✅ 已删除',
  x_fd691fb1: '确定释放此桌? (会清掉绑定的挂单链接)',
  x_c77aedd7: '✅ 已释放',
  x_23f7319b: 'QR 加载失败',
  x_65e200d3: '下载失败',
  x_28d45b55: '✅ ZIP 已下载',
  x_b264a9b6: '下载失败:',
  x_d3a27772: '先添加桌位',
  x_16fca75d: '✅ ZIP descargado / 已下载',
  x_3317ce8e: '桌号 (留空自动)',
  x_f1e3f7fb: '名称 (可选)',
  x_4af1e6c6: '座位数',
  x_a7bac223: '中文',
  x_806c4388: '绿',
  x_d088e652: '红',
  x_b990b42b: '橙',
  x_2fc8da52: '蓝',
  x_34e66c72: '紫',
  x_9cba5857: '黑',
  x_4207f36f: '桌位管理',
  x_be5fbbe3: '保存',
  x_904614f6: '还没有桌位',
  x_55fdd74d: '先去「⚡ 行业模板」选「🍽️ 餐馆」, 系统会自动建 10 张桌子',
  x_505fcefc: '或者点上面的「加桌」按钮手动添加',
  x_d07d6cdf: '空',
  x_29880b96: '用法:',
  x_45e716f0: '客人入座 → 服务员在 POS 选商品 → 按「F4 挂单」',
  x_362857a7: '挂单时输入桌号备注（如「桌3」），或来此页关联',
  x_5abc3304: '客人想加菜 → POS 取回挂单 → 加新商品 → 重新挂单',
  x_d01b9612: '客人要结账 → POS 取回挂单 → 收款 → 释放此桌',
  x_a889dfa2: '每张桌位的扫码点餐二维码。打印或下载 ZIP，贴在桌面上。',
  x_56ba8da3: 'Sellox · 扫码点餐',
  x_a6bcd7fd: '扫码 · 自动选桌号',
  x_bffc3306: '还没桌子 — 先去左侧「加桌」',
  x_22342357: '语言',
  x_664bd4c3: '品牌色',
  x_562afa20: '选择语言和颜色查看预览',
  x_cdc8aa2a: '请输入有效金额',
  x_a6be14ea: '🎉 储值卡已生成',
  x_a889286a: '创建失败',
  x_d9217d95: '充值失败',
  x_73268407: '确定停用此卡? (持卡人无法再使用)',
  x_174bdf89: '请输入卡号+PIN',
  x_6047d376: '弹窗被拦截,请允许弹窗后重试',
  x_3671b15c: '4 位',
  x_99c1801d: '搜索 客户名/电话/卡尾号',
  x_ad6b7038: '可用',
  x_9c2b5257: '用完',
  x_5c56a889: '停用',
  x_7779a6ac: '买$50送$5',
  x_81b5d9ee: '已复制卡号',
  x_a2fd009c: '🎁 Tarjeta de Regalo / 储值卡',
  x_cac30fb8: 'Código / 卡号',
  x_a93dac50: 'Saldo / 余额',
  x_fa6c3ef4: '请保管好本凭证,查询和使用需卡号+PIN。',
  x_d4334477: '🎫 储值卡',
  x_0e03f74c: '余额查询',
  x_f9089b58: '卡号 (16 位)',
  x_554b5f0d: '卡尾号',
  x_3577a5ae: '发售',
  x_584cd195: '过期',
  x_8a6e6c55: '还没有储值卡',
  x_11344dd6: '🎫 发售储值卡',
  x_39a058d6: '输入金额和客户信息生成新的储值卡。',
  x_5b90f4f9: '卡内金额 ($)',
  x_a10e8516: '店家赠送 ($)',
  x_8f876263: '客户姓名 (选填)',
  x_b4a12819: '客户电话 (选填)',
  x_7430e2e0: '有效期 (天, 0 = 永久)',
  x_1ffb8483: '生成卡',
  x_f0ec8be7: '🎉 储值卡已生成 — 请写下卡号 + PIN',
  x_76bd513c: '新生成的卡号和PIN，请抄录到实体卡片上。',
  x_a614e73a: '卡号',
  x_308111f4: '重要：',
  x_b3531d90: '本卡号和 PIN',
  x_f2c00976: '只显示这一次',
  x_bd8ee68a: '🖨️ 打印',
  x_a6dada89: '我已记下 ✓',
  x_c5b6c7ba: '💵 充值储值卡',
  x_7a8c087d: '为已发售的储值卡追加金额。',
  x_74fbcc56: '卡尾号:',
  x_204538f5: '当前余额:',
  x_1f143c8d: '充值金额 ($)',
  x_7e410409: '进行中',
  x_eca18247: '✅ 已完成',
  x_9809e6f2: '已取消',
  x_b7a2291a: '⚠️ 已没收',
  x_5a08deaf: '加载失败',
  x_63b8f2b2: '搜索单号 / 客户 / 电话',
  x_e7784a34: '已保存',
  x_712939e0: '金额必须大于 0',
  x_051e1c80: '✅ 已收款',
  x_3d1f2fcc: '失败',
  x_22bbda1e: '请允许弹出窗口',
  x_d6818f91: '<tr><td colspan="3" style="text-align:center;color:#999">无记录</td></tr>',
  x_dd139654: '已取消 / Cancelada (库存已回滚)',
  x_5cbad596: '🟢 定金',
  x_b5a103dc: '💵 加付',
  x_d98fd798: '备注 / Nota (可选)',
  x_5769b85a: '确认收款',
  x_a29d3fab: '取消原因',
  x_92b67f7b: '退还定金给客户',
  x_094590c4: '定金归商家(无退款)',
  x_2a33020e: '保存中...',
  x_0aa2fd58: '进行中',
  x_80e42329: '已完成',
  x_443483c9: '全部状态',
  x_fb852fc6: '进行中',
  x_fad5222c: '已完成',
  x_d6a3df8d: '已没收',
  x_08226a9b: '📋 商品',
  x_a015434e: '产品',
  x_b9224f27: '💰 金额',
  x_0b68090c: '总额',
  x_8ed12dec: '已付',
  x_f085817a: '待收',
  x_7220e4d5: '方式',
  x_edd98a05: '无记录',
  x_21a22391: '客户',
  x_9f796492: '商品',
  x_3f1e93a5: '➕ 加收款',
  x_9b7e9298: '📅 今日 Bs 汇率',
  x_464ee460: '🔒 创建时锁定:',
  x_15e8601c: '现金 USD',
  x_6aad3987: '现金 Bs',
  x_3ed4a686: '转账',
  x_25557e0c: '刷卡',
  x_66a35235: '⚠️ 取消 aparta(会自动恢复库存)',
  x_4253d249: 'Aparta 规则',
  x_150978ed: '启用 Aparta 功能',
  x_db82dff0: '最低定金 %',
  x_f411a870: '默认期限(天)',
  x_bfa32868: '到期后宽限期(天)',
  x_89d38266: '超过这天数后,定金归商家',
  x_05e6cff3: '到期前几天提醒',
  x_780eb764: '自动 WhatsApp 收据',
  x_ca0e7ab8: '🏭 行业专属模式',
  x_40a69a97: '选行业一键启用对应功能 + 分类预设',
  x_ce198527: '餐馆模式',
  x_4457ca2a: '桌位管理 · 厨房屏 KDS · 服务费 · 课菜分组打印 · 催菜按钮',
  x_f3bede6c: '服装店',
  x_31638707: '尺码×颜色变体 · 季节标签 · 批零自动切价 · 库存按变体独立计数',
  x_4b94f7ca: '快餐 / 烘焙',
  x_e4ec5eb2: '取餐号叫号 · 厨房打票 · 7 大分类预设（面包/蛋糕/咖啡）',
  x_f62e3009: '超市 / 食杂',
  x_c6f34300: '10 大分类 · 散装/称重默认开 · 整箱售卖 · 冷链区分',
  x_629960fd: '药店',
  x_ba330da8: '处方/非处方分类 · 批号 + 过期日预警 · 处方追溯',
  x_0f84be62: '五金 / 电子',
  x_17b68710: '工具/油漆/水暖 7 分类 · 序列号追溯（电子）· 保修期管理',
  x_7bcbf628: '🛒 收银 + 销售',
  x_79223063: '智能 POS 收银',
  x_e5cbb127: '条码扫描 · 多价格层 · Bs/USD 双币 · 快捷键 · 离线运行',
  x_ed4d7ae6: '离线 PWA 模式',
  x_c8bc72c1: '断网照样开单 · 恢复后全局队列自动同步上传',
  x_2e16c12a: 'Windows 桌面 App',
  x_44819336: 'Electron 打包 · 90 天 JWT 长会话 · 静默更新 · 装机即用',
  x_a6185298: '在线商城 + 二维码',
  x_3ff0e9d1: '网店自动生成 · 客户扫码下单 · 自助点单 / 送货上门 / 自取',
  x_c6840e7e: '客户 CRM + 批发标记',
  x_c98fb10f: '积分/会员等级 · 赊账 · 推荐返利 · 批发客户自动切换价格',
  x_3a44d260: '热敏打印',
  x_715e4b5e: '80mm 小票 · 价格标签 · ESC/POS 直连 · 多店打印机配置',
  x_61ac4d4d: '🛵 配送 + 营销',
  x_c51eca4b: '骑手平台 + 自动派单',
  x_31439e52: '骑手注册 · GPS 实时追踪 · 按距离+空闲自动派单 · 60s 接单倒计时',
  x_50e8efc4: '生日 WhatsApp 自动祝福',
  x_a8701246: '每天 09:00 扫描客户生日 · 自动发祝福 + 折扣码 · 0 成本复购',
  x_157c7c85: '节日群发 + 排程',
  x_abe4ae61: '圣诞/母亲节/情人节一键群发 · 定时排程 · 国家节日列表 · 历史记录',
  x_1eb970e4: '促销活动',
  x_aef63132: '折扣 · 满减 · 买赠 · 限时秒杀 · 按分类/单品配置',
  x_a1336484: '积分商城',
  x_193aa1e3: '顾客用积分兑换优惠券、礼品或余额充值 · 限时抢兑',
  x_9a3ebc32: '💼 后台管理',
  x_83d7870e: '多仓库 + 调拨',
  x_5ca33875: '多仓库 · 调拨创建自动扣源仓 · 签收差异自动登记报损 · 在途追踪',
  x_b3184a0c: 'P&L 报表（USD/Bs 分离）',
  x_387e4ccd: '毛利 · 开支 · 损耗 · 汇兑收益 · 各币种独立显示',
  x_41cdb401: '分店现金管理 + 防呆',
  x_7c6e4907: '实时 USD/Bs 余额 · 大额 (>10万 Bs / $1k) 必须二次确认 · 防误录',
  x_4bb41a3f: '班次交接',
  x_12e3a178: '现金清点 · 客户签字 · 面额清单 · 自动 WhatsApp 发老板',
  x_7be86c2c: '员工账务 + 考勤 + 工资单',
  x_50fa2355: '借款 · 赊货 · 还款 · LOTTT 第106条合规 A4 工资单',
  x_8ddf6808: '审计日志 + 库存稽核',
  x_4d5169cd: '高风险操作全记录 · CSV 导出 · 夜间自动比对 product.stock vs 仓库实际',
  x_c97dba40: '🤖 AI 加持',
  x_6d06e53e: 'AI 商品图美化',
  x_8ed5fef6: 'Gemini Nano Banana 一键去背景 + 商品图美化 · 批量处理 · 可还原原图',
  x_b94b644f: 'AI 聊天助手',
  x_df5fb097: 'GPT-5.2 客服 · 自动回答商品/库存/订单状态 · 24/7 在线',
  x_4ec4a23d: 'AI Pago Movil 验证',
  x_56c6972a: '截图 AI 自动识别金额/日期/参考号 · 收银员一键审核 · 防伪造',
  x_32a15937: '条码自动建商品',
  x_875fae32: '扫码或输入条码 · 自动查全球商品库 (Open Food Facts / UPCitemdb) · 0 手工录入',
  x_10899d94: '🌍 多国适配',
  x_ee7818c0: '8 个国家自动配置',
  x_77a6000a: '🇻🇪VE · 🇨🇴CO · 🇧🇷BR · 🇿🇦ZA · 🇩🇴DO · 🇨🇷CR · 🇹🇹TT · 🇵🇦PA · 自动汇率/语言/支付通道',
  x_9dd027aa: '4 语言切换',
  x_f6cbc1ec: '中文 / English / Espanol / Portugues - 一键切换',
  x_e3c6859e: '双币结算 + 实时汇率',
  x_6cb9867e: 'Bs/USD 任意切换 · BCV 官方 + 黑市汇率 · 一键切换报表币种',
  x_863683ad: '为零售业打造的智能 POS',
  x_e1828ed2: '覆盖 7 大行业 · 4 语言 · 8 国市场',
  x_3665550b: '餐馆 · 快餐 · 服装 · 烘焙 · 药店 · 美容 — 行业模板一键启用 · 7 天免费试用',
  x_cd1ce731: '立即免费试用',
  x_0d2a321f: '已有账号？登录',
  x_7bf86a2a: '全部功能',
  x_e539f895: '30+ 功能覆盖收银、库存、配送、营销、AI · 注册即享',
  x_6a4ab7b8: '立即注册',
  x_660d93f4: '7 天免费体验所有功能，无需付费 · 可选 7 大行业自动配置',
  x_5a631c6c: '新',
  x_402d19e5: '登录',
  x_9ceb77bb: '三语支持 · 双币结算 · 7天免费',
  x_021782de: '语言支持',
  x_81ea4b71: '云端运行',
  x_1d3ba50c: '数据安全',
  x_2e525185: '支持任何设备',
  x_0ec9d3c3: '电脑、平板、手机均可使用',
  x_1cfc09aa: '注册即享全部功能',
  x_8e046e99: '为多元化商家打造',
  x_d48f3735: '零售店铺',
  x_926a9ffe: '超市、便利店、杂货店、服装店等均适用',
  x_cff3dc29: '批发业务',
  x_5087d5ee: '支持批发价格体系、大客户管理、应收账款',
  x_ce98716f: '连锁门店管理',
  x_320fd2de: '总部统一管理多个分店，商品库存互通调拨，各店独立收银和报表',
  x_605629af: '普通店',
  x_14079459: '✨ 自动建 7 个菜单分类 + 10 张桌子 + 服务费 10%',
  x_02d470b4: '✨ 自动建 8 个服装分类 + 尺码颜色变体',
  x_19c60018: '通用零售模式 — 不预设分类，自己创建（适合 90% 生意）',
  x_a93d885f: '推荐码（选填）',
  x_fefc4fec: '使用推荐码注册可获得额外30天试用',
  x_87417e71: '🏢 行业',
  x_f134be36: '离线无法登录 - 请先联网登录一次',
  x_80745991: '前台收银',
  x_29ee0354: '收银员专用 - 登录后直接进入收银台',
  x_2443e297: '进入收银台',
  x_de094deb: 'Instalar App / 安装应用',
  x_ea90083b: 'Abre en Chrome para instalar / 用Chrome打开可安装',
  x_11afe095: '扫描商品条码',
  x_570e1531: '把条码完整对准绿框 · 距离 10-20cm',
  x_58faba06: '无法访问摄像头，请检查权限',
  x_bec7e4d6: '切换',
  x_17e423b0: '闪光灯',
  x_a4c59470: '点击画面手动对焦',
  x_3c43c899: '💡 让条码充满绿框，保持稳定 · 过近会模糊',
  x_5f031153: '📵 该设备不支持闪光灯',
  x_22867dc5: '重扫',
  x_lbl_created: '创建',
  x_lbl_rejected: '被拒',
  x_lbl_reason: '原因',
  x_lbl_operator: '操作人',
  x_lbl_total: '合计(件)',
  x_lbl_notes: '备注',
  x_80a36145: '✅ 已自动同步',
  x_1eec1e2e: '个之前网络中断的结班操作',
  x_e85b2d54: '个离线商品已同步',
  x_8cc59319: '订单同步成功',
  x_fad33691: '订单同步失败:',
  x_1fa61c48: '张历史被拒订单已自动重新提交 / pedidos recuperados automáticamente',
  x_73ae77ff: '离线模式 - 使用缓存数据 (',
  x_8ae9eaca: '更新)',
  x_57fa0696: '- 已调出 (',
  x_49ae0e5e: '项)',
  x_4068bc35: '⬆️ 结班前先上传',
  x_7b697750: '张待同步订单…',
  x_cdc0393e: '⚠️ 还有',
  x_960c577f: '单未能上传（已保存在本机，联网后自动补传）',
  x_4094833e: ', no más / 库存不足',
  x_b7b8517c: ', máximo / 库存不足',
  x_6f630d34: '🥡 取餐 #',
  x_edb823f2: '❌ 找不到商品:',
  x_45524982: '单已导出到下载文件夹',
  x_498458a5: '✅ 今日汇率已设为 Bs',
  x_5ec06103: '（仅本机）',
  x_c6615916: '天前',
  x_bb39a0c6: '小时前',
  x_9021c675: '📤 已导出',
  x_1eab1ec2: '单 到下载文件夹 (USB 可复制)',
  x_634abe29: '✅ USB 导入完成:',
  x_b359a569: '新增 ·',
  x_3af4ed2f: '已存在 ·',
  x_7030ff64: '错误',
  x_c6e4b6a0: '班已开',
  x_e7a7a7e2: '小时未交班 — 立即交班以避免跨日对账混乱',
  x_73559114: '小时，建议尽快交班 / Turno abierto hace',
  x_e2efd3fa: '⬇️ 新版 v',
  x_2d455ce5: '下载中',
  x_51a8f63f: '🔄 新版 v',
  x_c540ce8f: '已就绪 · 关闭软件自动安装 ·',
  x_4c4d6a98: '📡 没有网络 —',
  x_922a9dca: '单已安全保存，联网后自动上传 / Sin red, se subirán automáticamente',
  x_8d1c5588: '⬆️ 正在上传',
  x_6479a0a7: '单... / Subiendo',
  x_a53de3a7: '• 过期后,定金归商家',
  x_c0cd0f67: '换货信用已激活 / Credito de cambio:',
  x_bc4e851c: '确定停用',
  x_9cd30436: '？\\n停用后商品从 POS / 网店消失，但库存与历史订单保留，随时可重新启用。',
  x_47bf13b6: '将对',
  x_c9729ffc: '个商品做 AI 抠图白底，每个扣 1 点 AI 学分 (共',
  x_69db7ae0: '点)。继续?',
  x_c70a3c01: 'AI 抠图完成: 成功',
  x_114d9700: '/ 失败',
  x_8cac6775: '张图片匹配成功',
  x_5d459d55: '处理中',
  x_1e1445b3: '开始抠图 (',
  x_6242f731: ') · 扣',
  x_be604f8b: '点',
  x_2ecbd077: '📱 链接已发到老板 WhatsApp ...',
  x_3a17aa8e: '链接已发送!\\n\\n',
  x_fa407236: '\\n\\n按 OK 复制链接到剪贴板',
  x_cbcbd4e6: '确认批量调价？',
  x_1b92092d: '已更新',
  batchNoMatch: '⚠️ 所选分类下没有商品, 未做任何改价 — 请换一个分类',
  orderShift: '班次',
  viewShiftReport: '查看交班记录',
  shiftOpenBadge: '营业中',
  shiftClosedBadge: '已交班',
  batchAllSkipped: '⚠️ 0 件更新: 所选商品都没有成本价, 请先录入成本',
  x_8c533c4a: '⚠️ 商品已存在:',
  x_d8172b79: '✅ 已预填:',
  x_162d92be: '— 填好价格保存即可',
  x_82978490: '储值卡已扣',
  x_955e88ca: '· 余额',
  x_d43bd196: '离线保存:',
  x_eeb31a4e: '(上线后自动同步)',
  x_41c5ecd6: '超过',
  x_ed87d0af: '安全阈值。\\n\\n请再次确认金额是否正确？',
  x_94d22b13: '⚠️ 注意:\\n\\n实发现金:',
  x_741ca864: '(很小)\\n抵扣欠款:',
  x_1a079931: '\\n抵扣后还欠:',
  x_e93a7373: '\\n\\n是否确认?\\n• 按 [确定] → 按上面金额发放\\n• 按 [取消] → 把整笔工资',
  x_4f2bb016: '都抵扣欠款 (实发',
  x_6e11eb39: '已重设: 扣除',
  x_9de6f844: ', 实发',
  x_8800e34b: '- 扣除',
  x_569ff68a: '= 实发',
  x_48eb726e: '发工资成功: 实发',
  x_4c117f20: '订单',
  x_f6348db9: '找到订单:',
  x_692d69b4: '件商品,',
  x_3b5e93d8: '标记为【全天】\\n\\n按全天计算工资。\\n确定?',
  x_1f623127: '标记为【半天】\\n\\n按半天计算工资 (50%)，缺勤部分自动记入欠款。\\n确定?',
  x_0064a575: '标记为【旷工】\\n\\n系统将自动把 1 天工资记入欠款！\\n确定?',
  x_dc49966b: '💰 已记入欠款',
  x_e897afe2: '确认给以下员工发薪？\\n\\n',
  x_87c3b869: '\\n\\n共',
  x_465afe3c: '人',
  x_70e23b2c: '发薪 -',
  x_a657f46f: '周',
  x_247b6518: '已发薪',
  x_d051c48c: '人失败',
  x_59cf15fe: '模板',
  x_1463e88d: '已应用',
  x_d846c018: '公司欠',
  x_b52d1753: '存款余额：',
  x_6a34412a: '\\n\\n输入要支出的金额（留空= 全部',
  x_5f3fd382: '金额必须',
  x_f3221016: '0 且 ≤',
  x_c66b7456: '✅ 已支付',
  x_37186b95: '给',
  x_92ff3137: '最大抵扣 (= min(工资,欠款) =',
  x_ff06778b: '单)',
  x_9d074fc7: '📱 已发送到',
  x_be509224: '个手机 · 逾期',
  x_e6c92b78: '· 即将到期',
  x_59359c92: '确认要给所有逾期/即将到期的客户发 WhatsApp 催款提醒吗？\\n\\n（同一客户 7 天内只发 1 次，不会重复打扰）',
  x_03e25cc4: '✅ 已发',
  x_f6614467: '条客户提醒（跳过',
  x_6eb87074: '条 · 失败',
  x_feebfd78: '条）',
  x_a80efbb5: '未发送（共',
  x_60c5bacd: '条记录，跳过',
  x_fcc7ee2d: '，失败',
  x_7e1fefa7: '）—— 检查客户是否有手机号 + 订阅',
  x_88fe7ca5: 'A4 完整对账单 ·',
  x_fe78a84f: '80mm 小票 · 仅支付摘要 ·',
  x_758ec925: '最多',
  x_cf4a812f: '合计 / Total:',
  x_f7edf5ac: '件',
  x_2c117f7f: '✓ 已复制单',
  x_01d7aa49: '的',
  x_4e4008f8: '个商品，请选择目的店',
  x_53952782: '确定要取消调货单',
  x_26671096: '吗？\\n\\n取消后库存将退回源仓库',
  x_128b1e7c: '桌',
  x_2e3a36de: '分钟前',
  x_2de0d491: '小时',
  x_73c826e5: '✅ 充值成功 · 新余额',
  x_7e2720b4: 'Cliente / 客户:',
  x_a423e73c: 'Fecha / 日期:',
  x_1a608891: '天到期',
  x_182da4c4: '💳 支付记录 / Pagos (',
  x_24d9bec1: '⚠️ 今日汇率上涨',
  x_2e29f312: '% — Bs 收款按今日汇率折算（金额比锁定时少）',
  x_b1848125: '✅ 今日汇率下跌',
  x_be793e09: '% — Bs 收款按今日汇率折算（金额比锁定时多）',
  x_d6420ec0: '— 最后更新',
  x_603f7892: '⬆️ 立即上传 (',
  x_d6f5f3c9: '🚫 处理被拒订单 (',
  x_365c6e84: '🔄 Credito de cambio / 换货信用 $',
  x_cd600b9e: '），换算 Bs 可能偏差大',
  x_b61b86ae: '单待同步',
  x_4827c1f8: '单被服务器拒绝（未入账）',
  x_ff503ba7: '（当前 Bs',
  x_7d68b4e3: '当前:',
  x_2be10f11: 'POS 里此商品数量 ≥',
  x_41ae38b5: '匹配成功:',
  x_13ddc197: '已选 · 仅勾选有图片的商品',
  x_bec8b787: '时自动切换价格2',
  x_74714605: '🛒 零售 Retail —',
  x_bb255d74: '🛒 零售：',
  x_f84bb79f: '🏭 批发：',
  x_530afc78: '% 返利',
  x_30f580f1: '折扣 / Descuento',
  x_06772a76: '积分抵扣 / Puntos (',
  x_66525fb9: '原价 $',
  x_ae89baf7: '🛡️ 最多',
  x_f93a3192: '⚠️ 已达最大折扣（成本 $',
  x_98e21b6a: '余额不足支付 $',
  x_f2c67994: '将扣款 $',
  x_b682eb31: 'Vence / 到期:',
  x_dcbed21c: '% (成本保护)',
  x_9f93459b: '，不可再降否则亏本）',
  x_64e6defd: '· 余额 / Saldo:',
  x_2a7a6a6b: '→ 应付 $',
  x_128029c2: '· 剩余 $',
  x_eeedcd26: '💵 提取存款 / Retirar $',
  x_aedc526b: '扣',
  x_41cbd47f: '发薪 (',
  x_a71e4358: '暂无模板。排好班后点「',
  x_0d2fb245: '」保存为模板',
  x_4ce4ef96: '息',
  x_b4ebe3f5: '没有',
  x_25aa5d7d: '/ 请先添加',
  x_fbd2b1fb: '共',
  x_2187d87a: '单 · 已收 $',
  x_cc09dc10: '规格:',
  x_a0d921b3: '(短缺',
  x_c37f6a62: '桌位 QR 码 · 共',
  x_914e2a75: '下载所有桌海报 ZIP (',
  x_6499fc74: '张',
  x_c2c92c19: '张)',
  x_e93c8f7b: '占用 · 当前总额 $',
  x_87ba5064: '充值 $',
  x_31180e95: '加载出错:',
  x_36ea3e81: '待收 $',
  x_fdf80fc9: '收 $',
  x_b34de51a: '已付 $',
  x_0c6c45ae: '付款记录 / Pagos (',
  x_e3bc8fa5: '折算 USD（今日 Bs',
  x_7f4bb1d6: '天宽限',
  x_48b0dec0: '· 余 $',
  x_27720067: '✕ 清空',
  x_8decf585: '💱 手动设今日汇率',
  x_80272374: '📥 导出今日离线总结',
  x_b2abad7a: '📤 USB 导出全部',
  x_68771e30: '📥 USB 导入',
  x_7ca39c26: '立即交班',
  x_2ce5a620: '这些订单同步时被服务器拒绝，',
  x_d8e901bc: '0 时用黑市，否则用BCV',
  x_f47fc941: '— 点右侧按钮查看原因并处理',
  x_1faae5c2: '批量改价',
  x_ee2b9ce1: '📷 扫码新增',
  x_d0c1006c: 'Al cobrar imprime el recibo automáticamente y queda listo para la siguiente venta (sin diálogo de impresión). Pago Móvil/Transferencia siguen mostrando verificación. / 收款后自动打印小票、直接开始下一单（Pago Móvil/转账除外）',
  x_f3131239: 'Al cobrar en USD (efectivo/Zelle), el POS suma automáticamente 3% de IGTF y lo imprime en el recibo. / 收美金时自动加收3% IGTF税并打印在小票上',
  x_f09933aa: '看不到新按钮？点一下这里 → 系统自动清理旧缓存 → 立即加载最新版本。',
  x_f40cbd21: '提醒所有员工点这个按钮后，全员 5 秒内自动同步到最新版本',
  x_3a04c76e: '• 库存为 0 或负数时，POS 仍可结账',
  x_8250b510: '• 库存会变成负数（如 -5 表示欠货 5 件）',
  x_121b783a: '• 适合：实物在店里但系统库存不准、批发常预售、刚上新品未录库存',
  x_4fbdd3a8: '• ⚠️ 注意：请定期去',
  x_694ccb6b: '• 库存不足时 POS 拒绝下单',
  x_959932ab: '• 防止超卖、防止数据乱',
  x_f34c6c1f: '页盘点，把负数清掉',
  x_59637fe6: '页把数量调对，或临时打开此开关',
  x_684ee9b5: '强制更新到最新版本',
  x_140d6e9a: '🔄 一键强制更新',
  x_32415951: '客户赊账',
  x_85fc0b89: '员工赊货',
  x_vale_label: '购物券',
  x_vale_placeholder: '扫码 / 输入券号，回车',
  x_vale_apply: '用券',
  x_vale_applied_ok: '已抵扣',
  x_vale_forfeit: '券面值大于消费，多出部分作废：',
  x_vale_earned_title: '客人获得购物券！',
  x_vale_earned_rule: '本单满',
  x_vale_valid_until: '有效至',
  x_vale_later: '稍后',
  x_vale_print: '打印券给客人',
  x_f676b12b: '储值卡支付',
  x_d5109b1f: '📱 汇总发给老板',
  x_f6a5aaac: '🔔 催款发给每个客户',
  x_e87e3fba: '⏳ 待同步',
  x_c66a65a3: '💵 必须用美金支付 / Solo USD — 不可用 Bs 还款',
  x_4ef6283c: '失败·需处理',
  x_7ab62e2e: '下面这些商品在源仓库的库存不够。请选择如何处理：',
  x_f75eee5f: '✅ 仍然继续调货 / Continuar (允许负库存)',
  x_58c10a18: '✏️ 自动调减到可用数量',
  x_9cc890a7: '取消',
  x_c16cdc6d: '🎨 美化海报',
  x_cbdcabad: '释放',
  x_1b8de39d: '⚙️ 自动「桌位选择 → 挂单」UI 集成下一轮做。当前先用挂单备注关联。',
  x_5b3aaade: 'ℹ️ 打印后裁切，护贝粘到每张桌面 — 客人扫一下就进自己桌的点餐页（自动选好桌号）',
  x_7559ce8e: '🎨 桌位海报 · Branded Posters',
  x_2601cd44: 'ℹ️ 海报尺寸 A5 (1240×1748 @ 200 DPI)，含店名顶栏 + 桌号徽章 + 大 QR + 多语言宣传语 + 联系方式底栏。',
  x_81567a16: '印刷店打印后裁切、护贝、贴在桌上即可。客人扫码 → 自动进点餐页 → 桌号已填好。',
  x_7be49895: '📱 桌位 QR',
  x_727c86c9: '加桌',
  x_fbac2d7f: '直接打印',
  x_c12a29c0: '下载 ZIP (每张单独 PNG)',
  x_46c8a671: '发售新卡',
  x_e50663b2: '充值',
  x_79d3abe9: '复制',
  x_b1fe43e8: '。请把它们写到实体卡片上 / 打印小票交给客户。如果卡丢失，需要客户出示卡号+PIN 才能查询/使用。',
  x_fd924ff0: '留货管理',
  x_f20ccb10: '没有 aparta 记录',
  x_e8606af7: '确认取消',
  x_45f2c9a0: '到期',
  x_616c68e6: '规则设置',
  x_132c5cdc: '重试',
  x_5c52b0fd: '7 天内到期',
  x_12aabd94: '已逾期',
  x_ad3cd23a: '打印票据',
  x_1cb2b4b8: '取消订单',
  x_fix_bulk_hint: '（网店会显示"散称"标签，顾客可买 0.5 / 1.8 等小数）',
  x_fix_otherwh_hint: '其它仓库（只读，请用库存调整或调货管理修改）',
  x_fix_upload_hint: '个文件，点击"开始上传"由服务器按编码自动匹配',
  x_fix_rejected_hint: '请核对原因：如是重复单请删除；如是真实收款请点"重新提交"。',
  x_fix_guestwifi_tip: '建议用路由器的"访客网络"(Red Invitado)设置2分钟自动断线。',
  x_cd509648: '搜索商品...',
  x_26b5bd49: '加载中...',
  x_d5faf486: '店铺不存在',
  x_a8b0c204: '全部',
  x_e3a7209e: '暂无商品',
  x_1bd84635: '新鲜食品 每日优选',
  x_663af409: '美味佳肴 在线点餐',
  x_c76203b6: '百货精选 应有尽有',
  x_9450139e: '健康生活 用心呵护',
  x_fb289d60: '新鲜烘焙 香气四溢',
  x_13f0b75a: '时尚服饰 品味生活',
  x_a6ef79b6: '科技好物 尽在掌握',
  x_a03f1a4b: '新鲜肉类 品质保证',
  x_21f9dcf0: '在线购物 送货上门',
  x_54e5de42: '上传失败',
  x_18e80613: '商家未配置 WhatsApp 号码',
  x_aed1dfbc: '中',
  x_b71301e1: 'Elegir / 选择',
  x_0288e6a2: '浏览器不支持 GPS',
  x_12cffd73: '📍 正在定位...',
  x_48b05582: '✅ 已记录您的位置, 骑手能更准确送达',
  x_9ccbd711: '无法获取位置, 请手动填地址',
  x_2f6911f3: '已记录我的位置 ✓',
  x_1499f061: '用我当前位置 (送货更准)',
  x_dc715bb8: '确认订单',
  x_0d0bc2bc: 'Copiado / 已复制',
  x_dac8225e: '请选择规格 (尺码/颜色/口味)',
  x_9f9cbc48: '🥬 Por kg · 散装 (0.5',
  x_7f6e80a6: '点击下方"确认订单"',
  x_27c05b27: '系统会自动打开 WhatsApp 并预填订单详情，您只需发送即可与商家联系付款方式。',
  x_3a9be7db: 'Enviar pago a / 请转账到：',
  x_f65ce56a: 'Banco emisor / 银行',
  x_ed4ea468: 'Tel. emisor / 发送人电话',
  x_bb58400a: '查价',
  x_619fd86c: '输入商品名/条码...',
  x_1d7a5330: '未找到商品',
  x_fb852fc6: '进行中',
  x_cd8c77d3: 'Completada / 已完成 ✅',
  x_2111ccbb: '已取消',
  x_6a0abbb7: 'Vencida / 已没收 ⚠️',
  x_1ea78d47: '留货单',
  x_ff0b2077: '客户',
  x_6ffe81e2: '总额',
  x_57b642fc: '已付',
  x_931f1f80: '待付',
  x_9897d884: '商品',
  x_474cd02d: '付款',
  x_b0fae043: '规则',
  x_499b9a62: '到期日',
  x_8c1bc4ba: '期限',
  x_98ffc82c: '最低定金',
  x_82188307: '如未在期限内付清,定金归商家所有',
  x_e2eb6313: '请到店付款',
  x_6f83193b: '客户签名',
  x_e9bd1d12: '已接受条款',
  x_c281ff84: '未接受条款',
  x_affa4d0e: 'Cargando... / 加载中...',
  x_c6dd0ab3: '• 如未在期限内付清,定金归商家所有',
  x_8deff26f: '随手拍',
  x_866b795e: '加载失败',
  x_7683487f: '✅ 完成,继续下一个',
  x_82bae6ba: '搜索名字/代码/条码',
  x_bbd24cc2: '📷 拍照',
  x_2a3114f2: '🔄 替换',
  x_c0588fd1: '您拒绝了相机权限。请在浏览器设置里允许相机。',
  x_efb8ad19: '没找到相机设备',
  x_c9ece2f8: 'AI 美化失败,可直接用原图',
  x_d1f9b309: '保存失败,已保留原图',
  x_8705e16b: '仅老板和经理可用 / Solo admin/manager',
  x_77dbf376: '📸 随手拍',
  x_42eae5c2: '所有商品都有图了!',
  x_d2a53af5: '暂无可替换商品',
  x_3fe62d01: '先搜索您要替换的商品',
  x_5fbe1b26: '正在拍照...',
  x_36152aa9: 'AI 美化中...',
  x_bfeacb2a: '~15 秒',
  x_95d9b747: '📸 原图',
  x_3fb7e372: '✨ AI 美化(白底)',
  x_3f981012: '推荐',
  x_997c7a5d: '功能',
  x_6adafe27: '行业',
  x_a95dd3e1: '技术',
  x_d38a089e: '联系',
  x_402d19e5: '登录',
  x_248f81e2: '免费试用',
  x_3ab22098: '云端POS系统',
  x_e06f69f5: '让你的生意',
  x_cc15c20a: '更上一层楼',
  x_2852a028: '全面掌控你的商店、餐厅或药房。多币种 USD/VES，电子发票，离线可用。',
  x_dd88cfbf: '免费试用7天',
  x_8a81d8ca: '查看功能',
  x_b52b8c1f: '安全稳定',
  x_d255512b: '多币种 USD',
  x_1d8d47a1: '自动验证 Pago Móvil',
  x_84b0b2a1: '离线可用',
  x_6fcc5a76: '云端安全',
  x_0cee3341: '活跃商户',
  x_55131659: '日交易量',
  x_b67495ee: '在线率',
  x_f0fbeece: '技术支持',
  x_176ca494: '一个系统满足所有需求',
  x_b4fa6629: '从快速收银到智能报表，Sellox拥有助力你生意增长的每一项工具。',
  x_f1c5a568: '极速收银',
  x_adc03f83: '智能搜索、条码扫描、键盘快捷键，秒级完成销售。离线也能用。',
  x_c0c97799: '实时库存',
  x_40483407: '实时库存、套餐组合、低库存预警、多仓库调货。',
  x_3c1a2842: '智能报表',
  x_1aa9589f: '销售、利润、热销商品和套餐分析，一键查看。',
  x_ab572bf7: '分单支付',
  x_c677e641: '一笔交易接受多种支付方式：现金、银行卡、转账。',
  x_42081db9: '客户忠诚度',
  x_a1c08c39: '积分计划、会员等级、按客户类型设置特别价格。',
  x_3f70a475: '票据打印',
  x_f5fbde12: '兼容主流热敏打印机（Bixolon, HKA），支持收据+发票双打印。',
  x_47acae77: '连锁总部管理',
  x_ae346bda: '多门店业绩总览、跨店库存查看、统一调价、B2B客户授信管理。',
  x_9eb1059d: '智能补货',
  x_77e17012: '自动分析销售速度，预测断货时间，生成补货建议清单。',
  x_c14027b7: '适配你的业务类型',
  x_0c5bd351: '零售',
  x_e37fda71: '商店和零售',
  x_1752dd18: '全面的库存管控：低库存预警、条码扫描、客户分级定价、价签打印和供应商管理。',
  x_9d39de37: '条码扫描',
  x_8bc3ace8: '分级定价',
  x_a297a148: '多仓库库存管理',
  x_9e4e8242: '套餐和促销',
  x_37346312: '价签打印',
  x_faeff5ef: '超市',
  x_87dc671e: '超市和便利店',
  x_312dc180: '高效处理大量交易，集成电子秤、条码扫描、多收银台并行和保质期管理。',
  x_3e6c0601: '高频交易处理',
  x_73b2dfdf: '多收银台并行',
  x_b4157847: '电子秤集成',
  x_e9bb592c: '保质期管理',
  x_58936f4b: '批发和零售价格',
  x_2a0ad6ff: '餐饮',
  x_d2010d15: '餐厅和咖啡店',
  x_26b82bf3: '桌台管理、厨房小票、菜品备注、小费和分单结账，一站式平台。',
  x_450fec16: '桌台管理',
  x_58adcc1a: '厨房显示/打印',
  x_8c1b8588: '分单结账',
  x_6c7083d9: '自动小费',
  x_537efc66: '外卖订单',
  x_53b4b807: '美容',
  x_98a53972: '美发和美容院',
  x_24fbec85: '预约管理、客户服务记录、员工提成和会员忠诚度计划。',
  x_220e22c6: '预约管理',
  x_9c4df083: '员工提成',
  x_b78043c0: '客户档案',
  x_cc98eba1: '积分计划',
  x_cceccce5: '自动提醒',
  x_068d9237: '有网没网都能用',
  x_495aee53: '为委内瑞拉设计。断电断网，POS照样运行。',
  x_f0527d8a: '数据自动备份，任何设备随时访问。',
  x_4a61c29a: '离线模式',
  x_b5b0394e: '断网照常销售，联网后自动同步数据。',
  x_b0404c0b: '智能同步',
  x_ad79d5c5: '数据保存在本地 IndexedDB，即使断网数天也不丢失。',
  x_30504e20: '多设备支持',
  x_6d6042f2: '电脑、平板、手机都能用，界面完美适配各种屏幕。',
  x_f3de96c1: '电脑作为主收银台',
  x_a123f815: '手机随时查看销售数据',
  x_18e45612: '多终端同时在线',
  x_2ed39222: '员工',
  x_9c7d7a67: '无限',
  x_654522d2: '币种',
  x_97b835a4: '可用性',
  x_17927e12: '完整功能',
  x_a8b6d749: '比任何POS都全面',
  x_ac84ee55: '电子发票',
  x_bdb58c39: '自动汇率更新',
  x_8242ec7e: '会员忠诚度计划',
  x_3e751fda: '套餐和组合',
  x_bb84d6ea: '订单备注',
  x_b612cf7a: '班次管理',
  x_dbc12902: '热敏静默打印',
  x_e81ee1fe: '多仓库管理',
  x_87821b0d: '销售报表',
  x_46756e70: '利润分析',
  x_c791eec3: '供应商管理',
  x_f5a29430: '采购控制',
  x_8cca9955: '在线商城',
  x_93befa62: '线上订单',
  x_9f08dc32: '虚拟店铺',
  x_be37ebc5: '退货和退款',
  x_baa125c4: '跨店库存',
  x_42b52276: 'B2B客户管理',
  x_b9ee7355: '智能补货建议',
  x_d4d37b95: '销售速度分析',
  x_46cf89f9: '断货预测',
  x_ebff97ec: '员工借款/赊货管理',
  x_28d629c1: '考勤打卡系统',
  x_67580600: '自动工资计算',
  x_a4e9168d: '节日日历(1.5倍工资)',
  x_cb4588c2: 'AI Pago Movil验证',
  x_f348c3f7: '换汇管理(买美金/刷卡换现金)',
  x_4e3c5d06: '采购订单管理',
  x_52f264a7: '班次现金清点',
  x_28f364b2: '多价格模式(零售/批发/整箱)',
  x_7253b11c: '离线PWA订单',
  x_df5a934f: '准备好让你的生意',
  x_47db59fb: '更上一层楼？',
  x_267335fb: '加入委内瑞拉数百家信赖Sellox的商户。',
  x_2673904b: '免费开始',
  x_65300d22: '无需信用卡，5分钟完成设置。',
  x_1a69cc94: '立即开始',
  x_4d9b70e1: '效率提升',
  x_0e9fd989: '价格',
  x_a7bac223: '中文',
  x_a132c42f: '下载 Windows 版',
  x_a825a5b0: '有问题？问',
  x_92248c47: '客服 或',
  x_c984d4fd: '✨ 最新 AI 功能',
  x_01ff215e: 'AI 帮您做生意',
  x_f5299c8e: 'Nano Banana 美图',
  x_7fa9308c: '手机拍的模糊产品照一键变专业图 (Gemini Nano Banana)',
  x_e9a8de17: 'WhatsApp AI 营销',
  x_ed2f6b2f: '自动生日祝福 + 节日营销 + 四语回复（中英西葡）',
  x_576c046d: '语音收银',
  x_8f395150: '说"加 3 个可乐"即可下单 (Whisper STT)',
  x_99d6e6c1: 'AI 管家',
  x_627f661f: '每晚自动分析销售，给您明天的备货建议',
  x_1f7b6ef8: '多国汇率',
  x_d1529f52: '实时 BCV + Paralelo + Frankfurter 自动更新（7 国支持）',
  x_c0373da5: '年费包含云端服务器、自动备份和系统更新 — 门店越多，云端用量越大。',
  x_3a80619c: '不确定哪个功能适合您？问',
  x_5d6e903d: '客服，或',
  x_423811c2: '简单套餐，全部功能',
  x_86cb3a40: '无隐藏费用，随时可取消。先免费试用 7 天。',
  x_55b728d1: '最受欢迎',
  x_890e3707: '基础版',
  x_f9205ad4: '商户版',
  x_94ac1fb3: '企业版',
  x_5ad3f664: '年 云端+维护费',
  x_a3e93bd5: '✅ 自动验证 Pago Móvil 到账',
  x_8242103b: '多币种 USD/VES + 自动汇率',
  x_b7815b8e: '离线可用 + 云端备份',
  x_af2ed285: 'WhatsApp 客服支持',
  x_dc65864a: '🛒 含网店（线上商城）',
  x_01efcb04: '不含网店',
  x_7a5eaa76: '需要开通或续费？联系',
  x_49707f5f: '有疑问？',
  x_b69517e9: '客服 /',
  x_2f312b31: '原始$',
  x_c87b05f9: 'Tienda / 门店:',
  x_d6b71ccb: 'Todas / 全部门店',
  x_91c1ffb2: 'Bs/BCV (政府汇率拿货)',
  x_06510ba7: '件库存',
  x_12448e37: '成本:',
  x_6c694f7b: '零售:',
  x_b0c1f4e6: '原始$ (黑市拿货)',
  x_450efd2f: '合计',
  x_f6f1d40b: '总成本:',
  x_724210ee: '总零售:',
  x_61406e63: '利润空间:',
  x_652be256: '分类明细',
  x_d0771a42: '分类',
  x_f0789e79: '模式',
  x_040dd10a: '商品数',
  x_0eac8802: '库存',
  x_671e045d: '成本$',
  x_4c5d80a5: '零售$',
  x_1fc64a84: '利润$',
  x_bd4357f9: '全天',
  x_c31b1b99: '半天',
  x_02efd8b1: '旷工',
  x_3cdcbdf0: '已取消节日',
  x_15dd9319: '已设为节日 (双倍工资)',
  x_2a2338ae: '考勤管理',
  x_583cc547: '总员工',
  x_1c6f494e: '已打卡',
  x_a7da9234: '门店',
  x_93849f29: '今日考勤',
  x_87bd8d0d: '节日日历',
  x_3ccfeac0: '打卡记录',
  x_464f3d4e: '角色',
  x_b4f0388f: '上班',
  x_96ed60cd: '下班',
  x_3fea7ca7: '状态',
  x_6bc72d59: '未打卡',
  x_f5360872: '点击日期标记/取消节日，节日上班算1.5倍工资 (LOTTT)',
  x_8fb52fe0: '已预填法定节日',
  x_a7a9b5d0: '个新增',
  x_9087937f: '预填2026法定节日',
  x_29a98994: '本月节日',
  x_046c6233: '最近',
  x_249aba76: '天',
  x_4ff1e74e: '日期',
  x_2b6bc0f2: '操作',
  x_19fcb9eb: '时间',
  x_676e5982: '操作员',
  x_b3755e33: '分店日报',
  x_0c9d2b45: '支付方式',
  x_c633a333: '预期',
  x_06f26e9d: '实际',
  x_5fdfbade: '差异',
  x_1f11f332: 'PIN 必须是 4 位或 6 位数字',
  x_6a6dfeb1: '两次输入不一致',
  x_7a6d647f: 'PIN 已保存',
  x_6de920b4: '保存失败',
  x_175377c0: '更改 PIN',
  x_cbbd1f37: '设置 PIN',
  x_2a33020e: '保存中...',
  x_fd7c0215: '请用 PIN 确认',
  x_b070fd2b: 'Boss WhatsApp PIN / 老板 WhatsApp 指令 PIN 码',
  x_66bff1f9: '用于通过 WhatsApp 确认改价、退款、删单等**危险操作**',
  x_44e60789: '已设置',
  x_fe2d26a2: '未设置',
  x_e81c6450: '已锁定',
  x_ed6c2836: '失败次数',
  x_1b87b102: '新 PIN (4 或 6 位数字)',
  x_df21533b: '确认 PIN',
  x_359986fb: '更新 PIN',
  x_6b08b3ce: '保存 PIN',
  x_8513ad10: '如何使用',
  x_32fa6a1b: '1. 白名单老板号码发 WhatsApp 到 Sellox 绑定的 Meta 号。',
  x_cb43e349: '2. 查询类（今日销售、库存、赊账）直接回复。',
  x_20f82d05: '3. 修改类（改价/退单/调库存/发催收）会回复"请用 PIN 确认"。',
  x_8f4e84c9: '4. 您只回复 4 位数字 PIN，5 分钟内有效，系统执行并回报。',
  x_1c3b9af4: '所有操作写入审计日志 (audit_logs)，5 次错误 PIN 自动锁定 15 分钟。',
  x_61f6d70f: '现金',
  x_798d879e: '卡数',
  x_3ed4a686: '转账',
  x_3dd2ecf9: '挂账',
  x_b0559b3d: '✅ 已生成预览',
  x_6a3a5ef0: '预览失败',
  x_3bd0272f: '请先填合伙人手机号',
  x_9ca6a344: '发送失败',
  x_ac52a991: '(未命名)',
  x_b93fce3d: '📆 每月 1 号',
  x_f493a608: '📅 每天 21:00',
  x_11e80f95: '全部',
  x_ba1a3a35: '发送中...',
  x_07d0b32a: '立即发送',
  x_2b5c1e95: '✅ 已保存',
  x_bec9ee92: '保存',
  x_fe56e486: '🤝 AI 发账目给共同老板',
  x_1c2e02ce: '尚未启用',
  x_2b05c552: '共同老板',
  x_e6f32bcc: '频率',
  x_7b03c3e6: '筛选方式(只报告这些):',
  x_2a0331b4: '上次发送:',
  x_6b4a51fc: '📬 AI 生成的消息',
  x_4c117f20: '订单',
  x_28866da4: '总额 USD',
  x_de742acb: '筛选 USD',
  x_3d9ffcbf: '🤝 共同老板账目设置',
  x_c716dbd4: '启用',
  x_149265c0: '共同老板姓名',
  x_0d0635b6: '他的 WhatsApp (含国码,格式 58XXXXXXXXXX)',
  x_ba2b6eee: '频率',
  x_6d5a3b51: '21:00 自动发',
  x_3253cde4: '1 号自动发',
  x_79218550: '只报告这些支付方式 (空 = 全部, 两位老板都看到这些方式的明细)',
  x_a41cf705: 'AI 语气',
  x_b19cbde8: '同时发给我 (另一位老板)',
  x_55aa6366: '更新成功',
  x_e2f2ba57: '✅ 启用',
  x_0031dd8b: '⛔ 停用',
  x_8ff8cf44: '🗑 回收站',
  x_47508121: '上限$',
  x_7acbbda8: '已设为零售',
  x_79c4a31e: '已设为批发',
  x_f17d31b7: '批发客户 (自动用批发价 P2 + 0.5pt/$1)',
  x_4c998309: '打印二维码卡',
  x_5fa802be: '操作失败',
  x_2ffea779: '停用客户',
  x_b2cdaef5: '重新启用客户',
  x_5c56a889: '停用',
  x_7854b52a: '启用',
  x_e5323bab: '移入回收站 (可恢复)',
  x_45f778d7: '✏️ 编辑客户',
  x_95e5011c: '例: 05-14',
  x_3df74976: '赊账',
  x_dd694c71: '🏭 批发',
  x_36cd3fdb: '🎂 生日 (MM-DD 或 YYYY-MM-DD)',
  x_e8228d38: '📱 WhatsApp (如不同于电话)',
  x_84a6c65b: '📨 订阅 WhatsApp 通知（电子收据 + 生日祝福 + 营销）',
  x_766084e7: '🏭 批发客户（低积分）',
  x_6f76107e: '👤 员工自用（低积分）',
  x_193fd90d: '🏭 批发 / 👤 员工 → 按批发积分比例（0.5 pt/$1）；不勾 = 零售（1 pt/$1）',
  x_2e0d8c60: '导出失败:',
  x_080e4cdb: '\\n请用打印按钮另存 PDF 替代',
  x_617fe407: '请允许弹窗后再打印',
  x_8b05bd24: '打印失败',
  x_402193e1: '\\n请改用"下载 PNG"按钮另存后打印',
  x_d2f8e650: '🖨️ 打印',
  x_20b916e7: '关闭',
  x_1f1edd2f: '🎨 主题色',
  x_2c3a24c3: '赚积分 享优惠',
  x_9954e58a: '扫我查看你的积分余额',
  x_27210b8c: '🎯 ¿Cómo funciona? / 怎么用？',
  x_70e4ea74: 'Abre la cámara de tu celular 用手机相机',
  x_f486f0e3: 'Escanea este QR 扫这个码',
  x_7baa65a2: 'Ingresa tu teléfono 输入你的手机号',
  x_b624f658: '¡Ve tus puntos! 看到你的积分！',
  x_dfdc6590: '💡 使用建议',
  x_5df80e61: '下载 PNG → 打印贴在**收银台 / 店门口 / 店内墙上**',
  x_106fdc25: '把这个链接发给熟客，让他们收藏 — 随时查积分',
  x_56f67f86: '也可以打印成 A4 小海报贴墙上',
  x_5972e86f: '客户扫码后输入 **手机号** 或 **客户编号**（如 C123456）就能查',
  x_049346a3: '🤖 AI 学分',
  x_fa6ec9d1: '💳 SaaS 月租',
  x_90b1c915: '👑 一次买断',
  x_712596c1: '🛠 年费维护',
  x_52e6abbe: '已复制',
  x_86516aa6: '收款币种',
  x_c1e2c9b2: '⚠️ Sandbox 模式',
  x_ed25395f: 'Live 生产模式',
  x_4f0bae34: '已到账(USD)',
  x_aeb63c16: '发票总数',
  x_fad5222c: '已完成',
  x_072ece17: '等待付款',
  x_28efb5bd: '超级管理员 — 加密收款总览',
  x_694fc5ef: '刷新',
  x_c459d386: '按业务分类',
  x_21efd88b: '暂无数据',
  x_d071be88: '最近发票',
  x_4787d633: '租户',
  x_226b0912: '类型',
  x_f9b45f5c: '金额(USD)',
  x_def802c1: '收到(USDT)',
  x_4572d0ec: '暂无发票',
  x_50de5a30: '已到账',
  x_74d3ba48: '= 状态为',
  x_1dea3af7: '且',
  x_92a99777: '的发票总和',
  x_bfa852da: '💡 客户付款后 5-15 分钟自动到 NowPayments → 自动转你的 TRON 钱包',
  x_730aa550: '💡 想看每笔具体明细,直接在',
  x_351912e9: '查',
  x_8c25dee1: '活力橙黄',
  x_3c683341: '海洋蓝绿',
  x_a45a3ac7: '清新绿色',
  x_46341dc6: '典雅紫金',
  x_e64084df: '现代黑金',
  x_db29972a: '网店推广二维码',
  x_32a67e3c: '生成精美海报，打印后张贴在店铺吸引客户扫码下单',
  x_e414473c: '打印',
  x_0657ba7c: '网店链接',
  x_6a9e5785: '送货上门',
  x_0060e3d3: '随时下单',
  x_f973aa04: '专属优惠',
  x_7864d864: '极速到达',
  x_68d89d0b: '商品齐全',
  x_ee79ba4c: '多种支付',
  x_72f59366: '不出门，好货送到家!',
  x_ccb69e71: '新客首单折扣 + 下单送积分!',
  x_dd35f3aa: 'QZ Tray 是免费的本地打印服务。安装后，网页可以直接发送打印指令到打印机，',
  x_227b88f4: '不弹出打印对话框',
  x_ee173ce8: '步骤',
  x_e1eb333e: '1. 点击下面按钮下载',
  x_ff7bbf67: '2. 下载 Windows 版 (.exe)，双击安装',
  x_a3c49496: '3. 安装过程一直点 Next（下一步）',
  x_e0e27701: '4. 安装完成后，右下角系统托盘会出现 QZ 图标',
  x_0671c916: '消除安全弹窗',
  x_ea015cf2: '如果 QZ Tray 每次打印都弹出 "Untrusted website" 窗口，请按以下步骤安装证书：',
  x_e43c62e9: '1. 点击下载证书文件',
  x_d3f866d8: '2. 把下载的',
  x_0457c44a: '文件复制到：',
  x_be76a70e: '3. 右键系统托盘 QZ 图标 &rarr; 选择',
  x_84b2bd4a: '进入',
  x_1094f3fa: '管理后台 &rarr; 系统设置 &rarr; 打印机选项',
  x_f643af46: '，填写打印机名称。',
  x_ce1cca4a: 'POS收据打印机',
  x_1708461e: '用于打印日常销售收据（假单/内部收据）',
  x_b627c3dc: '示例',
  x_1bd554fc: '税务打印机',
  x_6f3305bc: '用于打印正式税务发票（真单/正单）',
  x_17f83847: '如何查看打印机名称？',
  x_69c9ff65: 'Windows设置 &rarr; 设备 &rarr; 打印机和扫描仪',
  x_b769e4ff: '只有一台打印机？两个名称填一样的即可。',
  x_49e382b0: '出真单（正式发票）',
  x_53299d30: '输入金额',
  x_23ad596c: '打印到税务打印机 | 订单显示在报表中',
  x_0597a697: '出假单（内部收据）',
  x_748da81b: '打印到POS打印机 | 订单在报表中隐藏',
  x_43f28ccd: '入数不出单（仅记录）',
  x_f523f020: '不打印 | 订单在报表中隐藏',
  x_339fbb54: 'Q: POS底部显示灰色 "QZ" 按钮？',
  x_850263a4: 'A: QZ Tray未运行。检查系统托盘是否有QZ图标，没有就重新打开QZ Tray。',
  x_3c7cc6d8: 'Q: 弹出 "Allow/Block" 对话框？',
  x_a008acbd: 'A: 勾选 "Remember this decision" 然后点 "Allow"，之后不再弹出。',
  x_5c8ae7a8: 'Q: 打印机找不到？',
  x_ed2b395c: 'A: 确认设置里的打印机名称与Windows中完全一致。进入 Windows设置 &rarr; 设备 &rarr; 打印机 查看。',
  x_60ca8330: 'Q: 只有一台打印机怎么配？',
  x_4042778b: 'A: POS打印机和税务打印机都填同一个名称（例如都填 XP-80C）。',
  x_d1b45389: 'Q: 不装QZ Tray能打印吗？',
  x_0a468501: 'A: 可以，但每次打印会弹出浏览器对话框。装了QZ Tray就完全静默打印。',
  x_231206dd: '箱',
  x_f7edf5ac: '件',
  x_d3bc58b6: '汇率',
  x_93a17a92: '🧾 订单收据',
  x_79730766: '💰 催款通知',
  x_3b380a1e: '🎂 生日祝福',
  x_4438a544: '📢 促销广告',
  x_1a6b4e12: '⚠️ 老板提醒',
  x_88a1edb1: '💬 自定义',
  x_5e89ee46: '已标记发送',
  x_02c1633a: '已跳过',
  x_f2b4dbf5: '没有客户积分 ≥100,暂无 VIP',
  x_490b3a34: '最近 30 天没有下单客户',
  x_0ea30aad: '今天没有客户过生日',
  x_79eb3367: '没有客户,或客户都没填电话',
  x_bc21bd22: '条件下没有客户',
  x_cc989ba6: '导出失败',
  x_e73fb531: 'WhatsApp 待发送',
  x_1ce32b39: '没有待发送消息',
  x_218e94e7: '下单 / 赊账 / 生日时会自动出现在这里',
  x_a9550e64: '🚀 如何使用导出的 CSV：',
  x_e75ae49a: '1. 下载',
  x_82190c17: '官方 APP（免费，不需要 RIF）',
  x_976bdc5e: '2. 设置 → 工具 →',
  x_c32cb069: '广播列表',
  x_4d238b59: '→ 新建',
  x_df804a38: '3. 通过 Google 通讯录 / iCloud 导入 CSV（或手动添加联系人）',
  x_df02ca90: '4. 在广播列表里发消息 — 每人收到的是 1 对 1 聊天（不是群聊）',
  x_f4d94d4b: '⚠️ 单个广播列表最多 256 人 — 客户多的话可以导出多次分批发',
  x_1603b069: '周一',
  x_b5a6a07e: '周二',
  x_e60725e7: '周三',
  x_170fc8e2: '周四',
  x_eb79cea6: '周五',
  x_24575130: '周六',
  x_562d7476: '周日',
  x_2e5d828a: 'Sin citas completadas este mes / 本月暂无已完成的预约',
  x_89a676e4: 'Cambia el % y se guarda automáticamente. Solo cuentan citas marcadas como completadas. / 修改百分比自动保存，只统计"已完成"的预约',
  x_685f370b: '📴 离线：入货单已保存，来网自动上传',
  x_d0c68f0b: '📴 离线：收货已记录，来网自动入库',
  x_93c4b017: '采购单已删除',
  x_41722aa3: '采购单已归档隐藏',
  x_dbc210d6: '请填写编码和名称',
  x_a889286a: '创建失败',
  x_535bef11: '分类已更新',
  x_930442e2: '更新失败',
  x_44e7120c: '隐藏已完成',
  x_9779a11a: '显示已完成',
  x_1a750305: '全部分类',
  x_37c419ae: '附加条码',
  x_f2996845: '单位',
  x_ea887bd0: '规格',
  x_c5855564: '价格设置',
  x_d0e857e9: '利润率公式',
  x_cb340191: '利润',
  x_c6e41d42: '整箱价',
  x_d4229e8a: '箱规',
  x_51829073: '初始库存',
  x_a45686c0: '库存预警',
  x_dce5379c: '隐藏',
  x_2f4aaddd: '删除',
  x_ecf7ebb5: '未分类',
  x_8ec0438a: '付款记录',
  x_bce9f7d6: '快速新增商品（采购入库）',
  x_625fb26b: '取消',
  x_730bfc36: '已付清',
  x_8ec00711: '采购单已全额付清!',
  x_9698ab8c: '请选择如何处理此采购单：',
  x_83ef2b4d: '💵 现金',
  x_90f94c19: '💳 银行卡',
  x_f1a5d025: '🏦 转账',
  x_2fc44ed8: '📋 赊账',
  x_4fa3a2eb: '推荐码已生成',
  x_7f7de8a2: '生成失败',
  x_10173e90: '已复制推荐码',
  x_a95b0fa6: '已复制注册链接',
  x_fe32def4: '活跃',
  x_69b0f684: '已停用',
  x_5947a2a4: '推荐奖励',
  x_62ea3c2c: '推荐有礼',
  x_838b386f: '1. 分享推荐码',
  x_d6ade6c8: '将您的专属推荐码分享给其他商家',
  x_07cff2ae: '2. 朋友注册',
  x_af47e408: '朋友使用推荐码注册获得44天试用',
  x_6019e1c3: '3. 双方获奖',
  x_a250368b: '您也获得30天免费延期',
  x_c6c4ba10: '您还没有推荐码，点击生成',
  x_83e0c4f0: '我的推荐码',
  x_6e1519ad: '已推荐人数',
  x_2964d77d: '获得奖励天数',
  x_f3ce8bc2: '推荐记录',
  x_23733df5: '最近30天没有销售记录，无法自动计算',
  x_0b1cc5f0: '计算失败',
  x_0d667672: '计算中...',
  x_0868b4ed: '自动设置最低库存',
  x_88b16782: '修复失败',
  x_e596edd9: '应用中...',
  x_5921137f: '自动计算结果（基于最近30天销售 + 7天安全库存）',
  x_b409f53c: '清点对比',
  x_e7c0908c: '现金',
  x_c31eabb4: '刷卡',
  x_acaf665f: '转账',
  x_2432b575: '备注',
  x_cd1cff20: '总销售 (毛额)',
  x_6b587c75: '重新对账此班(从订单库重算总额)?',
  x_a8336884: '同时强制结班?',
  x_f0407e01: '✅ 已重新对账',
  x_769a6bb0: '🔧 重新对账(从订单库)',
  x_d342fac8: '重打报表',
  x_a6240224: '员工绩效详情',
  x_a235c0c8: 'RFM 客户分群 + WhatsApp 一键群发',
  x_0cd126ef: 'WhatsApp Web is not connected. Go to “📱 WhatsApp 自动连接” to scan the QR before broadcasting.',
  x_1e664d6e: '点击分群快速选择该群所有客户 → 一键预填促销文案',
  x_c7b27363: 'WhatsApp 群发',
  x_792f9eb2: '✨ AI 文案生成 (GPT-5.2)',
  x_1aa19423: '根据您的行业 + 选定分群 + 客户购买行为,自动写 3 条 WhatsApp 文案',
  x_e4234194: 'Optional: 母亲节促销 / 新品到货 / 周末特价...',
  x_4dfe7036: '生成',
  x_48853792: 'AI 看到的数据',
  x_baea39ef: '人均消费',
  x_de4db8d2: '人均来访',
  x_b6838383: '房租',
  x_0ee0c81c: '水电',
  x_be11fc04: '工资',
  x_1f4beff9: '耗材',
  x_324712a3: '维修',
  x_0f3a252a: '运输',
  x_638e3280: '税费',
  x_0d98c747: '其他',
  x_d594b77a: '请输入金额',
  x_3fdaeadf: '添加成功',
  x_0719d4e5: '确定删除?',
  x_3fef31de: '开支管理',
  x_e5d6c826: '新增开支',
  x_07d77a1b: '总开支',
  x_3d2a964f: '笔数',
  x_6b63c89c: '各门店开支',
  x_3bdd08ad: '描述',
  x_f9ac4b2a: '操作人',
  x_86c5708d: '选择门店',
  x_16a097d2: '水费、电费、物流费等',
  x_de5f6c72: '等值',
  x_1e49734c: '实收',
  x_1993ed26: '汇总',
  x_78d078e8: '开支',
  x_80170f62: '净利润',
  x_e9caa1e9: '立即扫描所有租户的 products.stock vs inventory.quantity 偏差并自动修复？\\n\\n¿Auditar la deriva de inventario y autoreparar?',
  x_3859c850: '库存零偏差 — 一切对齐 ✓',
  x_e6c2d5d3: '扫描中...',
  x_8f7072ac: '库存稽核',
  x_66411a09: '🧪 Sellox WA-Web 测试消息',
  x_6e4f4b33: '请输入手机号',
  x_12020cd0: '✅ 已开启 — 客户开单后自动收到 WhatsApp 小票',
  x_ad859563: '⏸ 已关闭自动发收据',
  x_1668b5ee: '⏸ 已关闭自动催款',
  x_f562ea82: '请先选择默认归属店铺',
  x_9f276dd7: '✅ 已开启 — 客户发付款截图到您的 WhatsApp 会自动识别并匹配订单',
  x_08f2f5b8: '⏸ 已关闭自动核销',
  x_207fff73: '确定要登出 WhatsApp 吗？登出后需要重新扫码连接。',
  x_a58b3a30: '已登出，等待新二维码…',
  x_3d7c933b: '登出失败',
  x_c5ea9c6a: '已连接',
  x_9fde5e83: '等待扫码',
  x_61536d6b: '认证中...',
  x_7f3a55b2: '未连接',
  x_4c7bf874: '冲突 (其他设备登录)',
  x_fbecd9e3: '服务异常',
  x_e12b354d: '已开启 ON',
  x_3b6ed28d: '关闭中 OFF',
  x_be5fbbe3: '保存',
  x_7657f76c: '您的号',
  x_65026c6a: '连接状态:',
  x_9db7a84f: '已开启',
  x_d4909dab: '自动收到',
  x_5d855937: '已逾期',
  x_0d041ace: '3 天内即将到期',
  x_0e4b660d: '同一客户两次催款最少间隔:',
  x_30b38123: '发到您的 WhatsApp 号',
  x_6134f524: '自动匹配',
  x_f3a2348c: '客人完全不用打开网页或扫码，就像微信发消息一样。',
  x_12e45b5a: '默认归属店铺:',
  x_f26bedc7: '(无店铺)',
  x_abfc9ba9: '先关闭才能换店',
  x_c363b9ec: '扫码连接您的 WhatsApp',
  x_dfaf8682: '打开您手机的 WhatsApp',
  x_3fafc6fe: '菜单 →',
  x_4a4c2cf7: '已链接的设备',
  x_a7ad104b: '链接设备',
  x_e0290bd7: '用相机扫描下方二维码',
  x_6d81d254: '等待 5-10 秒显示「已连接」',
  x_0d280386: '等待生成二维码...',
  x_008fe1ba: '通常需要 10-20 秒',
  x_b8a25309: '已成功连接 ✅',
  x_b71dbebc: '📤 测试发送',
  x_565ea0b6: '收件号码 (E.164 格式)',
  x_b87b7756: '消息内容',
  x_eb0bd897: '💡 使用提示',
  x_0fb5c8cf: '这个连接是',
  x_01e161e9: '免费的',
  x_22d65176: '，不消耗 Twilio 额度',
  x_d01f9a4f: '给任何客户发消息',
  x_52c58309: '无需 join',
  x_332247f3: '，就像微信群发一样',
  x_83320746: '您手机不用一直开着 WhatsApp，VPS 自动保持登录',
  x_fcf8348a: '如果显示「冲突」，说明您在别处用了 WhatsApp Web — 退出其他设备即可',
  x_0f4dfafd: '万一被登出，回到本页面重新扫码即可（1 分钟）',
  x_f27d2855: '👉 切到上方',
  x_167fc20b: '「🎂 节日/生日营销」',
  x_525ce8d5: '标签，可一键群发节日 / 生日 WhatsApp，AI 自动写文案',
  x_4fe8cddc: '已设为不限门店',
  x_7b9796b4: '诊断失败:',
  x_c1e4fc86: '修复完成',
  x_24c6a887: '修复失败:',
  x_105c8a51: '导出成功',
  x_dd51ab50: '导出失败',
  x_80070ef8: '门店不限',
  x_104faff3: '门店上限',
  x_7fa365e7: '诊断/修复',
  x_9344b89b: '导出备份',
  x_0719aa2b: '重置密码',
  x_bdd21b3d: '改登录ID',
  x_9171e387: '自定义数量 (留空=不限)',
  x_a94b953e: '→ 自动建桌位、开启厨房打票、上菜阶段标签、10% 服务费',
  x_1b89e094: '→ 开启取餐号、厨房打票、自助点单',
  x_5d960ff3: '→ 开启 Size×Color 变体、季节标签、批发零售自动切价',
  x_3fc4b6fb: '→ 开启批号、过期日期管理',
  x_db15472a: '→ 开启散装/称重、整箱售卖',
  x_609adbd2: '→ 通用零售（无行业特殊功能）',
  x_72d55e89: '输入新密码',
  x_fbc026c9: '健康',
  x_fe3d61c1: '有警告',
  x_ab9512ba: '有严重问题',
  x_e2e27a87: '严重',
  x_900c70fa: '警告',
  x_8f3d0f51: '确定要清除全部订单？此操作不可撤销！',
  x_b97b6c51: '按套餐设置该商户最多能开几家店（对应定价：1店$50 / 2店$80 / 3店$110 / 5店$160 / 8店$230）。留空 = 不限。',
  x_8441b348: '不限',
  x_6258bb14: '— 自动初始化分类 + 行业功能',
  x_9e0124e8: '🛒 综合零售',
  x_8bc59f0c: '🍽️ 餐馆 / Restaurante (桌位 + 厨房屏 + 服务费)',
  x_2306dfd6: '🍔 快餐 / Comida rápida (取餐号 + 厨房屏)',
  x_03d614a2: '👕 服装 / Tienda de ropa (尺码×颜色 + 季节 + 批零)',
  x_9357f511: '💊 药店 / Farmacia (批号 + 过期管理)',
  x_ef343e19: '🥕 超市 / Supermercado (散装 + 称重)',
  x_e44ccd80: '🥐 烘焙',
  x_1464330c: '🔧 五金',
  x_08460537: '📱 电子 / Electrónica (序列号)',
  x_eebcf410: '💄 美容 / Belleza (预约)',
  x_89d569a1: '重置商家密码',
  x_0644dad5: '输入用户名和新密码。如果该用户不存在，系统会自动创建。',
  x_bf7da0bf: '新密码',
  x_80cfc33c: '确认重置',
  x_316a4683: '店铺诊断与修复',
  x_44d50e5a: '诊断中...',
  x_a519dc2a: '发现的问题',
  x_95ab9037: '修复操作',
  x_bab268d5: '供应商',
  x_e54ee345: '逾期!',
  x_edae78fd: '借款',
  x_c3704da5: '赊货',
  x_ebe86a1f: '还款',
  x_03531769: '工资扣除',
  x_756048fc: '员工对账单',
  x_4cf24aba: '金额',
  x_5a4fcfe2: '当前欠款',
  x_90ea8d11: '员工赊账',
  x_5a611987: '未分配门店',
  x_ad83f8e5: '总欠款',
  x_bd3616ee: '工资单 + 二维码',
  x_2dbf283b: '对账单',
  x_bbdd42a0: '已结清',
  x_ea340b7c: '借款',
  x_3f01df5b: '赊货',
  x_620610c0: '已还',
  x_8577b01a: '员工提取存款',
  x_44ba3fed: '提取失败',
  x_7b1df363: '暂无员工欠款记录',
  x_4c95bf44: '还款',
  x_79ef16e5: '工资扣除',
  x_006deeed: 'POS赊账',
  x_d2f88894: '采购',
  x_e6119529: '工资单',
  x_ef9ec7c0: '📞 联系客服',
  x_acf0664a: '删除失败',
  x_ec25deba: '清空失败',
  x_a2339865: '已经是主仓库',
  x_5154ae17: '复制失败',
  x_d6fecfb2: '请输入有效数量',
  x_956ef5ad: 'Aprobado / 已批准',
  x_786c8fe1: 'Rechazado / 已拒绝',
  x_7e237e94: '成本',
  x_4eb4b061: '从主仓复制',
  x_b6eea70f: '无法加载充值档位',
  x_81bbad14: '未设成本',
  x_901a44b7: '未设',
  x_55fadf3b: '单位成本',
  x_7e0457bb: '配置已保存',
  x_c330679b: '阈值过高，测试未触发（当前阈值',
  x_82b783f0: '已忽略',
  x_d06adee8: '汇率波动预警',
  x_46d3ff51: '预警配置',
  x_5659fd6c: '启用预警',
  x_839db71f: '— 超过此百分比即触发',
  x_3a62401d: '推荐 5%（常规 BCV 日波动 1~3%，超过 5% 属异常）',
  x_4ab817d3: '— 含国家码，不带 +',
  x_eae0f4d8: '为空时自动用 Boss PIN 设置的号码',
  x_0468089c: '预警历史',
  x_317dbe0f: '暂无预警记录',
  x_c4677828: '时间',
  x_8bd0b918: '源',
  x_609a902e: '旧 → 新',
  x_34d0195a: '变动',
  x_41dfb0bf: '原因',
  x_6ef780bf: '损坏',
  x_584cd195: '过期',
  x_a6a652d7: '自用',
  x_42e0c46b: '样品',
  x_fe299b11: '分类/汇率分析报表',
  x_1e355e1f: '黑市',
  x_800dfdd9: '今天',
  x_72520580: '本周',
  x_0ec94a37: '本月',
  x_c5d35890: '上月',
  x_6da06b0c: '所有门店',
  x_bee912d7: '查询',
  x_72d76618: '汇率:',
  x_4cbae8f6: '总销售额',
  x_9719978c: '商品成本',
  x_bae6c9ba: '毛利润',
  x_7bfa923d: '日常开支',
  x_cea67413: '损坏/报损',
  x_29225555: '汇兑收益',
  x_33fa2d30: '员工应收款',
  x_4fbe97e5: '待收回',
  x_fbb493d0: '订单数',
  x_eee785b1: '政府汇率拿货',
  x_9ae44464: '销售额',
  x_f5acfdc9: '黑市拿货',
  x_bc41ea8b: '按分类统计',
  x_bfec3534: '定价模式',
  x_27a504ee: '销售额($)',
  x_2d4ec760: '销售额(Bs)',
  x_eae13adc: '成本($)',
  x_e052f520: '利润($)',
  x_7a3da957: '利润率',
  x_e4f48bf4: '件数',
  x_dda07873: '开支明细',
  x_030808e9: '损坏/报损明细',
  x_65cccb1c: '汇兑收益明细',
  x_ac502247: '买美金现金',
  x_2feedc17: '刷卡换现金',
  x_0d91478b: '按日统计',
  x_d6ddd835: '批次 / 批号追踪 (FIFO)',
  x_e06e4a15: '新增批次',
  x_a6eefa41: '召回追溯',
  x_f7414a41: '🍳 制作中',
  x_a2d94b67: '✅ 已出餐',
  x_362f791f: '更新失败',
  x_a7cf3c19: '🆕 待制作',
  x_641fb174: '开始制作',
  x_6062f967: '已出餐',
  x_c7664439: '✅ 已出餐',
  x_d9d86061: '退回待制作',
  x_4f5b356a: '厨房显示系统',
  x_f05d50fe: '没有订单',
  x_ebedad8a: '等待 POS 下单',
  x_8f9d8f83: '账号/邮箱 (PayPal/Wise/Zelle)',
  x_6ee9e469: '钱包地址 (USDT/BTC/ETH)',
  x_6a069dc9: '链接 (paypal.me',
  x_436d77df: '二维码 (WeChat',
  x_03c32ab3: '银行账号 (Wire Transfer)',
  x_f8dfedcd: '已保存',
  x_a9ca9fd6: '+58 424-8476761 (中文/Español/English)',
  x_274c1e1b: 'TU_USDT_TRC20_AQUI (占位符)',
  x_ed7823b1: '+ 添加',
  x_ac92f4c5: '名称 (如 Wise / Zelle / Binance Pay)',
  x_76254a13: '账号/地址/链接 (如 your-wise@email.com)',
  x_61860e54: '给客户的支付说明 (可选)',
  x_908a649e: '例: 付款后请截图发给 WhatsApp 客服, 我们会在 30 分钟内激活您的 Sellox 账号并发送登录凭证。',
  x_921915b6: '保存所有设置',
  x_fb4ca1cf: '加载中…',
  x_f19e59a5: '🌍 国际支付设置 (跨境收款)',
  x_4290f0a0: '配置外国客户（南非/巴西/哥伦比亚等 7 国）支付 $199/$499/$999 的收款方式。信息会展示在落地页 "Buy" 弹窗里。',
  x_8009051e: '启用国际支付',
  x_e90bdf1a: '关闭后落地页 Buy 按钮只显示客服 WhatsApp',
  x_17fb55f0: 'WhatsApp 号码 (带国家代码, 不要 +)',
  x_45ffbd9d: '示例: 5804248476761 (委内瑞拉)',
  x_f3864065: '显示标签 (可选)',
  x_d04bbc0e: 'PayPal 邮箱',
  x_0fed3f6b: 'paypal.me 链接 (推荐 - 客户一键付款)',
  x_0b36d1a2: 'TRC20 (Tron) - 手续费 ≈ $1, 推荐 ⭐',
  x_67ebc935: 'ERC20 (Ethereum) - 手续费 $5~20',
  x_51e8a79c: 'BEP20 (Binance Smart Chain) - 手续费 &lt; $1',
  x_e71d5f47: '尚未添加。点右上角 "+ 添加" 来增加任意支付方式（Wise/Revolut/Zelle/Binance Pay/Pix/Western Union 等）',
  x_0380d11f: '💰 套餐价格 (USD)',
  x_dcf9f3db: 'USD 一次性买断',
  x_92d28a70: '📝 给客户的付款说明 (可选)',
  x_37ef8c61: 'PayPal 注册',
  x_a094a4a9: '(个人账号即可收款)',
  x_9b3c8bf1: 'paypal.me 创建',
  x_d149282b: 'USDT TRC20 钱包 (推荐)',
  x_b9f4d9f0: 'Wise (跨境汇款)',
  x_42c062bf: '🛒 普通店',
  x_b0c7322a: '杂货店、五金店、便利店、文具店、化妆品店等通用零售。不预设分类，按你需要自己创建。',
  x_e69533ce: '✓ 双币种 (USD + Bs)',
  x_5c26623b: '✓ 多门店',
  x_348c3c42: '✓ 网店发布',
  x_c971b497: '✓ 适合 90% 普通生意',
  x_d5ebb7de: '🍽️ 餐馆',
  x_c85301d4: '茶餐厅、快餐、烧烤、咖啡、酒吧等。一键创建菜单分类、桌位、厨房单据。',
  x_74efa0b8: '✓ 7 个菜单分类自动建好',
  x_03fb8ea8: '✓ 10 张桌子立即可用',
  x_01cdb4fc: '✓ 厨房自动出单',
  x_05474198: '✓ 服务费 10%',
  x_6229e580: '👕 服装店',
  x_66682a68: '服装、鞋帽、童装、配饰。每件衣服可设尺码 (S/M/L/XL) × 颜色 (红/蓝/黑) 多变体库存。',
  x_57dd3ef7: '✓ 8 个服装分类',
  x_2b54dfae: '✓ 尺码+颜色变体',
  x_7d9f9b66: '✓ 季节标签',
  x_72c05d38: '✓ 批发零售双价',
  x_f9003331: '已经是此行业了',
  x_acd5cb84: '失败',
  x_66342ccc: '✓ 当前行业',
  x_3f86ef3c: '应用此模板',
  x_e2662ca4: '服务费',
  x_8da5aff6: '✅ 已保存 — POS 收银台将立即生效',
  x_cea028d0: '行业模板',
  x_cd790081: '一键预设你的店铺类型 — 分类、桌位、变体一次搞好',
  x_a22b06e7: '提示:',
  x_605629af: '普通店',
  x_686dbf3b: '服务费 / 小费 (Servicio)',
  x_3b858549: '默认启用服务费',
  x_2420b778: '服务费百分比 (%)',
  x_f0d6cce2: '小票上显示的名称',
  x_0bfa1205: '🛵 骑手',
  x_00a0e92f: '⚙️ 费率设置',
  x_6af35899: '📦 配送订单',
  x_696bc73f: '✅ 已审核通过, 骑手现在能接单了',
  x_28687aeb: '确定拒绝该骑手？拒绝后他将无法接单。',
  x_81233d75: '已拒绝',
  x_3bddf714: '暂停该骑手？暂停后他无法接新单。',
  x_a2d930fd: '已暂停',
  x_30a59161: '✅ 已恢复, 可接单',
  x_a431ba4e: '按名字/电话搜索',
  x_75eb29d6: '🛵 摩托',
  x_f534abbc: '🚲 单车',
  x_b590db5d: '🚗 汽车',
  x_56d6a939: '🚶 步行',
  x_5c2ee4b5: '📍 正在获取位置...',
  x_88a5387f: '✅ 已获取当前位置作为店铺坐标',
  x_1b925959: '无法获取位置, 请手动输入',
  x_77322d90: '✅ 设置已保存',
  x_6620698d: '抢单池',
  x_68905cf3: '在线',
  x_cb2806df: '⏳ 待接单',
  x_fc6e17a5: '🛵 已接',
  x_107d8896: '📦 已取货',
  x_e0ae219c: '🚀 配送中',
  x_16661b98: '✓ 已送达',
  x_9d77d772: '配送骑手管理',
  x_bce11e3f: 'Repartidores · 审核骑手 / 设置费率 / 监控订单',
  x_c612876e: '还没有骑手注册',
  x_a37a9be7: '把',
  x_25e4e975: '链接发给你的骑手, 让他们用店铺代码注册',
  x_809476e2: '分享给骑手:',
  x_6cab0af7: '配送费率',
  x_14289a36: '起步费 (USD)',
  x_7de56a40: '每公里加价 (USD)',
  x_b25f1d80: '最远配送距离 (km)',
  x_73bb91d6: '店铺位置（用于算距离）',
  x_039e0dfc: '纬度 Lat',
  x_05e720b2: '经度 Lng',
  x_3fd0fc33: '店铺地址（显示给骑手）',
  x_fa8ee2c3: '骑手自动派单',
  x_28b2a26f: '自动指派给最近的在线骑手',
  x_f2418716: '距离 × 50 - 在送单数 × 30',
  x_58714e73: '暂无订单',
  x_86ce4ab5: '骑手:',
  x_9f911a7c: '尚未接单',
  x_188bff11: '🔴 已过期',
  x_6314a940: '🟠 7 天内',
  x_fc95d888: '🟡 30 天内',
  x_3aae3aea: '🆓 试用',
  x_d7bfdc78: '🟢 健康',
  x_d94c64e8: '👑 买断永久',
  x_4a5421bb: '❔ 无到期日',
  x_32137a91: 'AI 生成失败',
  x_3b5acbf9: '消息不能为空',
  x_1a70e8dc: '已加入 Outbox + 打开 WhatsApp',
  x_4d5ccd01: '已过期',
  x_d3cf0210: '7 天内到期',
  x_56ee9094: '30 天内到期',
  x_cda88e69: '买断永久',
  x_1a5e9603: '😊 友好',
  x_489fd45e: '⏰ 紧急',
  x_c6863be8: '💎 升级买断',
  x_0e223ebb: '未填',
  x_05e9dc7b: '发 WhatsApp',
  x_de815854: '租户订阅 / 续费 Dashboard',
  x_ecb48dd6: '🤖 AI 智能提醒',
  x_ee3f5585: '国家',
  x_927babb3: '剩余天数',
  x_fd5561f7: '最后付款',
  x_a522f3ba: '该分类暂无租户',
  x_46ca8fe7: '无电话',
  x_59cf15fe: '模板',
  x_0f0c4077: '😊 重写(友好)',
  x_849ced1d: '⏰ 重写(紧急)',
  x_28e51c71: '💎 重写(升级)',
  x_6b2b61c1: '点"发 WhatsApp"会自动加入 Outbox + 同时打开 WhatsApp 网页/App,你只需点 ➤ 发送箭头即可。',
  x_8fe83636: '请输入接收电话',
  x_b8c17683: 'Meta 被封,已加入 wa.me 队列',
  x_8384ee76: '已发送',
  x_e98c5780: '配置',
  x_e1c652bc: '测试发送',
  x_8b608503: '今天利润多少？',
  x_780a3ce3: '从 Meta WhatsApp 配置页复制',
  x_dfc26b0a: '如需更新，粘贴新 token',
  x_14ae8f5b: '从 Meta System User 生成',
  x_4323be72: '保存设置',
  x_1b709fcc: '接收电话 +584...',
  x_ff6d830a: '发送测试消息',
  x_1c00c645: '💡 大约需要 15-20 分钟。一次配好就再也不用管。',
  x_5a3044a7: '所有步骤免费，除非 WhatsApp 业务消息超过 Meta 的免费额度。',
  x_d9917a0f: 'Paso 1 / 第 1 步：创建 Meta 开发者账号',
  x_18305c0e: '打开：',
  x_f9056348: '用你的 Facebook / WhatsApp 账号登录',
  x_7d427d3d: '点右上角',
  x_9c11804f: 'Get Started / 开始',
  x_a3c972b7: '→ 按指示完成注册（免费）',
  x_63d5e90b: 'Paso 2 / 第 2 步：创建商务资产 (Business Account)',
  x_be604f8b: '点',
  x_86165c96: '创建业务',
  x_34bc86ed: '→ 填店名、你的姓名、邮箱',
  x_ff5d264e: 'Paso 3 / 第 3 步：创建 WhatsApp Business App',
  x_b140dd92: '回到',
  x_abb2b8f6: 'Create App / 创建应用',
  x_e90efab1: 'Use case 选',
  x_7d394eff: 'Other / 其他',
  x_9c2b1541: '→ Type 选',
  x_eaa0a8e3: 'Business / 商业',
  x_36a6d4b9: '关联到上一步创建的 Business Account → 创建',
  x_de9dda75: '进入 App Dashboard → 左侧菜单找',
  x_2ac93ee6: '→ 点',
  x_700677b3: 'Set up / 配置',
  x_ca3908a1: 'Paso 4 / 第 4 步：取 Phone Number ID + 临时 Token',
  x_2fcc28b3: '进入 WhatsApp → 左侧点',
  x_b1d07643: 'API 设置',
  x_593a1499: '页面顶部会看到',
  x_542bd2bd: '（`EAA...` 开头）→ 复制',
  x_0c4c68c7: '中间会看到',
  x_2868963d: 'Phone number ID / 电话号码编号',
  x_1ff9d199: '（一串数字）→ 复制',
  x_9a3f0a43: '⚠️ 临时 token 只有 24 小时，后面做 System User 的永久 token（见下一步）',
  x_1743a4bd: 'Paso 5 / 第 5 步：永久 Token（推荐）',
  x_d7098f50: '打开',
  x_5b1bc0f8: 'Add / 添加',
  x_04bb0f86: '→ 命名"Sellox Bot" → 角色选',
  x_7635736a: '进入 System User → 点',
  x_6effb00e: 'Add Assets / 添加资产',
  x_0c143e9a: '☑ Apps → 勾 App →',
  x_d0a5ba88: '☑ WhatsApp accounts → 勾 WABA →',
  x_609f8cf0: 'Generate New Token / 生成新令牌',
  x_373a96ca: '→ 选 App →',
  x_be153369: '生成 →',
  x_d600945c: '立刻复制',
  x_e9b20985: '（关窗就看不到了）',
  x_eeb6320c: 'Paso 6 / 第 6 步：配置 Webhook（让 Meta 能送消息给我们）',
  x_9ce48b57: '"配置',
  x_99539f07: 'Meta 配置页点',
  x_4d572586: 'Edit / 编辑',
  x_bdc858dc: '粘贴上面两个值',
  x_fae01bc0: 'Verify and save / 验证并保存',
  x_7701988b: '→ 出现绿勾 ✅',
  x_c348bfce: '下方 Webhook fields →',
  x_bc2153d1: '→ 订阅',
  x_ab20cc42: '和',
  x_8f2b0cd1: 'Paso 7 / 第 7 步：填到 Sellox 后台（就是下面这个页面）',
  x_5ce0ecbc: '在下面',
  x_95805797: '② 你的 WhatsApp Business 凭证',
  x_87bff178: 'Permanent Access Token（或临时 token）',
  x_c4d93fb8: '电话号码（可选）',
  x_c8c135f6: '老板手机白名单（格式 +584xxxxxxxxxx）',
  x_142f5856: '勾',
  x_97c38974: 'Paso 8 / 第 8 步：测试',
  x_eb2ec6d7: '保存后，下面会出现',
  x_f94ea898: '"测试发送"',
  x_d87f215d: '卡片',
  x_742be581: '填老板手机，发一条消息试试',
  x_4ee03501: '收到后，在 WhatsApp 里回复"今天利润多少？" → AI 会用真实数据回答 🎉',
  x_7d5267db: '⚠️ 测试号码限制',
  x_7509351d: 'Meta 免费测试号 (+1 555 662 4521) 只能发给最多 5 个手动验证过的接收方。要发给任何人，需要在 Meta 添加自己的商业号码（会要做商业验证，几天）。',
  x_20c5cf28: '💬 遇到问题？',
  x_fd4d3093: '联系平台管理员帮你配好，或者点右下角 AI 助手问具体步骤。',
  x_3f58e45d: '① Meta Webhook 配置（填到 Meta App Dashboard）',
  x_d025f0d5: '订阅字段:',
  x_01f35594: '电话号码 (E.164)',
  x_60eae7be: '（已保存，不显示）',
  x_372c24bf: '老板手机白名单（半角逗号分隔，可多个）',
  x_bb28c476: '只有在白名单里的手机号，AI 才会回答营业数据（利润、库存、欠账等）',
  x_01b59ca9: '③ AI 行为',
  x_e6a08432: 'AI 模式',
  x_639ebc3f: '仅老板 —— 只有白名单能聊，其他人不回',
  x_31d7946b: '仅客户 —— 客户查产品，老板仍可问数据',
  x_4ea5a5ee: '两者都 —— 客户查产品，老板查数据',
  x_20339501: '每单结账后自动推送电子收据到客户 WhatsApp',
  x_f679838d: '客户档案勾选了「📨 订阅 WhatsApp 通知」',
  x_f4cfb985: '即每个客户可单独选择是否接收',
  x_185c0503: '请选择客户',
  x_dd2124ee: '请添加商品',
  x_9923d1e2: '开单成功',
  x_21263321: '批发开单',
  x_d166bb06: '总部',
  x_abfecaae: '添加客户',
  x_c6403f20: '额度',
  x_ec3fb565: '选择客户',
  x_b042c052: '搜索商品 (名称/条码)...',
  x_57c89bca: '搜索商品并添加到订单',
  x_fedff361: '订单汇总',
  x_0367ebd1: '备注...',
  x_e7814437: '确认开单',
  x_0706515e: '快速添加客户',
  x_18401477: '信用额度 ($)',
  x_a48948bf: '全部门店',
  x_be3565c4: '参考号匹配',
  x_a0e50b0e: '订单匹配',
  x_c95d6f32: '金额匹配',
  x_1622dc9b: '未知',
  x_ed0ad119: '每日对账报告',
  x_8e600fc0: '已匹配',
  x_8567bca1: '未匹配验证',
  x_728bf491: '未匹配销售',
  x_1e8dc255: '订单号',
  x_ca2944f0: 'AI金额',
  x_093c45aa: '销售金额',
  x_5c4caeaf: '参考号',
  x_f3d55d6b: '发送人',
  x_f14b4f28: '银行',
  x_d47a0207: '每日自动对账',
  x_6ea41b97: 'AI验证记录 vs 电子支付销售 — 自动匹配核对',
  x_dd09a5da: 'AI验证总数',
  x_193911c6: '这些AI验证记录没有找到对应的销售订单，可能是客户上传了但收银员未确认',
  x_396a3453: '这些电子支付销售没有找到对应的AI验证，可能客户未上传付款截图',
  x_d4c1ecd7: '全部匹配！当天所有电子支付已核实',
  x_82e96463: '库存必须是 ≥ 0 的数字',
  x_6e5907ee: '🔄 刷新',
  x_1db180af: '搜 商品 / 颜色 / 尺码 / SKU',
  x_105b1395: '库存 ≤5',
  x_b12876c8: '已售罄',
  x_ad9238d4: '还没有带规格的商品',
  x_36094e1c: '无匹配',
  x_afcc3e34: '💾 保存',
  x_5c94144d: '总变体 SKU',
  x_0e076143: '商品',
  x_f1daf080: '尺码',
  x_6b36c6f7: '颜色',
  x_dd56adce: '确定要为所有员工自动创建/关联顾客档案吗？\\n这样他们赊账或消费时可以累积积分。',
  x_f10dfc69: '把所有员工自动注册为\'顾客\'（is_staff=true），这样他们赊账或消费时能累积积分',
  x_f33656e1: '身份证',
  x_881a9bd5: '身份证号码 (Cédula)',
  x_69b8571e: '工资 ($)',
  x_b5ca1dd9: '发薪周期',
  x_09b03b6d: '每周',
  x_9104c0c5: '每两周',
  x_aa3d57c0: '每月',
  x_72b3c2be: 'IP白名单（留空=不限制）',
  x_ba15d1d2: '例: 190.205.1.100, 200.44.32.50',
  x_9cf8e8f2: '多个IP用逗号隔开。管理员和经理不受此限制。',
  x_e6d7c138: '允许登录时间（留空=不限制）',
  x_d18b4c06: '委内瑞拉时间 (UTC-4)。例: 07:00 ~ 22:00',
  x_3eb2b5e8: '不能低于成本价',
  x_6bde6f81: '打折后价格不能低于成本价',
  x_a6f3ec47: '网店 AI 客服',
  x_e7454268: '老板 AI 查数',
  x_10f8a322: 'WhatsApp 文字',
  x_bb364b6d: 'WhatsApp 语音',
  x_6af959ee: '拍照入库',
  x_e50663b2: '充值',
  x_34ce201c: '赠送',
  x_85f42dcd: '消费',
  x_51d2fc74: '取消当前订单？取消后可以重新冲值。\\nCancelar esta orden?',
  x_f3955e88: '订单已取消',
  x_2b8fa5ac: '订单已付款，无法取消',
  x_98308839: 'USDT 到账！学分已充值',
  x_655c5610: '无法生成付款地址',
  x_326e34ed: '付款信息已生成 / Payment info ready — 扫码付款',
  x_efad9fe0: '创建发票失败',
  x_46ccee5b: '已复制金额',
  x_2e3006a9: '✅ 地址已复制',
  x_9790e47c: 'AI 学分',
  x_ae190ef1: '当前余额',
  x_8af6c290: '累计充值',
  x_5c9bc81a: '累计消费',
  x_34dccb6b: '消费价格表',
  x_7efdc4e4: '消费流水',
  x_b9db8476: '暂无记录',
  x_833cba67: '付款中',
  x_1833a9ec: '💰 付款金额 / Monto (USDT-TRC20) ⚠️ 手动输入',
  x_9d3931f8: '📥 收款地址',
  x_900ee05e: '扫码流程',
  x_30d4a272: '（任何 USDT 钱包都能用）：',
  x_bf863bf8: '1. 在币安/OKX/Trust Wallet 点「发送/Send」→ 选 USDT → 网络',
  x_4c6c1bd8: '2. 扫这个二维码 → 地址自动填入',
  x_550c9aef: '金额手动输入',
  x_46703262: '✓ 已到账',
  x_f4e8f238: '旧订单',
  x_3d75129d: '点',
  x_3f60cc81: '用 USDT 购买',
  x_e6b9334f: '👋 欢迎跟进',
  x_4f3f45b3: '您好 {name}！感谢注册 Sellox 试用。我是创始人，有什么问题请直接问我。您的试用还有 {days} 天，这是登录地址：\\nhttps://backup.sellox.shop',
  x_1b556750: '⏳ 快到期',
  x_b8e14961: '您好 {name}，您的 Sellox 试用还剩 {days} 天。要继续使用请选套餐：\\n• Standard $29/月（1店5人）\\n• Pro $49/月（3店15人 + AI）\\n\\n续费链接：https://backup.sellox.shop/saas/checkout',
  x_0cc0a930: '🎯 邀请演示',
  x_8787d76d: '您好 {name}，需要我帮您做 15 分钟远程演示吗？我们可以一起把您的商品导入，让您 1 小时内开始用 POS 收银。',
  x_9639c829: '无电话号码',
  x_558b5ced: 'WhatsApp 已打开并记录跟进',
  x_cdcef6e3: 'WhatsApp 已打开',
  x_e984172c: '已复制电话',
  x_5255b7ec: '总计',
  x_30aeeb9b: '活跃',
  x_a337d612: '即将到期',
  x_f7656c12: '已过期',
  x_2ba7855c: '待支付',
  x_80d9ba9e: '搜索 商户 / 联系人 / 电话 / ID...',
  x_c41ac297: '快到期',
  x_9246fe88: '待支付',
  x_f2992715: '点击复制',
  x_fb4174dd: 'SaaS 试用注册',
  x_4740f413: '所有国家',
  x_f10c9104: '无匹配结果',
  x_5bf2e3d5: '商户',
  x_52409da5: '联系人',
  x_5a93d3f7: '电话',
  x_56526d93: '注册于',
  x_43b510ed: '剩余',
  x_b0d7b92a: '快速模板',
  x_56cfacad: '消息内容 (可编辑)',
  x_a66e77ec: 'Basic · 单店',
  x_6feaed50: '1 家店',
  x_792d962f: '3 个收银员',
  x_f2e24124: '❌ 无网上商店',
  x_8a77db1e: '🎁 新租户首年免维护',
  x_9a61b1d7: '1 总店 + 2 分店',
  x_4463f4a6: '12 个收银员',
  x_dab7b561: '✅ 网上商店',
  x_a0eac492: 'Enterprise · 1+10 · 推荐',
  x_fe8cdaef: '1 总店 + 10 分店',
  x_63c7540a: '♾️ 无限收银员',
  x_1e7614cb: '✅ 网上商店 + 配送 + 多店报表',
  x_b934c4e3: '取消当前订单',
  x_d16fd88d: '订单已取消',
  x_2276b3e8: '✅ 买断激活成功！',
  x_92a13409: '无法生成付款地址',
  x_33486076: '付款码已生成 / 扫码或复制地址付款',
  x_1c017415: '付款码已生成',
  x_d988ff0f: '地址已复制',
  x_65dd9ef1: '等待中',
  x_fafc7219: '套餐开通 · 每年交服务费',
  x_e2841a14: '金额',
  x_d41c514e: '网络',
  x_93ba918d: '仅 TRON 网络',
  x_13b5c750: '状态:',
  x_b21b5ec9: '取消订单',
  x_228a7d81: '⭐ 推荐',
  x_d65904be: '首付含首年服务费 · 次年起交年费',
  x_39e6803b: 'USDT 买断',
  x_b36b9c5e: '/ 年',
  x_16bcce59: '含: 服务器 · 自动更新 · 客服 · 数据备份 · 每月 PWA 升级',
  x_338e96c9: '🎁 新租户首年随买断免费 · 第二年开始续费',
  x_2962f3d5: '买断套餐',
  x_d1fdc613: '店数有上限',
  x_9823244e: '。需要加店,直接 WhatsApp 客服报价,不在系统内自动升级。',
  x_29aca265: '仅 USDT TRC-20 网络。发其他币种或链将永久丢失。',
  x_8428cdf2: '付款 5-15 分钟内自动激活。如有问题,客服 WhatsApp:',
  x_1f1c7645: '可选组至少需要2个选项',
  x_5b530127: '请填写完整信息',
  x_a3033ebf: '(副本)',
  x_79d3abe9: '复制',
  x_ea15ae2b: '选项',
  x_839a578d: '创建套餐组合，提升客单价',
  x_c901f681: '套餐名称',
  x_cc6c35a3: '编码',
  x_cc949910: '固定商品',
  x_abba9357: '🔍 输入名称搜索, 自动过滤下拉...',
  x_2cad29d6: '暂无固定商品',
  x_9a982d0f: '可选配件',
  x_2e363fc9: '添加可选组',
  x_8243c74a: '暂无可选组 (顾客可从每组中选一个)',
  x_c6db8605: '定价',
  x_75c8703e: '套餐价格',
  x_8690ee2e: '节省',
  x_c12c079a: '组名称 (如: 饮料选择)',
  x_d2ea9e05: '默认选项',
  x_ae648cba: '至少添加2个选项，顾客购买套餐时从中选一个',
  x_348f1b33: '请先选择图片',
  x_4dc3f98d: 'OCR 失败',
  x_17710b35: '没有要导入的行',
  x_9190cc22: '供应商名称',
  x_1fd1d5c5: '商品名称',
  x_39f76a9b: '条码',
  x_5f99f6a8: '售价',
  x_1981be5f: '拍一张进货单，AI 自动识别 → 对齐商品 → 更新库存 + 建议售价',
  x_bfd77887: '① 上传进货单照片',
  x_5324ed82: '点击拍照或选择图片',
  x_346a0f2f: '支持 JPG / PNG, 最大 15MB',
  x_da7e7127: 'AI 识别中，大约 5-10 秒...',
  x_4eb51d8f: '开始识别',
  x_3f2f5467: '② 核对识别结果',
  x_a24b9d90: '已有供应商 (可选)',
  x_7b8bc49d: '-- 用上面的名字 --',
  x_9452920c: '入库仓库',
  x_dcffc8fa: '单号:',
  x_7501567a: '日期:',
  x_dbcbbf20: '总额:',
  x_01be458f: '③ 每行商品 — 选择动作',
  x_d32fc7ef: '没有识别到商品行',
  x_c58187fe: 'OCR 识别',
  x_e514d3ef: '数量:',
  x_3bf6cfdd: '× 单价',
  x_c500cfab: '动作',
  x_f504986f: '匹配',
  x_26bb8418: '新建',
  x_92636e8c: '跳过',
  x_ba30d5cc: '-- 分类 --',
  x_6a9e619b: '确认入库',
  x_1d46b01c: '✅ 入库完成',
  x_bb3502bb: '进货单号:',
  x_4a049640: '入库商品:',
  x_29645b50: '项',
  x_art_pl: '项',
  x_d909d882: '总金额:',
  x_c28d24cc: '请选择银行',
  x_f821a75d: '请输入账号',
  x_5d813f65: '请输入电话',
  x_d467588f: '已添加，记得点保存',
  x_e742ab60: '例如: 0199 Mi Banco Personal',
  x_8d1a5254: '请输入银行名称',
  x_c3441b0e: '该银行已存在',
  x_1796b0b6: '收款账户',
  x_2fae4dfd: '客户下单时看到的收款银行账号。可以添加多个（转账 + Pago Móvil）。',
  x_4edfb958: '还没有收款账户。在下面添加第一个。',
  x_9c3929ba: '账号:',
  x_343c39bd: '电话:',
  x_468507f3: '持卡人:',
  x_a315035f: '+ 添加收款账户',
  x_b7887785: '类型',
  x_c75632b1: '银行',
  x_d9d63df2: '账号',
  x_ccfc0579: '持卡人',
  x_b87b58ea: '电话',
  x_f1e36d48: '+ 添加收款账户',
  x_3a24d652: '网店显示的银行',
  x_9bdee3a3: '客户下单时可选的银行。不勾选任何一个 = 全部显示（默认）。可添加自定义银行。',
  x_3036d714: '添加银行',
  x_de8733ca: '全部启用',
  x_7c589a7b: '全部关闭',
  x_4d915d93: '订阅已续期',
  x_9d6a7ced: '无法创建发票',
  x_4e16c811: '个月',
  x_5beef376: '个月',
  x_91d63f7f: 'SaaS 订阅续费',
  x_bc8a11d1: '租户',
  x_9b9a6730: '套餐',
  x_5f06418b: '等待 USDT 到账中…',
  x_516de1ba: '· 状态:',
  x_1bcf2f98: '省 2 个月',
  x_e27e83d3: 'USDT 续费',
  x_77de9017: '钱包：仅 TRON 网络 USDT，发送其他币种将无法到账。',
  x_ef6a3fe2: '支付完成后页面会自动跳回这里并提示「订阅已续期」。如未自动跳转，可手动返回点击「刷新」。',
  x_da8f9e35: 'Cajas/箱',
  x_77862e71: '同步失败，请检查网络后重试',
  x_ad41fef2: 'BCV同步失败',
  x_12d0d88a: 'Paralelo同步失败',
  x_b4b5434b: 'BCV = 官方/报表 | Binance = 美金现金/汇兑 | 黑市 = 卖货定价',
  x_536911f7: 'Sin internet / 没有网络 — espere a que vuelva la conexión',
  x_b2fbbabf: 'Nada que sincronizar / 没有待同步项',
  x_aece3f5d: '¿Descartar este cambio? No se podrá recuperar / 确认放弃此操作？无法恢复',
  x_912a4250: 'Eliminado / 已删除',
  x_cb4d2044: 'Sin elementos fallidos / 没有失败的任务',
  x_10b526fb: '班次已结束 — 销售单实际已保存,这是重复的计数请求,可放心丢弃',
  x_5f01f33d: '挂单已不存在 — 可能已经被结算或删除,可放心丢弃',
  x_d10bff45: '库存不足',
  x_57e7ae15: '源仓库库存不足',
  x_8496514a: '源仓库库存不足 — 调货单未创建！请减少数量后重新开单，或先入库补货。此卡住的单可以丢弃',
  x_4eb6919a: '赊账权限',
  x_fee56ee3: '客户未开通赊账权限 — 请先在「客户管理」打开 allow_credit, 或丢弃此单改用现金/转账重做',
  x_b5bda5aa: '重复请求 — 服务器已处理过,可放心丢弃',
  x_f17d4674: '网络正常',
  x_01f3782e: '网络断开',
  x_8b9a1e80: '— sincronizando automáticamente / 自动同步中',
  x_9e50fc79: '🔄 Sincronizar ahora / 立即同步',
  x_1a62aebf: 'Descartar / 放弃',
  x_bcb61127: 'Nada pendiente / 没有待上传项',
  x_78e8a2f9: '✅ 已挂账',
  x_ccc63b24: '🔧 无主赊账修复',
  x_97ce76db: '收银员点了「赊账」但没选客户/员工 — 请点击右侧「挂账」补挂到正确的人',
  x_2a4cb867: '✅ 没有发现无主赊账,所有赊账都正确挂到客户/员工账上了',
  x_b7a67cb8: '搜索订单号 / 商品 / 收银员...',
  x_faa34bbd: '没有匹配的无主赊账',
  x_87633dad: '挂账',
  x_bdc278a2: '挂账给...',
  x_d84f39b4: '👤 员工',
  x_796638a3: '🧑‍🤝‍🧑 客户',
  x_69632a49: '搜索员工...',
  x_4b93385f: '搜索客户...',
  x_ce2242ff: '严禁把美金实收与本地币折算混算为单一总数 — 两者性质与对冲风险不同',
  x_0b0fad08: '套餐销售分析',
  x_b061a19e: '套餐订单数',
  x_761c7bd5: '占总订单',
  x_e0674456: '套餐营收',
  x_8bdec340: '活跃套餐数',
  x_a789726b: '套餐均价',
  x_221340da: '套餐销售排行',
  x_794b4643: '暂无套餐销售数据',
  x_da518fe1: '创建套餐后，销售数据将在这里展示',
  x_398265e4: '套餐销量分布',
  x_956aaaf0: '套餐销售趋势',
  x_9c4738fa: '套餐订单',
  x_c2ee20c6: '配件选择统计',
  x_d7bbccf6: '套餐销售明细',
  x_46cd403a: '💵 美金实收 · USD Receipts',
  x_9a2602b9: '实打实现金流',
  x_b5091ee6: '💰 本地币折算 · VES → USD snapshot',
  x_3989b42a: '当天锁 $ 价',
  x_840a3569: '(参考)',
  x_d22c8252: '样品/试用',
  x_2ba8df79: '盘亏/超卖',
  x_1a6387e4: '报损登记成功',
  x_8f2328a2: '报损管理',
  x_20d8ea7f: '新建报损',
  x_6e2c4471: '报损记录',
  x_1a9a9b5c: '报损数量',
  x_6c3b96c6: '损失金额',
  x_2e51c1e9: '全部原因',
  x_7074d50c: '损失',
  x_531401ac: '更换',
  x_c270fc6f: '仓库',
  x_cb29982e: '默认仓库',
  x_748662a5: '报损原因',
  x_da086f20: '补充说明（选填）',
  x_6966f4a1: '预计损失',
  x_3303f395: '确认报损',
  x_607e7a4f: '查看',
  x_30eb1c49: '本周有',
  x_0c6ff5f3: '位客户过生日 — 点击查看营销中心',
  x_35bd0636: '至少保留一个商品',
  x_dadc0335: '订单修改',
  x_5badb3ba: '修改失败',
  x_1229b861: '已开启隐藏非正单',
  x_dc78ab4d: '已关闭隐藏非正单 - 显示全部',
  x_a2290676: '隐藏非正单: 开',
  x_3d0512c9: '隐藏非正单: 关',
  x_027d489f: '平均客单',
  x_77678b5c: '全部店铺',
  x_565955cb: '全部收银员',
  x_bfdaebfd: '收银员',
  x_41ce131a: '混合',
  x_966038af: '已退货',
  x_7623803b: '标记已完成',
  x_1512dcd4: '编辑订单',
  x_9567eef9: '现金 Efectivo',
  x_838effc3: '刷卡 Punto',
  x_32005a19: '转账 Transfer',
  x_30bee6f5: '混合支付',
  x_5939657d: '分拆支付',
  x_1e9b1d5d: '现金$',
  x_26954cc9: '现金Bs',
  x_26922a58: '收到',
  x_c993e001: '找零',
  x_4091e27c: '折扣',
  x_c8b8ba24: '实付',
  x_c5575b3f: '保存修改',
  x_7a8a35ec: '全部支付方式',
  x_25557e0c: '刷卡',
  x_9f6bb100: '混合',
  x_04330953: '赊账',
  x_974470ef: '支付:',
  x_da4abd3e: '单价',
  x_0bf60b32: '数量',
  x_f599fcd3: '小计',
  x_669e3a20: '设置已保存',
  x_9e144231: '立即发送今日生日祝福？',
  x_6193e011: '消息太短',
  x_0ef8caa0: '请选择定时发送的时间',
  x_50525e3d: '时间不能早于当前',
  x_a5a64f69: '${blastForm.campaign_name || \'节日\'}',
  x_4dc5ca8d: '排期失败',
  x_370f2e2c: '取消此定时任务？',
  x_482e8539: '取消失败',
  x_5ae7b19b: '今天!',
  x_71325692: '例: 母亲节2026',
  x_2fb90b05: '处理中...',
  x_2ae98dbc: '⏰ 排入定时',
  x_846a6e3b: '立即群发',
  x_917f9004: '🎂 生日 / 节日 WhatsApp 自动营销',
  x_2e7a63e4: '每天 9:00 AM (VE) 自动发送给当天生日客户',
  x_81b7205c: '每位客户每年自动去重一次',
  x_8f6280a1: '优惠券前缀',
  x_429d5967: '折扣百分比 (%)',
  x_f81c3d04: '有效天数',
  x_d3276905: '暂无。请先在客户资料里填写生日 (MM-DD)',
  x_8483ed13: '生日',
  x_3ec2bba0: '距离',
  x_02daf71f: '订阅',
  x_7001dd63: '已退订',
  x_3e744a9b: '订阅中',
  x_1fd094a7: '📅 节日快选 (按日期排序, 点击选择)',
  x_919bf6ba: '选择一个祝福语模板 → 自动填入下方表单 (可再编辑)',
  x_83f2b3fe: '此节日暂无预设模板，请手动输入',
  x_53eab0ee: '活动名称 (用于去重, 当天同名只发一次)',
  x_baa7d2f5: '⏰ 定时发送（可选）',
  x_a69942de: '选择发送日期 + 时间（按您本地时区）',
  x_afea4271: '✨ 系统会在您指定的时间自动发送。比如母亲节前一周配置好，5/10 上午 9 点自动推送。',
  x_04ab3e0f: '开启后可指定未来某个时间自动发送（比如母亲节当天 09:00）',
  x_f9c3ed43: '尚无发送记录',
  x_db8a4b9a: '请填写完整',
  x_4177fcbd: '✅ 登录成功',
  x_b6076a05: '登录失败',
  x_459db148: '例: 店铺代码',
  x_d89bbf9f: '店铺代码/手机/密码/姓名 必填',
  x_817f3912: '✅ 注册成功！等老板审核通过即可接单',
  x_1c56d8c5: '注册失败',
  x_c5864848: '店铺代码',
  x_a3006784: '手机号',
  x_0b7dd959: '密码',
  x_552fd502: '至少 4 位',
  x_914a33ec: '姓名',
  x_3f1613aa: '车牌号',
  x_e33cbc27: '🎉 抢单成功！请尽快去店铺取货',
  x_ecb6d7f9: '抢单失败',
  x_5cc14c3c: '✓ 已确认接单！',
  x_c92aaa37: '确认失败',
  x_74cc7a41: '已让给下一位骑手',
  x_52690cab: '🚀 开始送货',
  x_1d6ecc64: '✅ 已送达, 配送费已记入账户',
  x_e319cca8: '拍一张送达证明照片?\\n(可以不拍, 直接取消)',
  x_ead2daed: '请联系店主了解详情。',
  x_757bc40a: '审核通过后这里会显示可抢订单',
  x_a830777b: '无法接单',
  x_b720a69a: '审核中',
  x_4a9428f9: '✓ 已认证',
  x_c9d929e0: '✗ 已拒绝',
  x_1ef6f1db: '待接单',
  x_10f8cbf4: '已接单, 去取货',
  x_f8a40394: '已取货',
  x_d409c4ea: '距离未知',
  x_e91aeee2: '已完成订单',
  x_9af2659b: '累计收入',
  x_f061db1c: '车辆',
  x_108db12e: '评分',
  x_ad77bf1d: 'Sellox 骑手',
  x_dec20a6b: '店铺代码',
  x_8e362599: '手机号',
  x_a6eabe9b: '密码',
  x_58caca00: '骑手注册',
  x_1c3a8565: '车辆类型',
  x_8db8ee8e: '🛵 摩托',
  x_201504a8: '🚲 单车',
  x_cc31ee5d: '🚗 汽车',
  x_fbba6044: '🚶 步行',
  x_6c78bebb: '等待店主审核',
  x_4a798e43: '账号已停用',
  x_d6991a83: '已完成 ✓',
  x_9890f97b: '打印设置向导',
  x_cff3211b: '3步完成静默打印配置，打印不弹窗',
  x_26590e3f: '第1步：设置默认打印机',
  x_8fb52e11: '打开 Windows 设置 → 蓝牙和设备 → 打印机和扫描仪',
  x_86219510: '关闭「让Windows管理默认打印机」',
  x_d82f67dd: '点击您的热敏打印机（如 XP-80C）',
  x_476e0586: '点「设为默认值」',
  x_b26839a0: '第2步：复制启动命令',
  x_89eff51a: '点击下方按钮复制命令',
  x_e63a8355: '第3步：创建桌面快捷方式',
  x_4a7e4b2f: '按照以下步骤操作',
  x_39dca51d: '右键桌面空白处 → 新建 → 快捷方式',
  x_f89fc87a: '在「位置」框里粘贴刚才复制的命令',
  x_8f932a07: '点下一步，名称写 Sellox POS',
  x_631effbe: '点完成。以后双击图标即可打开收银系统',
  x_e45ed499: '复制 Edge 启动命令',
  x_a28aa67f: '已复制！',
  x_e541bfc7: '复制 Chrome 命令',
  x_eedf4bbd: '提示：如果打印出到 OneNote 或 PDF，请检查第1步是否正确设置了默认打印机。',
  x_797d0e09: '设置完成后，双击桌面「Sellox POS」图标，打印将自动发送到打印机，不弹任何对话框！',
  x_f394cfe1: 'Cuenta Mayorista / 批发账户',
  x_95e3ad97: 'Cliente / 客户',
  x_a702e3be: 'Puntos / 积分',
  x_b29b209c: 'Crédito / 信用',
  x_0170732a: 'Resumen de Deuda / 欠款总览',
  x_39ee196f: 'Pedidos Mayoristas / 批发订单',
  x_4ccb2222: 'Compras recientes / 最近购买',
  x_5f2a9420: '扫码',
  x_ecd041a0: 'Redirigiendo / 正在跳转…',
  x_9a8ed80b: 'Pago recibido / 支付成功',
  x_e7268001: 'Error al subir / 上传失败',
  x_b37d1896: 'Comprimiendo... / 压缩图片...',
  x_bd703be1: 'Procesando... / 处理中...',
  x_67c3bc10: '凭证已发送过',
  x_96d7970c: '支付已确认',
  x_0cb0251b: '支付已拒绝',
  x_ea4ccc53: '凭证已发送给收银员',
  x_8a6643a7: 'Referencia / 参考号',
  x_88e9e55d: 'Monto / 金额',
  x_230397c0: 'Fecha / 日期',
  x_e10ba955: 'Remitente / 姓名',
  x_e222bb0c: 'Teléfono / 手机',
  x_248a9885: 'Cédula / 身份证',
  x_e4f17ebf: 'Banco / 银行',
  x_31bde601: 'Tipo / 类型',
  x_2faded9f: '上传您的付款凭证截图',
  x_ff5f2a1f: 'Por favor espere / 请稍候...',
  x_ee8d09d1: '点击拍照或选择图片上传',
  x_e893f6b1: 'Datos identificados / AI 识别结果',
  x_c7c7b829: '✓ Cuenta receptora correcta / 收款账户正确',
  x_aa855a32: '⚠️ Cuenta NO coincide — revise / 收款账户不符',
  x_2f1745ef: 'Subir otro comprobante / 上传另一张',
  x_1b056098: '收银员可以实时查看此结果',
  x_7eef492b: 'Ingresa tu teléfono o código / 请输入手机号或客户编号',
  x_rider_push_banner: '开启后台来单通知（锁屏也会响）',
  x_rider_push_btn: '开启',
  x_rider_push_on: '后台通知已开启！',
  x_rider_push_denied: '通知权限被拒绝，请在手机设置里允许通知',
  x_rider_push_fail: '开启失败，请重试',
  x_rider_new_order: '新订单！',
  x_5b4d6f56: 'No encontrado / 未找到',
  x_ba825d88: 'Falta tienda / 缺少店铺',
  x_163d4734: 'Nombre muy corto / 姓名太短',
  x_d8d5dbd4: 'Teléfono inválido / 手机号格式错误',
  x_61d1e909: 'Error al registrar / 注册失败',
  x_9e478700: '🎁 Club de puntos / 积分俱乐部',
  x_4f4ed4a8: 'Tienda / 店铺 ID',
  x_e223e6f8: '📱 Teléfono o Código / 手机号或编号',
  x_400ea289: '📋 Reglas / 规则',
  x_f4ae4ba2: '1 分钟',
  x_e41c8f96: '接收生日 / 节日 WhatsApp 祝福和优惠',
  x_472eeea6: 'Hola / 你好',
  x_e0ad1b59: 'puntos / 积分',
  x_b6d516c1: 'Reglas / 规则',
  x_3207b63d: '缺勤罚款',
  x_366edeab: '工资抵扣',
  x_1eb00e63: 'Empresa le debe / 公司欠员工',
  x_ecd32f47: 'Saldo pendiente / 待还款',
  x_a93dac50: 'Saldo / 余额',
  x_e37433ef: 'A retirar en caja / 可向出纳领取',
  x_c72b5c9e: 'Horario Semanal / 本周排班',
  x_2c7d6de7: 'Movimientos recientes / 最近记录',
  x_4536f3e5: 'es / 中文',
  x_98961d8e: '⏰ Enlace expirado / 链接已过期',
  x_13cd19da: '📸 Original / 原图',
  x_855e9d6c: '✨ Mejorada con IA / AI 美化版',
  x_8cd3793f: '<div style="background:#f59e0b;border:3px solid white;border-radius:8px;padding:6px 10px;color:white;font-weight:bold;font-size:12px;box-shadow:0 4px 12px rgba(245,158,11,0.5);white-space:nowrap">🏪 店铺<',
  x_9f2178d0: '<div style="background:#ef4444;border:3px solid white;border-radius:8px;padding:6px 10px;color:white;font-weight:bold;font-size:12px;box-shadow:0 4px 12px rgba(239,68,68,0.5);white-space:nowrap">📍 您<',
  x_261541dd: '⏳ 等待骑手接单',
  x_b886ab95: '🛵 骑手已接单, 正前往店铺',
  x_a2d70627: '📦 骑手已取货',
  x_168a78b9: '🚀 骑手正在送来',
  x_c5febde0: '✅ 已送达',
  x_4babc22d: '❌ 已取消',
  x_f07cecdb: '无法获取订单状态',
  x_69deca2b: '找不到订单',
  x_638959b3: '店铺',
  x_9b16789f: '🏪 店铺',
  x_341cb93c: '📍 您',
  x_3934104b: '骑手',
  x_b1862ef3: '订单金额',
  x_1138a92b: '配送费',
  x_2541ca48: '立即更新',
  x_153942db: '下次再说',
  x_78f2095f: '发现新版本',
  x_9b601b8e: '当前版本',
  x_9ee20a30: '最新版本',
  x_49009569: '📝 更新内容',
  x_4a07f0c8: '订阅已过期',
  x_db45a2da: '您的 Sellox 订阅已过期。为避免影响营业，请尽快续费。',
  x_5eeb04af: '订阅即将到期',
  x_8dd2a3dc: '试用即将结束',
  x_01059b1d: '免费试用已结束',
  x_26a5e5a8: '开通正式版即可解锁全部功能，继续经营您的生意。',
  x_0ea5b9f4: '一次买断 · 终身授权',
  x_39bb592b: '立即续费 (WhatsApp)',
  x_dc017114: '稍后提醒',
  x_7693a3c0: '你好，我想续费 Sellox 订阅。商户：',
  x_4a6ea4ec: '7天内不再提示',
  x_feea9211: '下载二维码',
  x_04c8c8a8: '📱 Sellox 手机 App 已发布',
  x_faf8c169: '摄像头扫码 · 蓝牙打印 · 随时查营业额 — 点这里扫码下载',
  x_053877ee: '扫码下载 Sellox 手机 App',
  x_d73e6673: '📱 手机相机或微信扫一扫',
  x_9f9d3632: '手机',
  x_5c980c4f: '相机',
  x_a7185263: '或',
  x_767c7df9: '微信扫一扫',
  x_d17430c7: '对准二维码',
  x_15067f6d: '点跳出的',
  x_17dbbc8e: '下载链接',
  x_69350bb6: '→ APK 开始下载',
  x_86e36e8c: '装完就多一个 Sellox 图标 — 直接登录',
  x_6d876a09: '查看完整页面',
  x_a75406c6: '你好 Super Admin 👑\\n可以叫我做：\\n• 「给 andy 充 500 点」\\n• 「看平台总租户和 AI 用量」\\n• 「AI 余额最多的 10 个租户」\\n• 「andy 的详细信息」',
  x_720f0600: 'AI 服务不可用',
  x_d21e1fb6: '平台总览',
  x_dc45b9fc: '列出所有租户',
  x_1c101627: '余额最多的 10 个',
  x_922f1ff2: '给 andy 充 500 点',
  x_40e77bcc: '告诉我做什么...',
  x_ee98d830: '平台级控制 · GPT-5.2',
  x_dbd5f6e5: '请选择一个规格',
  x_9cc890a7: '取消',
  x_b4a55bb3: 'Permita las ventanas emergentes / 请允许弹窗',
  x_45546304: '推送到 WhatsApp (~$0.01)',
  x_3835157d: '一键双发：打印 QR 小纸 + 弹 WhatsApp 推送框',
  x_e0caf262: '快速对账',
  x_fccab93a: '应收',
  x_6e2a13a0: '需要经理确认才能结束班次',
  x_4349b878: '经理确认',
  x_49dfdd8b: '经理已确认',
  x_04070c1f: '实际清点金额',
  x_57680d2c: '应收现金',
  x_4acec17e: '备注（如有差异请说明原因）',
  x_5f411223: '返回',
  x_1e576858: 'Pedido offline sincronizado / 离线补传订单',
  x_b15d9127: '关闭',
  x_240ce88f: '交接班需要经理扫码或输入密码确认',
  x_26201f40: 'PagoMóvil验证:',
  x_eec5e9de: '💡 已默认填入系统"应收"。只需修改与实际清点不符的那一行（通常只改现金行）。',
  x_77f4b22c: '💰 开班备用金',
  x_cf80dc01: '（已加到"应收现金"中）',
  x_3b2cc96c: '如果差额来自银行手续费、小费或找零零头是正常的。如果数字对不上，请检查是否输入错误或漏记某笔。',
  x_81ab69b9: '换桌 / 合桌 / 强制关桌',
  x_555dcd4d: '还没有桌位',
  x_7188b57a: '先去 Admin → 行业模板 → 餐馆 自动建桌, 或 → 桌位管理 手动加桌',
  x_21f69613: '桌：开新单。点',
  x_b19d83e5: '换桌',
  x_6f52c7c0: '合桌',
  x_cecf0ca3: '强制关桌',
  x_2435f5bd: '商品备注',
  x_0fa5956e: '输入备注...',
  x_da36e122: '无糖',
  x_d8a56361: '少冰',
  x_358cbe41: '加辣',
  x_81f4307e: '不要洋葱',
  x_7e1d3c25: '外带',
  x_bc8d758c: '加急',
  x_11db356c: '输入订单备注...',
  x_4403fca0: '清除',
  x_2b6c52ae: '无新订单',
  x_8131eb5e: '声音已关 · 点击开',
  x_7d1a9279: '声音已开 · 点击关',
  x_e2392cc3: '暂无桌位订单',
  x_60ce5286: '处方药',
  x_2c475e48: '必须先登记客户 (姓名+电话)，方可结账',
  x_8e5fdd7c: '⚠️ 临期/过期商品:',
  x_c15301ed: '今天到期',
  x_abfc8ce7: '开班',
  x_9f22fdc1: '开班备用金',
  x_561e47de: '抽屉里现在有多少现金？用来找零。结班时系统会自动减掉这个金额对账。',
  x_b250b8da: '跳过',
  x_e2f5ed34: '开班',
  x_d43f28df: '打印价格标签',
  x_cb08c979: '搜索商品',
  x_6ff3aa66: '价格',
  x_b7704c27: '尺寸',
  x_eb10f492: '80mm 热敏（每单 1 张）',
  x_bc3c00b4: 'A4（3 列网格，省纸）',
  x_3f5cee0a: 'Cashea 加价 %',
  x_248bf378: '没有结果',
  x_8821f767: '搜索姓名或电话',
  x_aed44ac1: '客户签名',
  x_1c5dca75: 'Total / 总额',
  x_a306d0a4: '客户',
  x_b21d8bb4: '无结果',
  x_15e8601c: '现金 USD',
  x_6aad3987: '现金 Bs',
  x_edf32545: '📱 参考号银行',
  x_a31b8b65: '输入客户转账参考号，系统自动核实银行是否到账',
  x_868e4ac3: '期限(天)',
  x_9da7a7b8: '赊账协议',
  x_6c6d1878: '本人',
  x_0f76a0c9: '确认已收到所述商品，总价值',
  x_7221fd2a: '，承若在',
  x_d959b5d4: '付清剩余',
  x_96553cea: '。逾期未付商家有权依法追究。',
  x_e2b5c6cc: '品名',
  x_b10acb59: '取单',
  x_a5e0e12d: 'A FAVOR DEL EMPLEADO / 公司欠员工',
  x_17ea5dd2: '📱 Estado de cuenta digital / 电子账单',
  x_4e743c6d: 'Saldo actual / 当前余额',
  x_4ae414d7: 'Préstamos y abonos / 借款与还款',
  x_c7d9aa03: 'Mercancía a crédito / 赊货记录',
  x_8815c25b: 'Salarios pagados / 工资历史',
  x_6cb22de0: '✅ Empresa le debe / 公司欠员工存款',
  x_66ea4390: '📱 Escanea para ver tu estado de cuenta digital / 扫码查看电子账单',
  x_443de421: '报损',
  x_bb54122e: '重印小票',
  x_50c099f4: '报损登记',
  x_a1ed3194: '搜索商品名称或编码...',
  x_7959f6f5: '批发客户',
  x_e2e1c3c9: '搜索会员 (姓名/手机)',
  x_0c9545b4: '客户姓名 *',
  x_8098e2b4: '手机号',
  x_6ecea67c: '身份证号 Cédula',
  x_67f6a89e: '备注（可选）',
  x_df3c5cbe: 'USB已连接',
  x_d685a4d5: '连接USB打印机',
  x_bfff47cd: '电子秤已连接',
  x_2864a729: '连接电子秤',
  x_912cc1e7: '查单',
  x_4b8e471b: '留货管理',
  x_05cee7de: '打印价格标签',
  x_6441bd25: '刷新中...',
  x_498519d1: '刷新数据',
  x_066ae8d7: '后台',
  x_b9431793: '切换账号',
  x_c3992269: '退出',
  x_f98a4911: '提前入袋',
  x_953a783e: '离线模式 - 可正常下单，订单将在恢复网络后自动同步',
  x_4080c16f: '离线且无缓存数据 - 请先连网加载数据',
  x_8bcfc934: '缓存数据已超过24小时，价格和库存可能已更新。恢复网络后将自动刷新。',
  x_a75ed77e: '缓存数据超过1小时，建议连接网络更新。',
  x_333142e1: 'Escriba para buscar / 输入搜索更多...',
  x_7ffacc1a: '🎂 生日 Cumpleaños',
  x_787b5677: '性别',
  x_6a0ee6bd: '使用 Chrome --kiosk-printing 模式可静默打印到默认打印机（XP-80C），无需其他配置',
  x_8dc32ae4: '现金',
  x_14add33c: '刷卡',
  x_a474b44e: '转账',
  x_80263dad: '混合',
  x_7f3933e2: '赊账',
  x_86aa4552: '订单查询 / 重打发票',
  x_36bcb2a1: '搜索订单号...',
  x_0cc05f42: '从',
  x_d716f1e8: '到',
  x_83958d46: '单',
  x_85ab5250: '无订单',
  x_9109ea1e: '加支付',
  x_16a3cf1d: '改支付',
  x_d8b294d0: '打印发票',
  x_15a6696e: '80mm小票',
  x_62d36990: '加入购物车',
  x_e90b99bd: '提前入袋',
  x_6cbe5ffa: 'USD (美元)',
  x_7559edad: '请输入金额',
  x_06508433: '请输入经理 PIN',
  x_731c658b: '作废此入袋记录？',
  x_dcc961ae: '已作废',
  x_267fa274: '选择经理',
  x_3700ec74: '4-8 位数字',
  x_e20efdec: '例: 抽屉过满',
  x_e39ec276: '✅ 确认入袋',
  x_563e10ba: '作废',
  x_43c80a9b: '把抽屉里的大额现金提前交给经理，结班时系统自动扣减，清点剩余现金即可。',
  x_2ed7e4e2: '币种',
  x_ae59a48e: '交给哪个经理',
  x_a87ce55a: '经理 PIN',
  x_3a14c9f8: '备注 / Notes (可选)',
  x_b72845a8: '暂无入袋记录',
  x_db16fe15: '✅ 完成',
  x_de040917: '⚠️ 没收',
  x_56673f3a: '加载失败',
  x_f15ea525: '搜单号/客户/电话',
  x_712939e0: '金额必须大于 0',
  x_e1308cbe: '✅ 收款成功',
  x_1d5381c2: '已取消,库存已回滚',
  x_a29d3fab: '取消原因',
  x_92b67f7b: '退还定金给客户',
  x_4c2db86d: '定金归商家',
  x_0aa2fd58: '进行中',
  x_80e42329: '已完成',
  x_f3f6aad1: '已取消',
  x_9f5fa600: '已没收',
  x_7cf73f3d: '全部',
  x_4865eb9a: '没有 aparta',
  x_76898534: '余款',
  x_d941a5be: '⚠️ 已逾期',
  x_3a291eca: '💵 收款',
  x_0959981b: '✅ 已结清',
  x_353048bb: '可发货给客户',
  x_e91d829e: '取消订单需经理权限',
  x_e8606af7: '确认取消',
  x_d2dbc37e: '不取消',
  x_de1ec1b5: 'Dividir entre / 拆几等份',
  x_32cd3100: '换桌失败',
  x_26e78ec2: '合桌失败',
  x_ae1573f2: '释放失败',
  x_be163dfd: '🔀 换桌',
  x_010a57e3: '把这桌的账转到另一张空桌',
  x_f4b63ba2: '🤝 合桌',
  x_57c68729: '把另一张桌的账并到这桌',
  x_dee2caa5: '🔓 强制关桌',
  x_145ac83c: '不结账，仅释放桌位（人工对账场景）',
  x_5a43d675: '选择目标空桌',
  x_88f3038b: 'WhatsApp 会发到',
  x_b787eaf7: '号码太短，至少 8 位数字',
  x_1a5e2d7a: 'PayPal.me (一键付款',
  x_a62f3804: 'USDT (TRC20) · Tron · 手续费 ≈$1 ⭐',
  x_e9868cc5: '已复制 ✓',
  x_48eb1f6c: '📞 客服 WhatsApp (最快',
  x_50a13126: '点一下自动带货',
  x_067ff847: '💰 支付方式',
  x_57c296c9: '📝 付款说明',
  x_422c8df2: '营业额',
  x_96575b5a: '单数',
  x_2ab9e7e1: '柜台现金',
  x_9627644f: '退货',
  x_598fb8ab: '付款方式',
  x_5d5de3a9: '卖了什么货',
  x_9902bd0f: '搜货品名...',
  x_729c413f: '货品',
  x_f965fea3: '次数',
  x_b68919a3: '班次',
  x_6f862984: '开班底钱',
  x_3788667e: '现金收入',
  x_8fbe97e2: '抽走',
  x_769b69c5: '现在应有',
  x_27e303bd: '没有开班（柜台无现金数据）',
  x_3e586351: '当天没有记录',
  x_244b0c8f: '原单',
  x_ea9fedcb: '毛收',
  x_211d2fdf: '无法访问摄像头',
  x_2637e51a: '摄像头启动失败',
  x_2cbd6249: '条码未在公共库中',
  x_3016cebc: '查询失败',
  x_2a3e7f5c: '手动',
  x_092a15aa: '输入条码',
  x_9ebf3950: '用此商品创建',
  x_82cafd5c: '用此条码继续',
  x_c0079539: '查询中',
  x_eba9d01c: '条码不在公共库',
  x_913fcd49: '没有改动',
  x_9216d1be: '尺码',
  x_bbbbab6e: '颜色',
  x_f297d54c: 'Paso 2: 输入每行库存 → 保存',
  x_2f88548e: '尺码 \\ 颜色',
  x_3e616117: 'Ingresa tu teléfono / 请输入注册手机号',
  x_925ff2fa: 'Ingresa el código / 请输入验证码',
  x_798b1cb7: 'Contraseña mínimo 6 caracteres / 密码至少6位',
  x_8052ef2a: 'Las contraseñas no coinciden / 两次密码不一致',
  x_8049f1c7: 'Enviar código / 发送验证码',
  x_9d936c0f: 'Restablecer / 重置密码',
  x_a850638e: '验证码将发送到店铺注册的 WhatsApp。',
  x_6c546734: 'Teléfono registrado / 注册手机号',
  x_b3382444: 'Código / 验证码',
  x_a25bd352: 'Nueva contraseña / 新密码',
  x_134cc560: 'Repite la contraseña / 再输一次',
  x_72138076: '¡Contraseña restablecida! / 密码已重置',
  x_35973a26: 'Tienda / 店铺 ID:',
  x_0c58a4d9: 'Usuario / 用户名:',
  x_871b1e0c: '🆕 新版本已就绪，完成本单后自动更新',
  x_77dbaf27: '🆕 正在更新到新版本...',
  x_edf4de14: 'Chrome (官方',
  x_c9dc4ffd: 'Firefox ESR 旧系统支持',
  x_39400df4: '🌍 全球租户地图',
  x_ef8318a7: '💰 加密收款总览',
  x_09636666: '🔔 续费提醒(AI)',
  x_542ce2f8: '📋 试用注册',
  x_408009cf: '💳 国际支付',
  x_5910639f: '📦 批次/批号 (FIFO)',
  x_b1381d19: '🎯 RFM 分群 + 群发',
  x_559dca3c: '🏆 员工绩效详情',
  x_6e1ce46a: '打印机手册',
  x_03a9825e: '你好老板！我是你的 AI 经营助理。可以问我「今天利润多少」「最卖座产品」「库存不足」「谁欠我钱」等。',
  x_b26b0699: 'AI 服务暂时不可用',
  x_0a0092b7: '最卖座的 5 个产品',
  x_b23a6752: '哪些库存不足？',
  x_19a63387: '谁欠我钱最多？',
  x_9445221f: 'AI 经营助理',
  x_a6f1ba27: '问一个问题...',
  x_20448d20: 'GPT-5.2 · 实时查数据',
  x_943201f9: '上涨 / 涨',
  x_caecf5b4: '下跌 / 跌',
  x_f345932a: '忽略此预警',
  x_1c4d65a8: '⚠️ 汇率波动预警',
  x_2a9db7a6: '✓ 已推送 WhatsApp 老板号',
  x_b2a5c20e: '⚪ 未推送 WhatsApp（请在 FX 设置里配置老板号码）',
  x_4f100f54: '你好 Sellox！我对你们的 POS 感兴趣。',
  x_0cbf83cc: '联系我们',
  x_e9e8054f: '邮件',
  x_73325cad: '满',
  x_41f5f6ef: '减',
  x_8be34d50: '买',
  x_040f3943: '送',
  x_9aacc1c5: '特价',
  x_3fcde29c: '上传支付凭证失败:',
  x_bf7669aa: '. 请尝试用清晰一点的截图',
  x_b4c3bd30: '个无图 / Sin imagen',
  x_3cf48c32: '个已有图(可替换) / Con imagen',
  x_f653eca8: '相机不可用 (',
  x_90b6a7dd: '), 走相册回退',
  x_52983340: '家门店 · 员工无限',
  x_a40aedb7: '✅ 已发送',
  x_791333be: '条 WhatsApp',
  x_3083efed: '确定把客户「',
  x_97bbb919: '」移入回收站？\\n账目和历史不会丢失，可随时恢复。',
  x_8d6e3b74: '已移入回收站',
  x_b70e8e43: '已恢复',
  x_3580b741: '已重新启用',
  x_4a561e6f: '位字符 (已实测签名通过)',
  x_f30d10af: '箱x',
  x_cdf08038: '确定把',
  x_a24c6f3f: '条全部标记为已发？',
  x_5c51c3b8: '已导出',
  x_c0a515b2: '位客户 / Exported',
  x_2d4c5dcc: '已创建',
  x_6c0b9fed: '个商品的最低库存',
  x_ddfcb2be: '已修复',
  x_b1418bb8: '个商品负库存',
  x_fe4c8813: '\\n...还有',
  x_930882bb: '个',
  x_8cfef109: '共有',
  x_896a955f: '个无成本价商品：\\n\\n',
  x_6b73316d: '\\n\\n确认全部删除？此操作不可恢复！',
  x_5cc23262: '已删除',
  x_db0a9f72: '个无成本价商品',
  x_a2aaa24e: '一键应用全部 (',
  x_fc4d75f6: '发现',
  x_1e2b2923: '个产品漂移，共',
  x_e86ee821: '单位。立即修复？',
  x_992bce69: '个产品 (',
  x_e2f9c4d8: '单位)',
  x_e213f3ac: '✅ 已发送！ID:',
  x_30fae0dd: '✅ 已开启 — 每天 9:30AM 自动催款（同一客户',
  x_ed0dbd12: '天内不重复）',
  x_04501e0e: '✅ 已保存 — 同一客户最少',
  x_99c19d88: '天才会再次催款',
  x_11c0bdd6: '给「',
  x_04b02a3b: '」设置新的登录ID\\n当前:',
  x_951c3597: '\\n(4-20位, 字母/数字/横线/下划线)',
  x_ec9f4837: '确认把',
  x_eb7706ac: '改成',
  x_61bbc1d1: '?\\n⚠️ 该商户所有员工要用新ID重新登录, 网店链接也会变成 /shop/',
  x_f0bb4cec: '门店上限已设为',
  x_a6cdd2a0: '家',
  x_4a368d87: '确定删除',
  x_f8789f6e: '的库存记录？',
  x_4d8a497e: '确定清空',
  x_52f6f1b8: '的所有库存？此操作不可恢复！',
  x_61682ed3: '再次确认：清空',
  x_9a5e3bc8: '全部库存记录？',
  x_3683077f: '已清空',
  x_4deb231b: '条库存记录',
  x_d5d53fcf: '确定从主仓库复制所有库存到',
  x_1b3f235d: '已从',
  x_06363f80: '个商品到',
  x_dd78ca49: '✅ 充值成功！+',
  x_19e9aae9: '测试预警已触发：',
  x_adfefb8e: '切换到「',
  x_0258b3da: '」？\\n会自动创建相应的分类（已有的不重复）。可以随时再切换。',
  x_6341a6f1: '张桌子',
  x_2cf87b31: '✅ 已切换 — 新增',
  x_2cd6fde3: '个分类',
  x_f64a9820: '· 已完成',
  x_8983c664: '营收风险',
  x_b8f4e941: '对账报告',
  x_822ac472: '已匹配 (',
  x_268173c2: '未匹配验证 (',
  x_172d9095: '未匹配销售 (',
  x_d03e7311: '✅ 处理完毕：新建',
  x_11e6be8e: '· 关联',
  x_b06b30ab: '· 已关联',
  x_1b16b10a: '· 缺手机号',
  x_26b59f52: '支付',
  x_fddfa6c6: 'AI 识别完成：',
  x_6def8122: '已入库：',
  x_2ef72bb3: '项 / PO',
  x_97695dd1: 's 前',
  x_be72b0b9: 'subidas correctamente / 已上传',
  x_b0ef9048: '丢弃',
  x_24406e3e: '笔被服务器拒绝的操作?\\n\\n',
  x_8d893e60: '⚠️ 这些操作没有在服务器生效。丢弃前请确认是否需要重新操作)',
  x_61cef91b: 'eliminados / 已清除',
  x_9fb4dafd: '笔',
  x_5526ee20: '笔无主赊账,共',
  x_13743a01: '确定立即向今日',
  x_1eca306b: '位寿星发送 WhatsApp 祝福?',
  x_939d7902: '…等',
  x_2b689f7b: '已修改',
  x_0a66a2c4: '预览: 今天有',
  x_27e4f2f4: '位客户过生日',
  x_bff5e1f3: '已发送:',
  x_8e141b21: '· 失败:',
  x_2517df74: '· 跳过:',
  x_9127c4b7: '预览: 将发送给',
  x_e61704c3: '位客户 (排除',
  x_e1967cf6: '计划在',
  x_ed33b3f4: '发送tr(',
  x_00c0b64d: ')? 确认？',
  x_05235460: '已排期:',
  x_bab46d2e: '将向所有订阅客户发送tr(',
  x_6912b561: ')消息，确认？',
  x_f43d612e: '批量发送完成:',
  x_8891f2c6: '成功 ·',
  x_c3342602: '失败 ·',
  x_17fbc240: '天后',
  x_d5b805a6: '天后 ·',
  x_3b8c1c81: '已填入模板:',
  x_e46f5031: '% / 上传中',
  x_1f06712c: 'rechazadas — revisar / 被拒绝，需处理',
  x_35b7c240: '您的订阅还有',
  x_aa277e9b: '天到期，请及时续费以免中断使用。',
  x_7dc5867e: '免费试用还剩',
  x_1d74fc6c: '天。开通正式版即可继续使用全部功能。',
  x_613c2e78: '⚠️ 发现',
  x_81764eb3: '项差额较大，请核对后再结班',
  x_86103e41: '⚠ 发现',
  x_473bed24: '项小额差异',
  x_3aa832e9: '通过网店下单 #',
  x_1cda5086: '桌位订单待处理',
  x_1b95ed0e: '定金',
  x_641e1071: '≥ 最低',
  x_1c73433c: '最低',
  x_1ecba8c2: '🏷️ Crear Aparta (签完)',
  x_793d5c95: '🏷️ 创建 Aparta',
  x_4ffc9e7c: '✅ 已入袋',
  x_ced2e82c: '⬆️ 上传',
  x_2180077a: '单 / Subir',
  x_b6f69d33: '单待传 · sin red',
  x_0e6f5c6c: '的账合并到',
  x_d8817d65: '🤝 合并完成 ·',
  x_dce1d1f6: '项 ·',
  x_09e8990d: '确认强制关闭',
  x_7e05053e: '? 该挂单不会自动结账。/ Liberar la mesa sin cobrar?',
  x_7f673278: '已释放',
  x_050ed17c: '✅ Encontrado / 找到了:',
  x_3bdece77: '✅ 生成',
  x_7a656cfc: '个变体',
  x_271f3942: '行库存',
  x_c53f6031: '行 · 失败',
  x_2d5aef4f: '行',
  x_b491196a: '界面崩溃 / UI crash:',
  x_296304f1: '今日',
  x_d8886c56: '位客户生日 — 一键群发祝福',
  x_e292789d: 'Estado / 状态',
  x_6165a875: '锁定到:',
  x_ba1267f0: '上次更新 / Ultima actualización:',
  x_65d9f49b: '待发送消息 (',
  x_764665c3: '全部 (',
  x_028a9628: '创建 "',
  x_a0f73e03: '修改分类 —',
  x_fa5bee02: '⚠️ 已排除：',
  x_dce0ab9f: '— 这些支付方式的订单将不发积分',
  x_27651c15: '30天售',
  x_1b3ba792: '最低库存:',
  x_04d8e11a: '(现:',
  x_efa4cb5c: '个 / 日均',
  x_6f7909ea: '自动发送 WhatsApp 收据',
  x_0141c048: '自动催款 (账期到期 WhatsApp)',
  x_041a7a49: '天 — 客户被催过后，就算他还没还，也要等',
  x_72f50f4b: '🤖 WhatsApp 自动核销付款',
  x_4c0d90b0: '当前 wa-web 已被其他租户占用 (',
  x_5250451c: 'Sellox 现在可以通过您的 WhatsApp (',
  x_24d49a39: '天内只发 1 次',
  x_97f6b93d: ') — 一台服务器同时只能一个租户开启',
  x_4d4bb206: ') 给任何客户自动发消息。',
  x_6dcb77fd: '门店上限 —',
  x_2fd10482: 'Inventarios pendientes de aprobación / 待审批盘点 (',
  x_49f610ec: '个商品没有设置成本价',
  x_22261f15: '保存配置 / Save',
  x_b45c0413: '发送测试预警 / Send Test',
  x_4d2afcd3: '已完成（最近 2h）',
  x_e0385134: '待制作 ·',
  x_d7104c13: '制作中 ·',
  x_c02e8b6b: '💡 落地页 Buy 按钮会展示: WhatsApp客服',
  x_889e1514: '· 其他',
  x_6f2e8e74: '当前行业:',
  x_26f914e7: '设定时间:',
  x_9657acc8: '💡 例: 客人点 $20 → 自动加 $',
  x_dc0ccfb0: '服务费 → 总额 $',
  x_6690b55c: '⏳ 待审核 (',
  x_a6b994c5: '✓ 已认证 (',
  x_0a4b9139: '已停用 (',
  x_c7c68337: '把这个链接发给你想招的骑手 →',
  x_bb5bb60d: '保存设置 / Guardar',
  x_81cf7805: '租户列表 (',
  x_a2b4e1d9: 'AI 续费提醒草稿',
  x_b6733812: '· 国家',
  x_e852c9a4: '店',
  x_a2cf4af4: '· 电话',
  x_4b2603c3: 'App Name 填一个随意名字（例：',
  x_bccb0533: '班次汇总 (',
  x_80a13d4d: '转账:',
  x_f576986b: '开始对账',
  x_ad131c12: '笔 $',
  x_54213898: '明细 (',
  x_4209a9ba: '1 点 = $',
  x_7a2c820b: '（复制上面那个',
  x_184b4831: '4. 确认发送 → 1-2 分钟 AI 学分自动 +',
  x_8b2a4731: '订单:',
  x_0b463505: 'USD · 余额不足时 AI 功能会暂停 · 联系平台管理员充值',
  x_be11172d: '个试用商户',
  x_8ae8f95e: '年费有效期至:',
  x_d3d43df8: '等待 USDT 到账 —',
  x_30c0ee04: 'USDT 续年费 $',
  x_1a810c50: '店版',
  x_f8f63ea1: '(售$',
  x_ea6914b3: '/ 进$',
  x_8f3599b6: '置信度',
  x_02456a77: '条码:',
  x_b4fdcd01: '更新成本价 (原',
  x_a3f28012: '建议售价（+',
  x_8375f775: '箱×',
  x_2c0e9a33: 'Encolado / 入队:',
  x_b8bfc6ea: 'cambios pendientes de subir / 项待上传',
  x_f15ef0a0: '笔 · 客户付美金',
  x_fadfbb89: '笔 · ≈',
  x_8e52492c: '一键发送',
  x_777ba9db: '件商品',
  x_60c22af0: '消息模板 (支持变量',
  x_2aabd245: '预览结果:',
  x_32e0b823: '未来 30 天生日 (',
  x_4e1abb5c: '消息内容 (支持',
  x_122c804a: '待发送计划 (',
  x_d0176d3e: '发送记录 (近 50 条 · 共',
  x_f2b7c51d: '待发',
  x_fb9b45b1: '· 优惠券',
  x_8e9b7f87: '个节日',
  x_4ca669c7: '已发 ·',
  x_7100dc7a: '跳过 ·',
  x_ff8318c2: '⚡ 指派给你 / ASIGNADO A TI',
  x_f1f28de8: '登录 / Iniciar sesión',
  x_ed2d1a22: '提交注册 / Enviar',
  x_618ab9b1: 's 内确认',
  x_49074539: '预估周薪: $',
  x_9013fa6e: '订单 #',
  x_1b3e5894: '骑手',
  x_d7d4b3fc: '正在送',
  x_875225ef: '— 选规格 / Selecciona talla y color',
  x_8dcf5483: '📤 已交经理 / Early Drops (',
  x_69a49f6a: '📩 网店新订单 (',
  x_532e7e2f: '项 · #',
  x_f38a0357: '处方药客户已登记:',
  x_2105a088: '天后到期',
  x_f77c9383: '更多...',
  x_56f0d339: '到期日 ≈',
  x_4727e7e1: '美元',
  x_4b8b23a7: '天内',
  x_100bd194: '件商品 ·',
  x_56ec6c2c: '% 最低定金 = $',
  x_338f8935: '库存:',
  x_dd8e89b9: '更多商品... 输入关键字搜索',
  x_698818eb: '待同步:',
  x_2751b59b: '金额 / Amount (',
  x_423485d6: '📜 本班次已入袋 (',
  x_9fb8b1b7: '🏷️ Aparta / 留货管理 —',
  x_f9659c1d: '余 $',
  x_e7feb554: '💯 收余款 $',
  x_d127a089: '选择要合并过来的桌 (该桌的账会合并到',
  x_d0846a09: '✓ 在',
  x_1e68d525: '查询 / Buscar',
  x_d7b1fd5f: '找到',
  x_5f6ef156: '生成组合 / Generar',
  x_29953c6f: '待保存',
  x_50918dbc: '个变体 ·',
  x_fc461ac5: '保存库存 (',
  x_e468fa4f: '⚠️ 您的浏览器太旧 / Your browser is outdated —',
  x_9ba1a642: '（阈值',
  x_f876a49c: '% · 建议检查商品售价）',
  x_795eaf50: '打印',
  x_8059771f: '📦 缺图',
  x_cec3f014: '🖼️ 替换不好看',
  x_532c8856: '拍照',
  x_207eb32c: '🖼️ 从相册选',
  x_2425155d: '💡 把商品放在亮色平面上,正面拍最清晰',
  x_9cf1afed: '对焦中, 请保持稳定 ~1 秒',
  x_77abc2a1: '👇 选择保留哪张',
  x_2d86ed95: '保留原图',
  x_82fc4841: '相机启动中...',
  x_8df3213a: '用 AI 版',
  x_781f0d75: '重拍',
  x_dd740dc5: '两位共同老板平等接收账目。AI 每天或每月自动通过 WhatsApp 发送详细销售报告给两位老板。',
  x_2eb1e982: '📅 每天 Diario',
  x_d5ac2190: '📆 每月 Mensual',
  x_b5c8b0a2: '📊 商务',
  x_3706b4d0: '😊 友好',
  x_e366ccf1: '设置',
  x_0a9c8842: '预览',
  x_c7db6d4f: '恢复',
  rider_reset_pw: '重置密码',
  rider_navigate_btn: '开始导航',
  rider_navigate_addr: '按地址搜索',
  rider_forgot_hint: '忘记密码？请联系店主，在后台「配送骑手」里为你重置密码',
  x_5fb1fd09: '积分二维码海报',
  x_aba55e6b: '扫描链接:',
  x_6f7fff38: '下载 PNG',
  x_bc96a998: 'NowPayments 配置状态',
  x_4fc91b55: '扫一扫 轻松购物',
  x_c154a693: '打印机设置手册',
  x_6b78e860: '安装 QZ Tray',
  x_75688f20: '配置打印机',
  x_12ee3d19: '出单操作',
  x_90167330: '常见问题',
  x_433baf5e: '下载 QZ Tray',
  x_27db0784: '下载证书',
  x_5482983f: '🔥 30 天活跃',
  x_01b2a86b: '🎂 今日生日',
  x_6810ae91: '📱 导出客户名单 CSV → 导入',
  x_59556b40: '全部标记已发',
  x_1535fcfa: '发送',
  x_b1731af3: '导出客户清单',
  x_58f4fc4b: 'APP → 建广播列表（一次 256 人）→ 群发促销/生日',
  x_28cfe557: '暂时保留',
  x_23532881: '新商品',
  x_ed3046c5: '创建并添加到采购单',
  x_71e9bba3: '删除（永久移除）',
  x_846e5470: '隐藏（归档保留记录）',
  x_a9818765: '🎯 不发积分的支付方式',
  x_e1d9e1d6: '勾选的支付方式将不计积分。例如勾选「现金」→ 现金支付的订单不发积分，鼓励顾客用银行卡',
  x_00155faf: '生成我的推荐码',
  x_040f51a6: '复制码',
  x_879058ce: '复制链接',
  x_db07affa: '负库存归零',
  x_8f9b2023: '删除无成本价商品',
  x_07c8a48c: 'WhatsApp 自助连接 (免费 / 无限发送)',
  x_ed2be317: '扫码一次，永久挂载您的 WhatsApp 账号到 Sellox 系统。给所有客户/员工发自动消息无需 join。',
  x_8277b145: '开启后，客户结账时如果有手机号 + 已订阅 WhatsApp 通知，',
  x_301c285f: '收银员无需手动点击 wa.me。',
  x_4fa7c9cc: '避免每天骚扰同一个人。',
  x_fdbb8738: '⚙️ 范围 1-60 天。建议: 紧的客群 3 天，普通 7 天，大客户 14-30 天。',
  x_bbe42801: '🔒 每张截图独立扣 1 个 AI 凭证额度 — 同张图 5 分钟内重复发送自动忽略。',
  x_9eba1d0b: '二维码每 25 秒自动刷新 — 别担心扫不上',
  x_a3ac5646: '已挂载:',
  x_5319c74b: '会在 30 秒内',
  x_78623eae: '每天',
  x_b036b784: '同一客户',
  x_2ee44035: '💡 比如设',
  x_ef49a64e: '客人把转账截图',
  x_676ea371: '还会自动回复客人「✅ Pago confirmado / 订单已确认」。',
  x_69893eef: '💡 这是 AI 识别后**找不到精确匹配订单**时，凭证会被记录到这家店的「付款核销」列表里供店员手工处理。',
  x_1b037636: '🔌 连接',
  x_771d235b: '🎂 节日/生日营销',
  x_75c856b1: '登出',
  x_2abe9e2c: '电子小票链接 —',
  x_2b9efa91: '当前关闭中 — 开启后效果立即生效',
  x_acabef73: '自动扫描所有赊账记录 — 给',
  x_e30c7cd7: '的客户发 WhatsApp 提醒。',
  x_5a445658: '，不会重复打扰。也可在',
  x_95de8c70: '」页面手动一键催款。',
  x_8ee2848b: '，AI 自动识别参考号/金额，',
  x_53eb1951: '近 48 小时的待付订单并标记已付，',
  x_01276a67: '🏭 行业',
  x_60624b98: '清理孤立库存',
  x_1c74acdb: '补全库存记录',
  x_01702b13: '清除全部订单（危险）',
  x_fcc3d39a: '自动修复',
  x_be0ade04: '重建索引',
  x_fd76118e: '导出数据备份',
  x_aac9e1d1: '充值',
  x_a8fc5824: '请在商品管理中设置成本价后重新查看。',
  x_67c6118c: 'Paralelo 汇率与昨天对比，超过阈值就触发预警（WhatsApp + 横幅 + Audit Log）',
  x_a2084b07: '触发阈值（%）',
  x_66bfebe7: '老板 WhatsApp 号码',
  x_c0d5d68f: '忽略',
  x_e38cac91: '↶ 重新打开',
  x_842010db: '全屏',
  x_a24983d8: '📞 客服 WhatsApp (必填)',
  x_48912e07: '🪙 USDT (稳定币, 全球通用)',
  x_1d7f3562: '🧩 其他支付方式 (Wise/Zelle/Binance Pay...)',
  x_bad080e4: '📍 切到服装店后，商品编辑页可以填尺码/颜色变体。',
  x_7f9f889d: '开启后，餐馆 POS 收银结账时会**自动**在小计后面加上 X% 的服务费。',
  x_9dad4122: '收银员可单笔关掉。客户的小票也会显示这一行。',
  x_47bd55cf: '如果你已经有商品分类，建议先用「',
  x_7b6d74a4: '📍 切到餐馆后，左菜单会出现「🍽️ 桌位管理」。',
  x_78841a5c: '切换行业**只是新增分类**，不会删除你已有的商品/分类。',
  x_6c525ddf: '」，然后只用你需要的功能（比如餐馆桌位）。',
  x_8d63ef38: '暂停',
  x_e7c3bc5c: '骑手注册时填店铺代码',
  x_7037508b: '💡 排序规则：',
  x_23c1f399: '通过',
  x_7173f809: '拒绝',
  x_a5978c43: '(或者你的 tenant ID), 你会在这页看到「待审核」, 通过后他就能接单了。',
  x_70f983d4: '用当前位置（在店里点这个）',
  x_13e8fee8: '· 越近+越空闲优先 ·',
  x_929fc89b: 'AI 消息风格:',
  x_144db44b: 'AI 提醒',
  x_9d6f026a: '📖 首次使用？点这里看完整设置教程',
  x_7bd0aecf: '费用：~$0.01 / 条（Meta Cloud API，超过 24h 服务窗外）',
  x_9fe61acb: '关闭后，店员仍可在「订单完成」弹窗手动点 [WhatsApp] 按钮发送',
  x_1dcf3bf4: '把下面两个值**复制**到 Meta 的 Webhook 页面（左侧菜单',
  x_a4e7978d: '条件：① 老板勾选此开关 ② WhatsApp 已配置启用 ③ 客户已建档+有手机号 ④',
  x_defd4e63: '→ 勾三个权限:',
  x_31aadde4: '卡片里填：',
  x_922a7731: '自动回复',
  x_85849d21: '④ 自动 WhatsApp 电子收据',
  x_83413c5e: '— 在 客户管理 / 新建客户时勾选即可',
  x_88b8d068: '打印报告',
  x_88ae41b0: '服装变体库存',
  x_1af9ab5b: '🔗 一键关联顾客档案',
  x_0563df42: 'USDT 加密支付',
  x_6ae048ae: '取消',
  x_6503c16e: '支持 USDT TRC-20（手续费极低）· 支付后约 1-2 分钟自动到账 · 无 KYC',
  x_3eb35747: '状态',
  x_90ef892d: '复制地址',
  x_4f8d48ef: '刷新状态',
  x_5b9fc057: '备用付款页',
  x_c4ab90ae: 'WhatsApp 跟进',
  x_f1d9634a: '打开 WhatsApp',
  x_81930d76: '已激活买断:',
  x_69774c73: '复制地址',
  x_84f49b2a: '年费维护',
  x_1ecf95c4: 'AI 拍照入库',
  x_075b05f1: '更新售价 →',
  x_1d447944: '拍下一单',
  x_ae765162: '选择续费套餐 · USDT TRC-20',
  x_b610fd7a: '当前订阅',
  x_04a54e6d: '全部已同步',
  x_f9885395: '被服务器拒绝的操作',
  x_4606c263: '— ⚠️ 这些操作没有生效！请看下方原因：需要修正后重新操作，确认无用后再丢弃。',
  x_2395acb4: '一键清除所有失败',
  x_8dd7df98: '离线时您做的任何修改（加商品、赊账、库存等）会自动出现在这里，恢复网络后自动上传。',
  x_a1ef1534: '美金价值',
  x_70f80ce3: '🎂 今日有',
  x_5248ea19: '位寿星！',
  x_49bc061f: '客户:',
  x_e6c8ab7b: '使用此模板',
  x_115028a6: '生日自动祝福',
  x_ae8e4235: '预览今日',
  x_bb4c3061: '立即发送今日',
  x_f45f7f98: '节日 / 促销群发',
  x_8e4d1d3b: '预览人数',
  x_acac71c9: '没账号？立刻注册',
  x_b7074575: '← 返回登录',
  x_7f8fb4ff: '⚠️ 注册后需要等店主在后台审核通过才能开始接单。请耐心等待 30 分钟左右。',
  x_1c88cdf2: '你的注册已收到。店主审核通过后，你就能看到订单并接单。一般 5-30 分钟，请耐心等待。',
  x_f0d22726: '📋 可抢',
  x_3d0cf184: '🛵 在送',
  x_24eee8a8: '👤 我的',
  x_79646591: '暂时没有新订单, 等等再刷新',
  x_7957b16f: '✅ 接',
  x_2f3b0a05: '✖ 让给别人',
  x_350d4758: '🚀 我要接单',
  x_edc9f0b4: '还没有订单',
  x_6cb26531: '📦 已到店取货',
  x_26407f6e: '🚀 开始配送',
  x_285135ae: '✅ 已送达, 收款完成',
  x_3f53cc4a: '注册后需店主审核通过才能接单',
  x_4a566f8e: '用 Google 地图导航',
  x_e33fe8b5: '退出',
  x_52dc2f55: '登录',
  x_d839dff6: 'AI识别中...',
  x_70654539: '您还不是本店会员。填下面表格',
  x_ae1f9579: '免费注册，下次消费立刻开始累积积分 🎁',
  x_295a203d: 'Regístrate gratis 免费注册',
  x_3e869d4a: '本周暂无排班',
  x_c7a3ad5d: '已结清',
  x_fa9a9ed5: '忘记密码?',
  x_5dac1074: 'Coloca el producto sobre fondo claro · 在亮色背景拍最清晰',
  x_b2d24a53: '选择用哪张',
  x_ab4a66f9: '用原图',
  x_cd32a3bc: '拍照',
  x_d978ee93: '用 AI 版',
  x_ad7db97f: '重拍',
  x_757bfeeb: '配送跟踪',
  x_b01f7e91: '正在为您匹配最近的骑手... 一般 1-3 分钟',
  x_f2dec5f3: '页面每 5 秒自动刷新',
  x_c1558ab2: '送达证明',
  x_b426bb47: '⚠️ 此版本必须更新才能继续使用',
  x_f26ef914: '下载',
  x_4ddef578: '直接下载',
  x_2905f1e3: '加入购物车',
  x_fa8d0ac2: '↺ 全部重置为应收',
  x_cf5fddcb: '💡 点',
  x_4bf93975: '⋮ 长按或右上角小图标：',
  x_1f15f435: '桌：调出该桌挂单到购物车。',
  x_d432ce48: '显示 $ USD',
  x_910a7387: '显示 Bs.',
  x_fdf6f7f6: '显示名称',
  x_37c233bc: '显示规格',
  x_b8da42c6: '显示编号',
  x_eaeef91b: '张标签',
  x_288f0c40: '清空',
  x_e429696c: '打印',
  x_61a0eed9: '创建留货',
  x_bcc9eb9f: 'ℹ️ 创建后立即扣库存,WhatsApp 自动发收据给客户',
  x_13b83977: '客户签名确认',
  x_2fe011c2: '📜 赊账协议',
  x_7c82e213: '客户已阅读并同意以上条款',
  x_ba00b607: '定金',
  x_4d28eb40: '刷新',
  x_28a2f60d: '📨 允许 WhatsApp 通知（收据 + 生日祝福）',
  x_5698e78f: '📤 提前入袋',
  x_c052324e: '到期:',
  x_e56c9982: '确认收款',
  x_386c1cb4: '取消订单(还原库存)',
  x_e6a96594: '💡 这是给客人的「分账小票」 — 实际收款仍按总价一次结算',
  x_eb695f9f: '✅ 已同步',
  x_ba769ad1: '← 返回',
  x_50d1e443: '⏳ 在线支付正在开通中。请通过上方',
  x_9747fec8: '付款后请把截图发给 WhatsApp 客服 → 30 分钟内激活您的 Sellox 账号 ✅',
  x_d6e0b32d: '联系客服完成购买，30 分钟内激活账号。',
  x_2070ff11: '扫码新增商品',
  x_a9cebdd2: '把条码对准摄像头 → 自动识别',
  x_0e626263: '💡 USB 条码枪扫一下条码 → 输入框自动填好 + 自动回车',
  x_b779b5fc: '手动填名称 + 价格即可。点「使用此条码」会预填条码字段，AI 可帮您生成产品图片。',
  x_1ee3ff57: '摄像头',
  x_5f78052a: '手动输入 / 条码枪',
  x_c600be33: '尺码 × 颜色变体',
  x_0c240da9: '⚠️ 生成会覆盖现有变体（库存数据保留时如果尺码/颜色未变会被自动迁移）',
  x_443da31a: 'Paso 1: 输入尺码和颜色（用英文逗号',
  x_e0baad05: '分隔），点「生成」即创建组合',
  x_fc14f592: '找回密码',
  x_2a86dd91: '换个号码',
  x_49f38495: '去登录',
  x_ffcd6690: '某些功能（如离线收银、PWA 安装、扫码枪等）可能**不工作**。建议升级到以下浏览器：',
  x_a415f6c2: '界面发生错误',
  x_d470d3d3: '界面显示出错，这笔单不一定已入账！请点「关闭」恢复，然后在「最近订单」核对是否有这笔单；没有就重新收款。',
  x_8d2f4bdd: '关闭',
  x_5428abef: '重新加载',
  x_f1a0be3e: '查看历史 / 设置阈值',
  x_fix_shop_confirm: '点击下方"确认下单"按钮',
  x_fix_bosspin_3: '3. 修改类（改价/退单/调库存/发催收）会回复"需要老板PIN"。',
  x_fix_profit_warn: '，利润计算不准确（显示为"?"）。',
  x_fix_intlpay_empty: '尚未添加。点右上角"添加"来增加任意支付方式（Wise/Revolut/Zelle/Binance Pay/Pix/Western Union 等）',
  x_fix_rider_flow: '新订单 → 系统挑选距离最近、空闲的骑手 → 60 秒倒计时确认 → 不接则自动让给下一位 → 全部拒绝才回到"手动派单"',
  x_fix_rider_gps: '骑手需要 5 分钟内 GPS 心跳才算"在线"',
  x_fix_super_outbox: '点"发送"会自动加入 Outbox + 同时打开 WhatsApp 网页/App，你只需点 ➤ 发送箭头即可。',
  x_fix_pin_lock: '连续 5 次错误会锁定 15 分钟',
  x_fix_none: '无',
  x_fix_agotado_tip: '• 如果系统显示"AGOTADO"但实物明明有货 → 去',
  x_fix_days_remind: '天才会被再次提醒。',
  x_fix_rider_fee_example: '💡 例：起步 $1.0 + 每公里 $0.3，距离 5km → 配送费 $1 + $0.3×5 =',
  x_fix_all: '全部',
  x_fix_wa_reply_tip: '收到后，在 WhatsApp 里回复"报表" → AI 会用真实数据回答 🎉',
  x_fix_usdt_note: '支持 USDT TRC-20（手续费极低）· 支付确认后自动延长订阅 · 1 个月 = 30 天 · No KYC',
  x_fix_apk_download: '点"下载"将跳转到浏览器下载新 APK',
  x_fix_shift_prefill: '💡 已默认填入系统"应有金额"。只需修改与实际清点不符的那一行（通常只改现金行）。',
  x_fix_added_expected: '（已加到"应有金额"中）',
  x_fix_usb_scanner_tip: '💡 USB 条码枪也用"键盘"模式',
  x_m0: '',
  x_m1: '一月',
  x_m2: '二月',
  x_m3: '三月',
  x_m4: '四月',
  x_m5: '五月',
  x_m6: '六月',
  x_m7: '七月',
  x_m8: '八月',
  x_m9: '九月',
  x_m10: '十月',
  x_m11: '十一月',
  x_m12: '十二月',
  x_fix_all_stores: '全部门店',
  next: '下一个',
  priceEdited: '已改价',
  noProducts: '未找到商品',
  spec: '规格',
  cedula: '身份证号 Cédula',
  goToAdmin: '进入后台',
  switchAccount: '切换账号',
  refresh: '刷新',
  addPayment: '加支付',
  editPayment: '改支付',
  transfers: '调货收货',
  submitting: '提交中...',
  marginPercent: '利润率',
  autoCalcPrice: '系统自动算价格',
  taxRate: '税率',
  pendingTransfers: '待收货调货单',
  noTransfers: '没有待收货的调货单',
  saved: '已保存',
  scheduleTemplates: '排班模板',
  new: '+ 新建',
  weeklySalaryEstimate: '周薪预估',
  morningShift: '上午',
  afternoonShift: '下午',
  off: '休',
  clickToToggle: '点击格子循环切换',
  noPermission: '权限不足',
  invalidPrice: '请输入有效价格',
  noNewKitchenItems: '✅ 已挂单 (无新菜，未打印)',
  addCustomerSuccess: '客户添加成功',
  quickPriceTooltip: '快速售卖 - 直接输入价格（烟/袋子/散货）',
  quickSell: 'Venta Rápida / 快速售卖',
  quickSellHint: '无条码商品：烟/袋子/散货等，直接输入价格即可加入购物车',
  priceInCurrency: '价格',
  itemNameOptional: '名称（可选）',
  itemNamePlaceholder: '例如：烟 / Cigarro / 袋子',
  barcodeNotFound: '条码未匹配商品',
  creating: '创建中...',
  reprintReport: '重打报表',
  customers: '客户',
  equivalent: '等值',
  summary: '汇总',
  orderDetails: '商品明细',
  deleteProductWarning: '注意：删除商品会影响所有分店！',
  confirmResequence: '确定要按名称排序重新编码所有商品吗？(01, 02, 03...)',
  labelPaperSize: '标签纸',
  salary: '工资 ($)',
  x_fix_iva_enabled: '启用 IVA 增值税',
  x_fix_iva_included: '价格已含 IVA',
  x_fix_igtf_label: 'IGTF 3% — 外币(USD)支付附加税',
  x_fix_min_salary_note: '按官方公报(Gaceta Oficial)现行最低工资。用于月度工资单(LOTTT 第106条)。',
  x_fix_404: '页面不存在',
  x_fix_404_home: '← 返回首页',
  einv_menu: '电子发票',
  einv_title: '电子发票 (SENIAT)',
  einv_subtitle: '数字化开票预备 — 税务档案、IVA 与导出',
  einv_tab_profile: '税务档案',
  einv_tab_invoices: '发票列表',
  einv_tab_health: '体检诊断',
  einv_tab_export: '导出',
  einv_rif: 'RIF 税号',
  einv_razon: '法定名称 (Razón Social)',
  einv_address: '税务地址',
  einv_phone: '电话',
  einv_taxpayer: '纳税人类型',
  einv_taxpayer_ordinario: '普通纳税人',
  einv_taxpayer_especial: '特别纳税人',
  einv_apply_iva: '结账时加收 IVA (售价不含税)',
  einv_apply_iva_hint: '开启后: 收银台按每个商品的税率 (16%/8%) 在收款时自动加上 IVA。',
  einv_saved: '税务档案已保存',
  einv_not_enabled_title: '模块试点中',
  einv_not_enabled_desc: '电子发票功能正在预备阶段。请联系 Sellox 为您的商户开通试点。',
  einv_run_health: '运行体检',
  einv_profile_missing: '税务档案缺少字段',
  einv_orders_total: '期间发票数',
  einv_orders_ready: '电子发票就绪',
  einv_missing_rif: '缺客户 RIF/C.I.',
  einv_missing_fiscal: '缺发票号',
  einv_products_no_tax: '商品未设税率',
  einv_ready_pct: '就绪度',
  einv_invoice_no: '发票号',
  einv_control_no: '控制号',
  einv_date: '日期',
  einv_customer: '客户',
  einv_customer_rif: 'RIF/C.I.',
  einv_total: '总额',
  einv_iva_col: 'IVA',
  einv_status_ready: '完整',
  einv_status_incomplete: '不完整',
  einv_pos_rif: '发票 RIF / C.I. (可选)',
  einv_load: '加载',
  einv_export_hint: '按日期范围导出 SENIAT 就绪格式的发票 (XML / CSV / JSON)。',
  einv_none: '该期间没有发票',
  einv_ok_all: '全部就绪 — 税务档案完整',
  wa_connect_mine: '连接我自己的 WhatsApp 号',
  wa_connect_started: '正在启动会话，二维码几秒后出现，请稍候…',
  wa_channel_title: '发送通道',
  wa_channel_platform_title: '平台号代发（推荐新店）',
  wa_channel_platform_desc: '无需扫码，小票和通知由 Sellox 官方号代发，自动附"请勿回复"',
  wa_channel_own_title: '用自己的号（下方扫码连接）',
  wa_channel_own_desc: '客户看到的是你的号，可以回复互动（AI 店员可用）',
  wa_channel_meta_title: '官方 Meta API（永不封号）',
  wa_channel_meta_desc: '连接自己的 Meta 商务账户，内置逐步教程',
  wa_channel_configure: '去配置 →',
  wa_channel_on: '✅ 已切换为平台代发',
  wa_channel_off: '✅ 已切换为自己的号码',
  wa_relay_usage_month: '📊 本月已代发 {n} 条',
  qs_assigned: '已分配',
  qs_paid: '已收款',
  qs_due: '应收',
  qs_hint: '💡 直接在方式框里输入金额，多个框=拆分支付',
  qs_missing: '还差',
  qs_change: '找零',
  wa_not_connected: '未连接（可扫码绑定自己的号）',
  wa_platform_fallback: '当前消息通过 Sellox 平台号代发。连接自己的号后，客户将看到您店铺自己的 WhatsApp 号。',
  wa_own_number_hint: '每个商户可绑定自己的 WhatsApp 号 — 扫一次码永久挂载。',
  sx_cost: '成本',
  sx_taxable_base: '含税基数 (Gravado)',
  sx_exempt: '免税金额 (Exento)',
  sx_iva: 'IVA 增值税',
  sx_total: '总金额',
  sx_gravado_sales: '含税销售',
  sx_exento_sales: '免税销售',
  sx_iva_due: '应缴IVA (16%)',
  sx_tax_card_title: 'IVA / 税务汇总',
  sx_pkg_title: '会员次卡',
  sx_pkg_new: '新建次卡',
  sx_pkg_defs: '卡种定义',
  sx_pkg_sold: '客户持卡',
  sx_pkg_sell: '卖给客户',
  sx_pkg_redeem: '核销1次',
  sx_pkg_left: '剩',
  sx_pkg_times: '次',
  sx_pkg_name_hint: '名称 (例: 剪发10次卡)',
  sx_pkg_sessions: '次数',
  sx_pkg_price: '售价 $',
  sx_pkg_days: '有效天数',
  sx_pkg_customer: '客户',
  sx_pkg_paymethod: '收款方式',
  sx_pkg_confirm: '确认售卡',
  sx_pkg_none: '还没有次卡',
  sx_pkg_sold_none: '还没有卖出的次卡',
  sx_menu_packages: '会员次卡',
  sx_note_no_spicy: '不要辣',
  sx_note_no_sauce: '不要酱',
  sx_note_egg: '加蛋',
  sx_note_well_done: '全熟',
  sx_note_less_salt: '少盐',
  sx_note_no_cheese: '不要芝士',
  sx_usd_toggle: '💵 美金收款 (USD)',
  sx_cashier_price_switch: '🔓 收银员可切换价格 (P1/P2/整箱)',
  sx_usd_off_info: '前台POS将隐藏美金切换，只能用 Bs 开单收款（仍显示BCV汇率参考价）',
  sx_cashea_pct: 'Cashea 加收 %',
  sx_cashea_pct_hint: '用Cashea支付时自动在总价上加收此百分比（0 = 不加收）',
  sx_variant_pick: '请选择规格 (尺码/颜色/口味)',
  sx_recargo: '加收',
  sx_customer: '客户',
  sx_subtotal: '小计(不含税)',
  sx_discount: '折扣',
  sx_promo: '促销',
  sx_promo_incl: '已含在单价',
  sx_cost_usd: '成本 $',
  sx_cost_bs: '成本 Bs',
  sx_profit: '毛利',
  sx_sales_summary: '销售摘要',
  sx_loading_orders: '正在加载订单数据，请稍候…',
  sx_loss_alert: '亏本商品',
  sx_stale_alert: '价格过期',
  sx_loss_hint: '去掉IVA后净卖价低于成本，卖一件亏一件',
  sx_stale_hint: 'Bs价还是旧汇率算的，或超过30天没更新价格',
  sx_net_price: '净价(去IVA)',
  sx_loss_each: '每件亏',
  sx_current_bs: '现Bs价',
  sx_expected_bs: '应为Bs',
  sx_days_no_update: '未更新(天)',
  sx_reason_rate: '旧汇率',
  sx_reason_old: '太久没更新',
  sx_production_date: '🏭 生产日期',
  sx_expiry_alert: '临期商品',
  sx_expiry_hint: '30天内到期或已过期，赶紧促销',
  sx_days_left: '剩余',
  sx_expired: '已过期',
  sx_batch_expiry: '本批有效期',
  sx_export_products: '导出Excel',
  sx_payment_breakdown: '收款分解',
  sx_orders_count: '单据数',
  sx_items_count: '件数',
  sx_total_bs: '总额 Bs',
  sx_cash_usd: '现金 $',
  sx_cash_bs: '现金 Bs',
  sx_avg_ticket: '平均客单',
  sx_gravado: '打税总额',
  sx_exento_short: '免税总额',
  sx_subtotal_short: '小计',
  sx_tax_total: '税总额',
  sx_pay_total: '支付总额',
  sx_printer_default: '默认打印机',
  sx_fiscal_machine: '税务打印机',
  sx_fiscal_already: '🧾 此单已开过财政票, 不能重复开 (避免重复入税务账)',
  sx_fiscal_done: '已开财政票',
  sx_fiscal_desktop_only: '税务打印机仅桌面版可用 (COM)',
  sx_pretax: '税前',
  sx_customer_display: '客显屏 (顾客第二屏)',
  sx_ws_mode: '批发模式 (B2B)',
  sx_ws_mode_desc: '开启后：网店游客看不到价格；顾客需注册并等您批准(客户管理里打开"批发客户"开关)才能看价下单；按整打/整包起订。',
  sx_ws_locked: '注册批发客户后可见价格',
  sx_ws_apply: '申请批发账户',
  sx_ws_pending: '您的批发账号正在审核中，店家批准后即可查看价格下单',
  sx_ws_pending_badge: '批发申请待审',
  sx_ws_moq: '起订量',
  sx_ws_moq_hint: '默认起订量(打)，商品有装箱数时按装箱数',
  wsx_zone: '批发专区',
  wsx_go_retail: '去零售店',
  wsx_go_mayor: '批发入口',
  wsx_closed_retail_title: '本店只做批发',
  wsx_closed_retail_sub: '零售通道已关闭，请进入批发专区选购',
  wsx_closed_mayor_title: '批发暂未开放',
  wsx_closed_mayor_sub: '本店暂未开放批发下单，欢迎光临零售店',
  wsx_tier_ge: '≥{n}件',
  wsx_mix_hint: '✨ 可混批：不同款式凑满{n}件即可按批发价下单',
  wsx_mix_need: '混批还差 {n} 件才能下单',
  wsx_mix_ok: '已达混批起订量',
  wsx_mix_progress: '混批进度',
  wsx_vip_badge: 'VIP价 -{n}%',
  wsx_moq_multi: '{n}件起订，按{n}倍数',
  wsx_moq_min: '{n}件起订',
  wsx_settings_title: '网店批发设置 (B2B)',
  wsx_tab_orders: '批发订单',
  wsx_tab_salesmen: '业务员提成',
  wsx_tab_settings: '批发设置',
  wsx_terms_title: '赊账账期 & 折扣 (网店批发下单用)',
  wsx_terms_hint: '客户下单选账期，折扣%为正=减价，负=加价 (如: 15天 -3%, 90天 0%)',
  wsx_terms_days: '天',
  wsx_terms_pct: '% 折扣',
  wsx_terms_add: '加账期',
  wsx_retail_toggle: '零售网店',
  wsx_ws_toggle: '批发网店 (/mayor)',
  wsx_copy_link: '复制链接',
  wsx_link_copied: '链接已复制',
  wsx_default_moq: '默认起订量(件)',
  wsx_retail_ws_qty: '零售店起批数量(全局)',
  wsx_retail_ws_qty_hint: '0=关闭; 商品自己填的"起批数量"优先生效',
  sx_boss_confirm: '✔ 补确认',
  sx_boss_confirm_ask: '确认这笔钱已核实到账? 将挪到"已人工核实"绿色区',
  wsx_mix_enable: '允许混批（不同款式凑总量）',
  wsx_mix_min: '混批总起订量(件)',
  wsx_vip_pct: 'VIP客户额外折扣 %',
  wsx_ai_desc: '顾客在 WhatsApp 问"有没有 Harina PAN 多少钱"，AI 自动查库存报价、记录订单意向并回复（西班牙语）。每次回复消耗 1 AI 学分。',
  wsx_ai_setup: '需要先扫码连接本店 WhatsApp（上方绿色卡片）。顾客确认下单后，AI 会自动生成挂单，收银台按 F10 取单即可收款。',
  wsx_ai_store: '挂单门店（AI 接的单存到哪个店）',
  wsx_ai_store_auto: '自动（第一个门店）',
  wsx_ai_extra: '店铺补充信息（营业时间/配送/收款方式，AI 会参考回答）',
  wsx_ai_kb: 'AI 知识库（常见问答 / 店规 / 退换货政策 / 不要对客人说的话 — AI 会严格照着回答）',
  wsx_ai_kb_ph: '例：\n问：有送货吗？答：Caracas 市内满 $20 免费送，其他地区按距离收费。\n问：能赊账吗？答：只对老客户，需要老板批准。\n不要承诺到货日期；不要给折扣；不要提竞争对手。',
  wsx_ai_lead_phone: '合作/供应商线索通知号码',
  wsx_ai_lead_hint: '对方提到 合作、对接、API、供应商 等词时，AI 停止推销并把消息转发到这个号码（留空则用网店订单通知号）',
  wsx_ai_save: '保存信息',
  wsx_ai_chats_view: '查看 AI 对话记录',
  wsx_ai_chats_hide: '收起对话',
  wsx_ai_chats_none: '暂无 AI 对话记录',
  wsx_ai_msgs: '条',
  wsx_ai_on: '已开启',
  wsx_ai_enable: '开启',
  wsx_cr_l1: '每天早上 9:30 自动扫描所有赊账记录，给「已逾期」或「3 天内到期」的客户发 WhatsApp 提醒。',
  wsx_cr_int_pre: '同一客户 ',
  wsx_cr_int_post: ' 天内只发 1 次，不会重复打扰。也可在「/admin/credits」页面手动一键催款。',
  dlv_enforce_max: '超出范围禁止下单',
  dlv_enforce_max_hint: '开启后，超过最大配送距离的顾客无法下单（需顾客分享位置）',
  dlv_map_hint: '🗺️ 配送范围地图 — 点击地图可直接设置门店位置',
  dlv_map_legend_max: '最大配送范围',
  dlv_map_legend_free: '免运费范围',
  sh_week_hint: '按天设置（如周日只开半天或休息），不设置的天用上面的默认时间',
  sh_mode_default: '默认时间',
  sh_mode_custom: '自定义',
  sh_mode_closed: '休息',
  sh_day_mon: '周一', sh_day_tue: '周二', sh_day_wed: '周三', sh_day_thu: '周四', sh_day_fri: '周五', sh_day_sat: '周六', sh_day_sun: '周日',
  pl_mode_p1: 'P1 (零售)', pl_mode_p2: 'P2 (批发)', pl_mode_p3: 'P3 (大批发)',
  pl_mode_p1p2: 'P1 + P2', pl_mode_cashea: 'P1 + Cashea 价', pl_mode_box: 'P1 + 整箱价', pl_mode_p1p2box: 'P1 + P2 + 整箱', pl_mode_p1p3: 'P1 + P3', pl_mode_all: '全部 3 个价位',
  pl_instock: '有货', pl_all: '全部', pl_clear: '清空',
  wsx_save_ok: '批发设置已保存',
  wsx_tiers_btn: '阶梯价',
  wsx_tiers_title: '商品阶梯批发价',
  wsx_tiers_sub: '例：≥12件 $5.00，≥48件 $4.50，≥144件 $4.00。留空则用批发价P2。第一档数量即该商品起订量。',
  wsx_tier_qty: '数量 ≥',
  wsx_tier_price: '单价 $',
  wsx_tiers_saved: '阶梯价已保存',
  wsx_tier_manage: '设置商品阶梯价',
  wsx_search_product: '搜索商品设置阶梯价...',
  wsx_catalog_btn: 'PDF报价目录',
  wsx_catalog_with: '含批发价（发老客户）',
  wsx_catalog_without: '不含价格（发群引流）',
  wsx_catalog_note: '注册批发账户即可查看价格下单',
  wsx_vip_toggle_on: '已升级为VIP批发客户',
  wsx_vip_toggle_off: '已取消VIP',
  wsx_guide_title: '📖 批发网店怎么用？点开看操作教程',
  wsx_guide_1: '1️⃣ 开启上方「批发网店」开关，把批发链接(/mayor)发到WhatsApp批发群。零售店和批发店共用同一套商品和库存，两个入口可分别开关。',
  wsx_guide_2: '2️⃣ 默认「免审核」：客户注册（留下姓名+手机号）就能看价下单，方便赊账熟客直接进货。想控制谁能看价，可关掉免审核，改为您在【客户管理】手动批准。',
  wsx_guide_3: '3️⃣ 给重点商品设阶梯价：买越多单价越低（例：12件$5 / 48件$4.5 / 144件$4），刺激客户凑大单。没设阶梯的商品自动用批发价P2。',
  wsx_guide_4: '4️⃣ 起订量：有阶梯价的商品按第一档数量起订；其他商品按装箱数或默认起订量，按倍数下单（12、24、36…）。',
  wsx_guide_5: '5️⃣ 混批照顾小客户：开启后客户可以不同款式混着拿，凑够总件数（如36件）就能下单，不再限制单款起订量。',
  wsx_guide_6: '6️⃣ VIP客户：在【客户管理】给老客户/大客户打开VIP，他们下单自动在批发价上再打折（折扣%在上面设置）。',
  wsx_guide_7: '7️⃣ 一键生成PDF报价目录发WhatsApp群：「无价版」发陌生群引流拉注册，「含价版」发给已批准的老客户。',
  wsx_guide_8: '8️⃣ 客户下单后进【网店订单】，可打A4批发发票；已开赊账额度的客户还能赊账下单，到期自动WhatsApp催收。',
  wsx_hot_title: '本周批发爆款',
  wsx_hot_sold: '7天走货 {n} 件',
  wsx_auto_approve: '免审核（注册即可看价下单）',
  wsx_pedido_nopay: '批发下单免付款（Pedido）',
  wsx_pedido_nopay_hint: '客户提交 Pedido 不用付款、不占库存；打印 A5 拣货，确认后才扣库存，明细自动发客户 WhatsApp',
  wsx_salesman: '业务员 WhatsApp（新批发单自动直推）',
  wsx_wa_target: 'WhatsApp 号码或群ID',
  wsx_send_with: '直发含价目录',
  wsx_send_without: '直发无价目录',
  wsx_sent_ok: '已发送到 WhatsApp',
  wsx_send_fail: '发送失败，请检查 WhatsApp 是否已连接',
  wsx_size_mix: '混码配比（例: S*4 M*4 L*4）',
  wsx_statement: '对账单',
  wsx_only_left: '仅剩 {n} 件',
  wsx_load_groups: '读取WhatsApp群列表',
  wsx_pick_group: '选择群',
  wsx_groups_fail: '读取失败，请确认 WhatsApp 已扫码连接',
  wsx_salesman_multi: '业务员 WhatsApp（可填多个，逗号分隔）',
  wsx_sm_title: '业务员业绩 & 提成',
  wsx_settle_pdf: '结算单PDF',
  wsx_settle_send: '发结算单(WhatsApp)',
  wsx_settle_sent: '结算单已发送 ✓',
  wsx_sm_enable: '启用业务员提成',
  wsx_sm_add: '添加业务员',
  wsx_sm_name: '姓名',
  wsx_sm_pct: '提成%',
  wsx_sm_link: '专属链接',
  wsx_sm_customers: '客户数',
  wsx_sm_orders: '订单',
  wsx_sm_sales: '销售额$',
  wsx_sm_collected: '实收款$',
  wsx_sm_comm_sales: '提成(按销售)',
  wsx_sm_comm_coll: '提成(按实收)',
  wsx_sm_none: '未分配',
  wsx_sm_unassigned: '未归属订单',
  wsx_sm_saved: '已保存',
  wsx_sm_hint: '💡 把专属链接发给业务员去拉客：客户点他的链接注册就自动归他名下；也可以在【客户管理】手动改归属。该客户下的批发单自动只推给他跟单。',
  wsx_wechat_copy: '发微信/其他App：',
  wsx_copy_with: '复制含价文案',
  wsx_copy_without: '复制无价文案',
  wsx_copied: '文案已复制，去微信群粘贴发送即可',
  wsx_color_theme: '网店颜色主题',
  wsx_color_hint: '选中后点保存，零售店和批发店整体配色立即更换',
  x_nosalary_prompt: '⚠️ 该员工未设置工资，无法自动计算扣款。\n请输入本次应扣金额（美元 $），点取消则不记账：',
  x_nosalary_skipped: '未记欠账。提示：在「员工管理」中设置该员工工资后，旷工/半天可自动按日薪计算扣款',
  x_free_label: '免费',
  x_credits_unit: '学分',
  ci_btn: '货柜装箱单',
  ci_title: '货柜装箱单导入（中国进货）',
  ci_upload_hint: '上传供应商发来的装箱单（Excel .xlsx 或 .csv）。标准模板可直接导入；乱格式会由 AI 自动识别每一列。',
  ci_choose_file: '选择装箱单文件',
  ci_analyzing: '正在分析...',
  ci_download_template: '下载标准模板',
  ci_ai_note: 'AI 兜底：供应商发什么格式都行，系统自动认列（货号/品名/箱数/每箱数量/进价RMB等），导入前可手动修正。',
  ci_ai_used: '✨ AI 已自动识别列对应，请检查后确认',
  ci_ai_mapped: 'AI 已识别',
  ci_analyze_fail: '文件分析失败',
  ci_total_rows: '数据行数',
  ci_mapping_hint: '每列上方可修改对应字段',
  ci_f_ignore: '— 忽略 —',
  ci_f_code: '货号',
  ci_f_name: '品名',
  ci_f_barcode: '条码',
  ci_f_cartons: '箱数',
  ci_f_per_box: '每箱数量',
  ci_f_qty: '总数量',
  ci_f_cost_rmb: '进价RMB',
  ci_f_cost_usd: '进价USD',
  ci_f_retail_usd: '零售价USD',
  ci_f_wholesale_usd: '批发价USD',
  ci_f_t1_qty: '梯价1起订量',
  ci_f_t1_price: '梯价1价$',
  ci_f_t2_qty: '梯价2起订量',
  ci_f_t2_price: '梯价2价$',
  ci_f_t3_qty: '梯价3起订量',
  ci_f_t3_price: '梯价3价$',
  ci_f_category: '分类',
  ci_f_spec: '规格/颜色',
  ci_rmb_rate: 'RMB→USD 汇率',
  ci_live_rate: '实时汇率已自动填入',
  rmb_card_title: '人民币汇率（自动实时）',
  rmb_auto_note: '自动获取 USD→CNY 实时汇率，并按 BCV/Binance 折算 Bs（每6小时更新）',
  rmb_refresh: '刷新',
  rmb_unavailable: '暂时无法获取人民币汇率',
  rmb_example: '换算示例',
  ci_shipping: '总运费 USD（分摊到成本）',
  ci_warehouse: '入库仓库',
  ci_wh_default: '默认仓库',
  ci_dup_mode: '已有货号处理',
  ci_mode_add: '加库存+更新价格',
  ci_mode_skip: '跳过不动',
  ci_commit: '确认导入',
  ci_back: '重新上传',
  ci_commit_fail: '导入失败',
  ci_result_created: '新建商品',
  ci_result_updated: '已有商品加库存',
  ci_result_skipped: '跳过',
  ci_result_failed: '失败',
  ci_result_units: '入库总件数',
  ci_ship_per_unit: '每件分摊运费',
  ci_po_created: '已自动生成入库采购单（采购管理可查这柜货成本）',
  bi_offer: '给这批商品配图，网店马上能卖',
  bi_create_link: '生成手机拍照链接',
  bi_link_copied: '链接已复制，手机打开即可拍照',
  bi_copy: '复制链接',
  bi_wa_text: '📸 新货配图链接（手机打开逐件拍照，AI自动白底）:',
  bi_hint: '老板手机打开链接，对着货逐件拍照，AI 自动白底；选原图免费，用 AI 版按张扣学分。链接7天有效。',
  bi_title: '新货批量配图',
  bi_done_count: '已配图',
  bi_take_photo: '拍照 / 选图',
  bi_processing: 'AI 处理中...',
  bi_use_this: '用这张',
  bi_ai_failed: 'AI 处理失败，用原图即可',
  bi_retake: '重拍',
  bi_cancel: '返回列表',
  bi_style_whitebg: '白底图',
  bi_style_poster: '电商海报（AI配卖点文案）',
  ci_done: '完成',
  pt_tier_title: '批发梯价（≥数量 → 单价$，随商品一起保存）',
  pt_tier_minqty: '数量',
  pt_tier_price: '价格',
  pt_tier_hint: '例：≥12 $2.80 / ≥60 $2.50 / ≥120 $2.20。留空则不设梯价。',
  pt_tier_save_fail: '梯价保存失败，请到批发页重试',
  wsx_cp_title: '智能信用折扣（早还款有优惠）',
  wsx_cp_slogan: '宣传语（显示在客户对账单上）',
  wsx_cp_slogan_ph: '例：30天内还款立减3%！',
  wsx_cp_days: '默认账期（天）',
  wsx_cp_tier_days: '≤天数',
  wsx_cp_tier_pct: '折扣%',
  pu_loading: '加载中...',
  pu_done_title: '完成！',
  pu_saved_for: '照片已保存到商品',
  pu_close_tab: '可以关闭此页面了',
  pu_title: '上传商品照片',
  pu_code: '货号',
  wsx_pronto_hint_1: '已赊',
  wsx_days: '天',
  wsx_pronto_receive: '现在还只需付',
  wsx_pronto_save: '省',
  wsx_pronto_btn: '应用早付折扣',
  wsx_banner: '店铺横幅（网店顶部大图）',
  wsx_banner_upload: '上传横幅图片',
  aisd_btn: 'AI 设计',
  pos_ai_logo_btn: 'AI 生成店铺Logo',
  pos_ai_logo_regen: 'AI 重新生成Logo',
  aisd_title: 'AI 网店设计师',
  aisd_kind_banner: '店铺横幅',
  aisd_kind_logo: '店铺 Logo',
  aisd_style: '风格',
  aisd_color_synced: '网店主题色已自动同步为横幅颜色',
  aisd_ref_hint: '可选',
  aisd_ref_upload: '上传一张喜欢的横幅，AI 照这个风格做',
  aisd_ref_active: '将模仿参考图的风格生成（自动换成你的店名和联系方式）',
  aisd_style_supermercado: '🛒 拉美超市促销',
  aisd_style_modern: '现代',
  aisd_style_anime: '🎌 动漫',
  aisd_style_tech: '⚡ 科技感',
  aisd_style_3d: '🧊 立体3D',
  aisd_style_warm: '温馨',
  aisd_style_luxury: '奢华',
  aisd_style_promo: '促销',
  aisd_style_minimal: '极简',
  aisd_style_festive: '节日',
  aisd_desc: '补充描述（可选）',
  aisd_desc_ph: '例：卖生鲜果蔬，想要红色喜庆促销风',
  aisd_generate: '生成',
  aisd_generating: 'AI 生成中…',
  aisd_regen: '重新生成',
  aisd_apply: '应用到网店',
  aisd_applied: '已应用到网店！',
  aisd_cost: '费用',
  aisd_credits: '学分',
  aisd_balance: '学分余额',
  aisd_no_credits: 'AI 学分不足，请到 ✨AI学分 页充值',
  aisd_failed: 'AI 生成失败，请重试（已退还学分）',
  aisd_wait_hint: '生成约需 30-90 秒，请勿关闭窗口',
  shopslug_label: '网店专属网址（自定义店名链接）',
  shopslug_hint: '3-30位小写字母、数字或连字符。设置后客户可用店名直接访问，旧链接仍有效。',
  shopslug_save: '保存网址',
  shopslug_saved: '网址已保存！',
  shopslug_invalid: '网址名无效或已被占用',
  poster_btn: 'AI海报',
  poster_title: 'AI 促销海报',
  poster_select_hint: '勾选1-6个商品，AI排成一张促销海报',
  poster_max6: '最多选6个商品',
  poster_promo_label: '促销标语（可选）',
  poster_promo_ph: '例：周末大特价！仅限3天',
  poster_sent: '海报已发到 WhatsApp:',
  poster_phone_ph: '手机号（留空=发给老板号码）',
  poster_wa_hint: '发到你的WhatsApp后，转发到客户群即可宣传',
  poster_download: '下载海报图片',
  hb_toggle: '节日横幅自动生成',
  hb_hint: '圣诞、黑五等节日前5天，AI自动生成节日横幅（16学分/次）并发WhatsApp给你，一键换上',
  hb_enabled: '已开启节日横幅自动生成',
  hb_disabled: '已关闭节日横幅自动生成',
  gb_title: '🔥 拼单团购',
  payqr_upload: '📷 上传银行收款QR',
  pk_menu: '📦 拣货出库',
  vd_menu: '🧳 业务员',
  vendedor: '业务员',
  pd_gallery_label: '更多图片（网店详情图）',
  pd_gallery_hint: '顾客在网店点击商品即可左右滑动查看这些图片',
  pd_desc_label: '商品简介（网店详情显示）',
  tid_contact_admin: '商户ID由平台管理，如需修改请联系 Sellox 客服',
  payqr_change: '📷 更换QR',
  aiverify_label: '🤖 AI 自动识别付款截图',
  aiverify_hint: '关闭后凭证走人工核对(不消耗AI积分): 客户填参考号+传截图, 老板对账确认',
  sdc_btn: '🎉 生成宣传贺卡',
  sdc_download: '📥 下载图片',
  sdc_share: '分享到 WhatsApp',
  sdc_hint: '先下载图片，然后发布到 WhatsApp 动态或直接发给客户',
  gb_intro: '拼多多玩法：给商品设拼单价+成团人数，顾客开团后转发WhatsApp拉人，人满自动成团生成订单，24小时不满自动取消。',
  gb_enabled: '已开启',
  gb_disabled: '未开启（点击开启）',
  gb_on: '拼单团购已开启！',
  gb_off: '拼单团购已关闭',
  gb_add_product: '添加拼单商品',
  gb_search_ph: '搜索商品名/编号',
  gb_price: '拼单价',
  gb_size: '成团人数',
  gb_saved: '拼单商品已保存！',
  gb_configured: '已设置拼单的商品',
  gb_none: '还没有拼单商品，上面搜索添加',
  gb_groups: '拼团记录',
  gb_no_groups: '还没有顾客开团',
  gb_st_completed: '已成团',
  gb_st_open: '拼团中',
  gb_st_expired: '已过期',

  wsx_banner_removed: '横幅已移除',
  sx_fiscal_copy_ok: '已打印副本（该单已开过税票，副本为无税务效力凭证）',
  sx_last_cost: '上次进价',
  sx_ocr_menu: '拍照进货 (AI)',
  sx_cost_up: '比上次进价贵',
  sx_cheaper_sup: '有更便宜的供应商',
  sx_shrink_menu: '损耗报告',
  sx_shrink_title: '损耗 / 失窃报告',
  sx_shrink_sub: '盘点差异 + 报损汇总 — 把看不见的损失变成看得见的数字',
  sx_shrink_stk_loss: '盘亏（少了）',
  sx_shrink_declared: '报损登记',
  sx_shrink_gain: '盘盈（多了）',
  sx_shrink_total: '总损失',
  sx_shrink_top: '损耗排行（按金额）',
  sx_shrink_times: '次数',
  sx_shrink_qty: '缺少数量',
  sx_shrink_value: '损失 $',
  sx_shrink_no_data: '这个时间段没有损耗记录 🎉',
  sx_shrink_wh: '仓库',
  sx_shrink_events: '明细记录',
  sx_shrink_source_stk: '盘点',
  sx_shrink_source_loss: '报损',
  sx_resq_title: '⚠️ 编码重排 — 高危操作',
  sx_resq_body: '此操作会把全部商品编码按名称顺序改为 01, 02, 03…，原有编码将被覆盖！（系统会自动保留一份编码备份，可联系平台恢复）',
  sx_resq_type_hint: '如确定要继续，请在下方输入',
  sx_resq_go: '确认重排',
  sx_exit_system: '完全退出系统',
  sx_ocr2_cur_q: '这张发票的价格是什么货币？',
  sx_ocr2_usd: '美金 USD',
  sx_ocr2_bs: '玻利瓦尔 Bs',
  sx_ocr2_rate: '汇率 (Bs÷汇率=$)',
  sx_ocr2_rate_hint: 'Bs 价格会 ÷ 汇率换算成美金入库（优先用你填的汇率，其次用单据上印的汇率）',
  sx_ocr2_usd_hint: '如单据同时有 $ 和 Bs 两列，AI 只读 $ 列；整箱价(bulto/caja)会自动 ÷ 箱数算出单价',
  sx_ocr2_rate_req: '请先填写汇率',
  sx_ocr2_src_user: '手动汇率',
  sx_ocr2_src_invoice: '单据上的汇率',
  sx_ocr2_src_system: '系统汇率',
  sx_ocr2_box_conv: '整箱换算',
  sx_ocr2_units: '单位',
  sx_ocr2_pick: '🔍 搜索选择商品…',
  sx_ocr2_no_pick: '选了"匹配"但还没选商品',
  pm_wait_bank: '⏳ 等待银行通知(可能需1-2分钟)…',
  overpay_label: '多收',
  overpay_return_by: '找回方式',
  overpay_cash: '💵 现金找零',
  overpay_transfer: '🏦 转账退回',
  overpay_cash_hint: '将从收银员现金抽屉扣除',
  overpay_transfer_hint: '不影响现金抽屉',
  aisd_ref_banner: '🖼️ 参考横幅',
  aisd_style_gold3d: '金色立体',
  aisd_style_mascota: '3D吉祥物',
  aisd_style_emblema: '徽章',
  aisd_style_neon: '霓虹灯',
  pay_where_transfer: '📍 显示位置：网店结账 → 顾客选"转账"时看到的收款账号（旧版单账号；建议使用下方"收款账户"列表，可添加多个）',
  pay_where_pm: '📍 显示位置：网店结账 → 顾客选"Pago Móvil"时看到的收款信息（旧版单账号；建议使用下方"收款账户"列表）',
  pay_where_wa: '📍 显示位置：网店结账 → 顾客可选"WhatsApp下单"，订单发送到此号码',
  pay_where_cashea: '📍 显示位置：网店结账 → 顾客可选 Cashea 分期付款',
  pm_edit_auth_action: '修改支付方式需要管理员/店长授权（扫码或输密码）',
  dlv_charge_customer: '运费由顾客支付',
  dlv_charge_customer_hint: '开启后，网店结账时自动加收运费（起步价 + 每公里×距离）',
  dlv_free_over: '满额免运费 (US$)',
  dlv_free_over_hint: '订单商品金额达到此数免收运费；填 0 = 不启用',
  dlv_free_km: '几公里内免运费 (km)',
  dlv_free_km_hint: '顾客距离店铺在此范围内免收运费；填 0 = 不启用（需顾客定位）',
  dlv_banner_toggle: '网店显示免运费横幅',
  dlv_banner_hint: '在网店商品列表顶部显示"满 $X 免运费"横幅，刺激凑单',
  oe_edit_auth_action: '改单需要管理员/店长授权（扫码或输密码）',
  oe_edit_note: '改单会自动调整库存并留审计记录',
  x_4ea2dc0c: '在 Safari 点「分享」→「添加到主屏幕」即可安装',
  x_b3f1742d: '浏览器菜单 ⋮ →「添加到主屏幕 / 安装应用」',
  x_c6b0ecc1: 'PROFORMA / 参考单',
  x_b43540a2: 'Documento de referencia — no fiscal. Sujeto a confirmación de inventario. / 参考单 — 以仓库确认为准。',
  x_d2a5f47d: '营业时间外，暂不接单。营业时间',
  x_79da6318: '下单失败',
  x_a7387278: '我的订单',
  x_0134ef91: '安装到手机桌面',
  x_e655a410: '安装',
  x_9f68a807: '积分',
  x_c6a7617b: '一打起批发价',
  x_db3c3f79: '新客首单免运费!',
  x_92254b8d: '拼单特价',
  x_1cb0067b: '✨ 新品',
  x_262a5f78: '💥 特价',
  x_9789ea3d: '售罄',
  x_7c114133: '批发',
  x_fe0e8bf7: '注册',
  x_c5f36f1e: '注册类型',
  x_a634b186: '批发商',
  x_33809226: '零售客户',
  x_1b21e28e: '店面名称',
  x_abbe4bb4: '出生日期',
  x_fccc2b4a: '1月',
  x_c1d13f1d: '2月',
  x_c4767bc3: '3月',
  x_3eaf4b30: '4月',
  x_0545f138: '5月',
  x_f2422a6e: '6月',
  x_464bab7f: '7月',
  x_81017142: '8月',
  x_4b592d5e: '9月',
  x_f544c399: '10月',
  x_57c44755: '11月',
  x_c0615eb3: '12月',
  x_e42b99d5: '月',
  x_465260fe: '年',
  x_a65be661: '电话或身份证号',
  x_ab735ef3: '门店登记过的客户可直接用电话或身份证号登录',
  x_5f57ab2b: '请选择完整的出生日期',
  x_18d9ac63: '欢迎回来！',
  x_c94c6645: '注册成功！',
  x_c91539c5: '您已是本店会员！首次网店登录请设置密码，积分和记录都会保留',
  x_bc490ac9: '没有账号？注册',
  x_89438cb2: '我的积分',
  x_70c5388d: '待还赊账',
  x_99b7dc82: '账期',
  x_f7013966: '-- 选择银行 --',
  x_b00a4f4e: '免运费',
  x_abd7f31c: '本店限制配送范围，请在上方分享您的位置',
  x_df4e7845: '拼团购',
  x_e77dadaf: '拼团人数',
  x_96b165fe: '该拼团已结束——可以开个新团',
  x_a49dc062: '请选择支付方式',
  x_0d6fd032: '请输入支付参考号（至少4位）',
  x_0025409e: '🎉 拼团成功！订单已创建',
  x_934a013a: '出错了，请重试',
  x_918d2e43: '进行中的拼团——快加入！',
  x_cece7904: '顾客',
  x_4d99b1b3: '加入 →',
  x_7be5df87: '🚀 我要开团',
  x_02c280bb: '你的姓名',
  x_a0b92ea7: '你的电话 (WhatsApp)',
  x_630a2d4f: '💳 立即支付锁定名额',
  x_e3648a5b: '📲 用银行App扫码',
  x_bc7dbf60: '支付参考号 *',
  x_78fbb3b8: '店铺将核实你的付款。24小时内未成团将退款。',
  x_fbf44f79: '💬 成团后通过 WhatsApp 与店铺协商付款。',
  x_661f0360: '✅ 加入拼团',
  x_a392ec03: '🚀 创建拼团',
  x_9c401b86: '分享链接——成团后订单自动确认。24小时内有效。',
  x_1d7b443a: '分享到 WhatsApp',
  x_4b7d6310: '链接已复制',
  x_02b52fdf: '拼团成功！',
  x_375ec885: '好的',
  x_0b4f1582: 'SENIAT - 税务控制中心',
  x_a2a6e3a5: '税务管理 · Z/X报表 · 导出 · 审计',
  x_466ef11d: 'X报表',
  x_aecc6c50: 'Z报表(关账)',
  x_52f43ce8: '计数器',
  x_685de23a: 'SENIAT导出',
  x_a722bf43: '审计日志',
  x_18f25f32: '连号检查',
  x_917b67ce: '生成X报表',
  x_3fca2d1d: '生成Z报表 (关账)',
  x_4d020ba3: '生成中...',
  x_2a9ce745: 'Z报表 = 当天税务关账，只在打烊时生成一次。',
  x_6ca3821a: '⚠️ 当前在浏览器：财政打印机只能从桌面版打印',
  x_4823e2b3: '📅 按日期重打Z副本 — 财政内存报表',
  x_1b1964c7: '在财政打印机上重打指定日期已保存的Z单法定副本。不产生新Z、不修改任何数据 — SENIAT和会计均认可。',
  x_d3955f6a: '在财政机上打印',
  x_0ef2525d: '⚠️ 只能从桌面版操作（需连接财政打印机）',
  x_a8be906b: '还没有生成过Z报表',
  x_ade95bda: '今日销售额',
  x_f4f5a946: '笔交易',
  x_ee1689c9: '已收IVA(增值税)',
  x_52f7f49a: '免税销售',
  x_f2a378e9: '作废单',
  x_983f27e7: '净销售',
  x_d3c85a4d: '发票号',
  x_d3a4a490: '控制号',
  x_6cced836: 'IVA明细',
  x_b294fbbf: '税基',
  x_2bb46698: '还没有计数器。首笔开票销售会自动创建。',
  x_f74759c0: '控制号计数器',
  x_353cab9e: '发票号计数器',
  x_4c9bb426: '前缀',
  x_ca8f0b14: '当前号',
  x_f2c71b78: '导出税务数据 (SENIAT)',
  x_b44c0f33: '开始日期',
  x_1d468be9: '结束日期',
  x_55405ea6: '导出',
  x_aa03f534: 'CSV: 分号分隔，Excel/SENIAT通用。字段: 日期、发票号、控制号、RIF、税基、IVA%、IVA、免税、总额、支付方式、币种',
  x_7a5bbc5b: 'TXT: | 分隔纯文本，用于对接SENIAT系统',
  x_725b5a3e: 'JSON: 结构化格式，用于API对接',
  x_1fd02a90: '用户',
  x_79c05840: '暂无审计记录',
  x_5839aebb: '审计数据按SENIAT规定 (SNAT/2024/000121) 保存10年。',
  x_43c011c1: '检查连号',
  x_0410cb00: '检查中...',
  x_bc5b83bc: '不选日期 = 检查全部。内部自查，不依赖SENIAT。',
  x_7974ad56: '✅ 连号完整',
  x_8dc2b6cc: '⚠️ 发现问题',
  x_19616fb8: '张发票 · 范围',
  x_9a136985: '跳号 (缺失号码)',
  x_a656f3be: '重复号',
  x_c258e133: '时间乱序',
  x_5da53c3a: '离线补录 / 作废',
  x_af5eba6e: '跳号明细 (缺失的控制号)',
  x_d8066277: '重复的控制号',
  x_351f1da9: '非时间顺序开票',
  x_8ce24893: '生成Z报表？这会关闭今天的税务日，一天只做一次。确定吗？',
  x_87d27264: '⚠️ Solo disponible en la app de escritorio / 只能在桌面版操作',
  x_66823aa3: '已派给',
  x_89a92538: '已发布，骑手可抢单',
  x_d02627fe: '✅ 来单通知设置已保存',
  x_6af47376: '✅ 订单已修改',
  x_d3cb9a21: '✅ 开单完成',
  x_cdbe0c92: '确定取消该订单? 库存将释放, 配送单同步取消',
  x_32ff009c: '✅ 订单已取消',
  x_a769cdc2: '确定彻底删除此订单？将自动释放预留库存，不可恢复',
  x_2716e6a7: '确定彻底删除此订单记录？不可恢复',
  x_cbb7bf56: '🗑 已彻底删除',
  x_00e41368: '请输入退货数量',
  x_96c48fd4: '✅ 换货完成, 需向顾客补收',
  x_7ef40e73: '✅ 退货成功, 库存已更新',
  x_44c198c1: '退款',
  x_f36ecce3: '来单通知设置',
  x_359ff4db: '来单 WhatsApp 通知号码 (留空=不发送)',
  x_b7656e18: '铃声',
  x_0d9c291a: '清脆',
  x_1fdac4c2: '响亮',
  x_95b9408f: '语音播报金额',
  x_f4a35245: '试听',
  x_f62dea70: '哪些账号响铃提醒 (不勾选 = 全部账号都响)',
  x_2026e292: '电脑端自动响铃 + 语音播报新订单金额（跟随系统语言）',
  x_2dad819e: '已全退',
  x_f67d89db: '部分退',
  x_bc3583b5: '开单',
  x_4efd6a13: '发给骑手',
  x_cbfc5ba6: '缺货可改数量，填0删除该商品',
  x_855fb7e2: '确认总额',
  x_d613b1b4: '确认后自动: 扣库存 + 挂账到客户(按账期) + 提成记业务员',
  x_b59c07ff: '✅ 确认开单',
  x_897dbdee: '修改订单',
  x_7650487a: '地址',
  x_d2dd7e1c: '缺货可改数量, 填0删除该商品',
  x_d99e3dbb: '新总额 (不含运费)',
  x_926c613a: '⚠️ 该订单已付款, 金额变动需自行与客户结清差额',
  x_84693468: '💾 保存修改',
  x_b163cb6a: '订单退货',
  x_a9275c2e: '默认全退, 可修改数量做部分退货 (0 = 不退该商品)',
  x_2f656a74: '已退',
  x_4178e0b6: '退款方式',
  x_976f94a1: '退货原因 (可选)',
  x_fd3108f0: '如: 商品损坏',
  x_cf55227f: '换货 (可选) — 换成其他商品, 差价自动计算',
  x_33bda28d: '搜索要换的商品...',
  x_9854a54a: '退货金额',
  x_51811a84: '换货金额',
  x_2718ce26: '退给顾客',
  x_d1903e50: '顾客需补交',
  x_1830fefb: '确认后: 退货入库+换货出库+生成退款记录(计入报表), 并自动WhatsApp通知顾客退款凭证',
  x_54945fc4: '✅ 确认退换货',
  x_6be8ae78: '✅ 确认退货',
  x_1817ed2a: '派单给骑手',
  x_dc2c3193: '没有已认证的骑手。骑手需在 sellox.shop/rider 注册并由您审核。',
  x_727df9ee: '发布抢单(不指定)',
  x_c29ce6fd: '现金 $',
  x_58ef5787: '已清空暂存',
  x_129fe574: 'Nº factura proveedor / 供应商单号:',
  x_2959bd81: '✅ 已开启每日自动补货草稿 (7:00)',
  x_e6a85d28: '已关闭自动草稿',
  x_a2a843ad: '没有需要补货的热卖商品',
  x_513d596e: '✅ 草稿已确认为正式采购单',
  x_0c456ca5: '删除这张草稿?',
  x_9b19d9c6: '⚠️ 请先选择仓库',
  x_20b73ca7: '💾 采购单已离线保存, 网络恢复后自动上传',
  x_1922f043: '💾 收货已离线保存, 网络恢复后自动上传',
  x_31d1f953: '📋 已复制商品信息，只需改名称和条码',
  x_673942b6: '条码已存在',
  x_47e03fd1: '编码已被占用',
  x_b0007365: '未指定供应商',
  x_e24ce335: '自动草稿:开',
  x_9cfd9afd: '自动草稿:关',
  x_31416882: '立即生成草稿',
  x_719fb446: '搜索供应商或卖家...',
  x_4091474b: '📝 草稿',
  x_d7291e52: '单据币种',
  x_2ced248f: '复制为新商品(只改名和条码)',
  x_e21626f3: '🗑 清空暂存',
  x_64457c62: '点击更换部门/分类',
  x_00ca7c29: '无分类·点击设置',
  x_df6d0757: '个/箱',
  x_64d9ef93: '利率',
  x_9e4dbf03: '金额 Bs',
  x_77449ea5: '汇率 (Bs/$)',
  x_5e496273: '输入Bs自动按当天汇率折算美元金额（汇率可手改）',
  x_be85dc34: '参考号 / 流水号',
  x_0edbdf53: '转账参考号、Zelle确认号…',
  x_8f8b954f: '例：给业务员Juan现金、部分定金…',
  x_f8580966: '付款凭证（转账截图/收据）',
  x_be6f0f22: '拍照 / 上传凭证',
  x_aa24f2e1: '图片太大 (最大8MB)',
  x_94171ce2: '凭证',
  x_3e440694: '该编码已被占用',
  x_be607248: '该条码已存在',
  x_515c0b7e: '整单改仓库？已入库的库存会自动从原仓库移到新仓库',
  x_15816bc7: '修改这张单的仓库？',
  x_0e344978: '银行账务',
  x_5bb78d8a: '账户互转',
  x_228d2bab: '新建账户',
  x_3b186bad: '还没有账户。创建银行账户/现金柜，收款会自动入账。',
  x_6095e59c: '流水',
  x_348e534e: '单号/备注',
  x_09e1d043: '暂无流水',
  x_6f484666: '编辑账户',
  x_f3f18020: '账户名称 (如 BNC 主账户 / 美金现金柜)',
  x_f430b947: '银行 (可空)',
  x_4d72cab9: '账号后4位 (可空)',
  x_de35ac7b: '期初余额',
  x_1f0fca13: '绑定支付方式（收款自动入这个账户）',
  x_68e9a989: '备注 (可空)',
  x_3e25b5d4: '从账户',
  x_e83fca1c: '到账户',
  x_33ed7cfa: '转出金额',
  x_30f229d9: '到账金额',
  x_26050b04: '确认转账',
  x_9e268a5d: '请填名称',
  x_db8ac4f2: '金额无效',
  x_4ab08f52: '已记账',
  x_51e7ba4a: '转账已记账',
  x_3524c978: '导出对账单',
  x_be123473: '导出对账单 (Excel/PDF)',
  x_81909158: '月份',
  x_37cb3781: '汇总报表',
  x_32f2f705: '资金汇总报表',
  x_026d5880: '期初',
  x_361ffa7f: '流入',
  x_37cc0a9a: '流出',
  x_b39409ce: '净额',
  x_d6080990: '期末',
  x_79ceb63f: '门店现金抽屉',
  x_936cf2c9: '审批设置',
  x_5a97be8a: '大额审批设置',
  x_6fded8ab: '启用大额审批（超过门槛的取出/转账/付供应商需输PIN）',
  x_a54fc320: '美金门槛 $（0=不限）',
  x_807af4c1: '玻利瓦尔门槛 Bs（0=不限）',
  x_c0e9bd0c: '新6位审批PIN（留空不改）',
  x_47217200: '当前PIN（修改设置需验证）',
  x_9ccb14f1: '审批设置已保存',
  x_d9d6d5ba: '🔐 需要老板审批',
  x_be9d2bc1: '该金额超过审批门槛，请输入6位审批PIN',
  x_0e1667c5: '6位PIN',
  x_9cc24820: 'PIN错误',
  x_b8e32288: 'PIN已锁定，请15分钟后再试',
  x_7116e7ec: '账户',
  x_e3dea388: '该期间暂无数据',
  x_767d5ae4: '已自动恢复未交班的班次',
  x_b231f6b0: '已恢复今天未结的班次，继续使用',
  x_d5ff526d: '你有上一班未结账，请先结班再开新班',
  x_42d9293a: '30天 / 30 días',
  x_94903830: '60天 / 60 días',
  x_dc491dae: '90天 / 90 días',
  x_cba8c4ef: '请允许弹出窗口',
  x_6f2838fe: '请输入价格',
  x_32a79f1b: '滞销排行',
  x_ed320806: '畅销榜',
  x_9e3d9f77: '有库存商品',
  x_862dacd0: '零销量压货成本',
  x_70ac9021: '全部库存成本',
  x_966a2e61: '够卖(月)',
  x_460e109d: '压货成本',
  x_993a1358: '最后售出',
  x_7098d682: '清仓',
  x_d81bb206: '无',
  x_0dc5dc88: '拼团',
  x_28183523: '💥 设置清仓特价',
  x_baed7f26: '🔥 开启拼团清仓',
  x_f9c82b80: '特价已生效（线上OFERTA标签 + 线下POS同步改价）',
  x_6edc3851: '打印特价标签',
  x_23a605c4: '特价 (USD) — 默认85折',
  x_3576efc7: '拼团价 (USD)',
  x_ec798f44: '成团人数 (2-5)',
  x_3907665a: '特价时长（到期自动恢复原价）',
  x_d716067e: '7天',
  x_d9926871: '15天',
  x_853f8cf7: '30天',
  x_544cb8d3: '将修改商品价格1并在网店打上 OFERTA 标签',
  x_6ff9fab3: '在网店开启该商品拼团（需拼团总开关已开启）',
  x_15af542a: '🔒 发票店面信息由服务商维护，如需更改店名/地址请联系服务商（另行收费） / La información fiscal la administra el proveedor del sistema. Cambios de nombre/dirección: contacte a su proveedor (servicio con costo).',
  x_6e0df37b: '🧾 发票编号 / Numeración de facturas',
  x_12923f27: '✅ 已启用连续编号 / Numeración activa',
  x_9aa9020f: '⬜ 未启用 (点击启用) / Desactivada (clic para activar)',
  x_99a06c43: '前缀 / Prefijo',
  x_453340fc: '位数 / Dígitos',
  x_f45ac04c: '下一个号 / Próximo Nº',
  x_02f02875: '启用后, 每张确认收款的网店订单自动分配连续发票号, 显示在电子发票和小票上 / Al activar, cada pedido con pago confirmado recibe un número de factura consecutivo, visible en la factura electrónica.',
  x_eea9deb9: '店铺 Logo（可提取打印或做 WhatsApp 头像）',
  x_8c57e455: '上传 Logo',
  x_456885ba: '下载 Logo',
  x_967d445b: '🕐 网店下单时间限制 / Horario de pedidos online',
  x_8a0bbf6e: '委内瑞拉时间, 此时间外顾客无法下单; POS收银不受影响 / Fuera de este horario no se aceptan pedidos online; el POS no se ve afectado',
  x_2086719a: 'Volver a Precio 1 tras cada escaneo (P2/Caja aplica solo al próximo producto) / 选价格2/箱价只对下一件商品生效,扫完自动回到价格1',
  x_b9f9fade: '单据货币 / Moneda en ticket',
  x_d30839fd: '只打 Bs · Solo Bolívares',
  x_99f08c08: '只打 $ · Solo Dólares',
  x_75bffa13: '双币显示 · Bs + $',
  x_09d4c026: '🧑‍💼 店长面板功能 / Panel de Gerente',
  x_41ebcf52: '关掉的功能店长在前台面板看不到 (老板账号不受限) / Las funciones apagadas no aparecen al gerente de tienda',
  x_a2e95088: '全天汇总 / Resumen del día',
  x_1ae34829: '查看库存+商品资料 / Inventario',
  x_eb479750: '盘点 / Inventariar',
  x_e7926cff: '支出管理 / Gastos',
  x_75e361e0: '汇兑收益 / Ganancia cambiaria',
  x_1a7665ae: '现金余额 / Efectivo en caja',
  x_9a127288: '员工账务 / Cuentas de empleados',
  x_d7a96cba: '排班时间 / Horario',
  x_9ac5ab89: '赊账管理 / Créditos',
  x_c1f80f9b: '添加商品 / Agregar producto',
  x_0735fcbc: '调货收货 / Traslados',
  x_2ff230cf: '📊 网店访客分析',
  x_677d39e2: '谁在浏览你的网店、看什么、买不买',
  x_49ea343c: '当前在线',
  x_36331e50: '今日访客',
  x_63568477: '今日浏览',
  x_f2a70aa0: '今日订单',
  x_43798078: '访客趋势',
  x_c527743c: '下单转化率',
  x_852da3f7: '访客',
  x_88bc4d7a: '浏览量',
  x_dd2a2f3b: '🔥 热门商品（加购次数）',
  x_f2581824: '还没有数据 — 顾客把商品加入购物车后会统计',
  x_4f15720f: '设备占比',
  x_e855972e: '电脑',
  x_c77c44eb: '还没有访客数据 — 分享店铺链接后这里会实时统计',
  x_c864ee0a: '14天',
  x_fdfd62e8: '今日注册',
  x_bd83f3a1: '🛒 购买转化漏斗',
  x_3c5c43e5: '加购',
  x_423da4b1: '下单',
  x_6e3a0666: '次加入购物车',
  x_72df3158: '📝 新注册顾客',
  x_1818467a: '该时间段没有新注册',
  x_61dd3548: '👀 最近访客（谁在看）',
  x_44761c5f: '匿名访客',
  x_ff6e1828: '暂无访客记录',
  x_e9ac9962: '次浏览',
  x_381fb5ef: '🔔 访客高峰提醒',
  x_3836004f: '在线人数达到设定值时 WhatsApp 通知你，抓住热流量推促销',
  x_468a206b: '在线人数 ≥',
  x_60051ff7: '通知号码（留空=用订单通知号码）',
  x_0c18a538: '每次提醒间隔至少 60 分钟，避免刷屏',
  x_add9c8bf: '⚖️ 劳动法 LOTTT',
  x_a09fe96e: '🧾 税法 SENIAT',
  x_e9f30aae: '🏢 商法 Mercantil',
  x_3dcf62b4: '问任何问题,比如:',
  x_50a1215a: '辞退一个工作3年的员工要赔多少?',
  x_c9e9a906: '加班费怎么算?',
  x_eb3853bc: '"辞退一个工作3年的员工要赔多少?" · "¿Cuánto es el cestaticket actual?" · "加班费怎么算?"',
  x_b08d2eca: '⚖️ AI 正在查阅法律…',
  x_323d361d: '输入你的法律问题… / Escriba su consulta…',
  x_74221fd8: '清空对话',
  x_2aad6aeb: '先选员工',
  x_842bd876: '员工 / Empleado',
  x_f48c1e0f: '开始 / Desde',
  x_0a50a227: '结束 / Hasta',
  x_60197011: 'AI 计算中…',
  x_9945bf6c: 'AI 生成工资月结',
  x_98a98282: 'AI 会读取该员工在系统里的真实数据(工资、考勤、借款/欠账),按 LOTTT 法条生成合规月结单。',
  x_010a3d9c: '⚖️ AI 正在核对 LOTTT 法条并计算工资…(约 20-40 秒)',
  x_b7014d64: '委内瑞拉劳动法 LOTTT · 税法 SENIAT · 商法 — AI 引用具体法条回答,并可自动生成合规工资月结',
  x_1a1d2d4e: 'AI 学分余额',
  x_88426c86: '问答 1 学分 · 工资月结 3 学分',
  x_10d691fd: '💰 AI工资月结',
  x_c228ed55: '⏳ 等待上传 / Pendiente de subir',
  x_95a03b22: '✅ 重复单-钱可能已收到, 核对后可删 / Duplicado - probablemente ya cobrado',
  x_b60c2cbc: '❌ 库存不足 - 未入账，补货后重新打单',
  x_9ed2da59: '❌ 被服务器拒绝 - 未入账',
  x_9c8b638d: '没有可同步的',
  x_59c10673: '同步队列',
  x_963d2f9c: '全部已同步, 没有待处理的操作',
  x_422e18f2: '已删除',
  x_6b1192c7: '删除',
};

Object.assign(zh, {
  refCommNav: '💵 推荐返佣',
  refCommTitle: '推荐返佣管理',
  refCommDesc: '商户介绍新客户，新客户首次付费后按比例返现给介绍人（一次性）',
  refCommEnabled: '启用现金返佣',
  refCommRate: '返佣比例 (%)',
  refCommSave: '保存',
  refCommSettingsSaved: '返佣设置已保存',
  refCommPendingTotal: '待支付返佣',
  refCommPaidTotal: '已支付返佣',
  refCommPendingCount: '笔待支付',
  refCommRecords: '返佣记录',
  refCommReferrer: '介绍人',
  refCommReferred: '新商户',
  refCommAmountPaid: '客户付款',
  refCommAmount: '返佣金额',
  refCommStatus: '状态',
  refCommPending: '待支付',
  refCommPaid: '已支付',
  refCommCancelled: '已作废',
  refCommMarkPaid: '标记已付',
  refCommPayMethod: '支付方式',
  refCommPayRef: '转账参考号/备注',
  refCommConfirmPay: '确认已支付',
  refCommCancelRec: '作废',
  refCommManualAdd: '手动添加返佣',
  refCommSelectTenant: '选择被介绍商户',
  refCommNoEligible: '没有可添加的商户（需通过推荐码注册且未生成过返佣）',
  refCommNoRecords: '暂无返佣记录',
  refCommDate: '日期',
  refCommClose: '关闭',
  refCommMyEarnings: '我的现金返佣',
  refCommPendingBalance: '待结算',
  refCommReceived: '已收到',
  refCommEarnRule: '新客户用您的推荐码注册并首次付费后，您可获得其付款金额 {rate}% 的现金返佣',
  refCommPayoutNote: '💰 返佣由平台通过 Pago Móvil / Zelle / Binance 转账给您',
  refCommCreatedToast: '已生成返佣记录',
  renewAmountPaid: '本次收款金额 (USD)',
  renewAmountPaidHint: '选填 · 用于记录付款和计算推荐返佣',
  renewReferredHint: '该商户由推荐码介绍注册，首次付费将自动生成返佣记录',
  refPosterBtn: '生成海报',
  refPosterTitle: '推荐分享海报',
  refPosterDownload: '下载海报',
  refPosterDownloaded: '海报已下载，发到WhatsApp给朋友吧！',
  refPosterHint: '下载海报图片发朋友圈，或点WhatsApp直接分享推荐链接',
  refProgramNav: '🎁 推荐赚钱 · Sellox平台',
  refHow2Desc: '朋友用您的推荐码注册试用（此时还没有返佣）',
  refHow3Title: '付费才返佣',
  refHow3Desc: 'TA正式付费购买后，您才获得其付款金额 {rate}% 的现金返佣',
  refStatUses: '已推荐商家',
  refStatEarned: '累计返佣',
  duTitle: 'USDT 直接支付（Binance）',
  duZeroFee: '零手续费',
  duDesc: '直接转 USDT (TRC20) 到平台收款地址，贴上交易哈希秒确认自动开通。Binance 内部转账请用截图审核。',
  duBuyLifetime: '套餐开通（含首年服务费，次年起每年交服务费）',
  duMaintenance: '续年维护费',
  duMaintenance12m: '年维护费 · 12个月',
  duExpiry: '到期',
  duCredits: '充值 AI 学分',
  duStep1: '第1步：转账以下金额到收款地址（仅限 TRC20 网络）',
  duStep2: '第2步：转账后粘贴交易哈希 (TxID)，系统链上验证后立即开通',
  duTxidPlaceholder: '粘贴 64 位交易哈希 TxID…',
  duVerifyBtn: '验证并开通',
  duPasteTxid: '请粘贴交易哈希 TxID',
  duNetworkWarn: '务必选择 TRC20 (TRON) 网络，转错网络无法到账！',
  duBinanceInternal: 'Binance 内部转账没有TxID？',
  duUploadScreenshot: '上传截图人工审核',
  duMyOrders: '我的支付订单',
  duStPending: '待支付',
  duStReview: '审核中',
  duStConfirmed: '已开通',
  duStRejected: '已拒绝',
  duNav: '💰 USDT直付订单',
  duAdminTitle: 'USDT 直付订单',
  duAll: '全部',
  duTenant: '商户',
  duUseCase: '用途',
  duApprove: '确认开通',
  duRejectNote: '拒绝原因（可留空）',
  duScreenshot: '付款截图',
  duYearFee: '首年服务费',
  mainSupplier: '主供应商（智能补货按它分组发单）',
  noSupplier: '— 未设置 —',
  priceCompare: '供应商比价（历史进货价，最便宜在前）',
  posRejTitle: '订单被拒绝',
  posRejLine1: '这笔单没有入账！系统里不会有记录',
  posRejLine2: '先不要找零、不要交货！',
  posRejLine3: '购物车还在，解决问题后重新收款',
  posSaveFailTitle: '订单没保存上！',
  posSaveFailLine1: '服务器没响应，这台设备也存不下这笔单',
  posSaveFailLine2: '马上拍照或抄下上面的单号和金额，报告老板',
  posSaveFailLine3: '不要关这个页面！网络恢复后重新收款',
  posShiftWarnTitle: '开班没连上服务器',
  posShiftWarnLine1: '班次已先存在本机，可以继续卖货',
  posShiftWarnLine2: '如果网络一直不恢复，记得告诉老板一声',
  supBasicInfo: '基础信息',
  supExtraInfo: '辅助信息',
  supCategory: '供应商分类',
  supAddCategory: '添加分类',
  supTaxId: '税号 (RIF)',
  supCurrency: '采购结算货币',
  supTerms: '结算账期（天）',
  supEmail: '电子邮箱',
  supPostal: '邮政编码',
  supBankName: '开户银行',
  supBankAccount: '银行账号',
  supCarrier: '默认运输商',
  supCountry: '国家',
  supState: '省份',
  supCity: '城市',
  supNotes: '备注',
  supAutoGen: '留空自动生成',
  supDupName: '⚠️ 该供应商名称已存在',
  supDupCode: '⚠️ 该供应商编码已被使用',
  supSearch: '输入名称/编码搜索供应商…',
  supNoMatch: '没有匹配的供应商',
  posAlertSoundTitle: 'POS警示音',
  posAlertSoundHint: '弹出红色警示时播放的声音（点击试听）',
  soundBuzzer: '蜂鸣（默认）',
  soundBeep: '哔哔',
  soundChime: '清脆铃声',
  posSaleSoundTitle: '开单成功提示音',
  posSaleSoundHint: '每笔收款完成后播放（点击试听）',
  saleSoundDing: '叮咚',
  saleSoundCash: '收银机 ka-ching',
  saleSoundOk: '双响 OK',
  pmVoiceTitle: 'Pago Móvil / 转账到账语音',
  pmVoiceHint: '收银台验证参考号出结果时播报：到账 / 有异常 / 未查到',
  pmVoiceShort: '只报「Pago Móvil confirmado」',
  pmVoiceAmount: '报「confirmado + 金额 Bs」',
  soundSiren: '警笛',
  soundOff: '静音',
  invLedger: '库存流水',
  ledgerSale: '销售',
  ledgerReturn: '退货',
  ledgerPurchase: '进货',
  ledgerAdjust: '调整',
  ledgerLoss: '损耗',
  ledgerTransfer: '调拨',
  ledgerCreate: '新建商品',
  ledgerDelete: '删除商品',
  ledgerAllProducts: '全部商品（新增/删除/调整）',
  ledgerNoData: '该期间没有库存变动',
  ledgerCurStock: '当前库存',
  posNoLastOrder: '本次开机还没有小票可重印（先完成一笔销售）',
  posOk: '知道了',
  verNewWeb: '🆕 新版本',
  verClickReload: '点击更新',
  cat_pdf_btn: '目录PDF',
  cat_pdf_title: '按分类导出商品目录 PDF',
  cat_pdf_hint: '横版大图目录，适合发到微信/WhatsApp 批发群。价格与批发网店显示一致。',
  cat_pdf_select_all: '全选',
  cat_pdf_clear: '清空',
  cat_pdf_hide_inactive: '不显示已下架商品',
  cat_pdf_hide_oos: '不显示库存为 0 的商品',
  cat_pdf_show_prices: '显示价格',
  cat_pdf_generate: '生成 PDF',
  cat_pdf_generating: '生成中…（图片多时需 10～30 秒）',
  cat_pdf_done: 'PDF 已生成',
  cat_pdf_empty: '所选分类没有商品',
  cat_pdf_pick: '请至少勾选一个分类',
  cat_pdf_color: '主题颜色',
  cat_pdf_color_custom: '自定义颜色',
  wsx_sm_qr: '店铺二维码',
  wsx_sm_qr_hint: '客户扫码进入批发网店，自动归属这位业务员（可保存图片发微信/WhatsApp 群）。',
  bulto: '捆(Bulto)',
  bultoBoxes: '每捆几箱',
  bultoPrice: '捆价',
  bultoHint: '捆 = 大包装，一捆装几箱。填 0 表示没有捆。',
  bultos: '捆',
  wsx_moq_mode: '起批方式',
  wsx_moq_mode_box: '整箱起批（数量按整箱倍数）',
  wsx_moq_mode_unit: '单件起批（可买 1 个，也可按整箱加）',
  wsx_moq_mode_hint: '盒/捆两级的店（如最小卖 1 盒）请选「单件起批」。',
  cat_pdf_products: '个商品',
  cat_pdf_uncat: '个商品没分类，不会进目录',
  cat_pdf_uncat_hint: '去商品管理给它们选分类后才会出现在 PDF 里',
  x_svc_staff_pick: '选技师…',
  x_svc_not_found: '找不到对应的服务项目，请手动添加',
  x_beauty_center: '美业中心',
  x_appt_pay_pos: '收款开单',
  x_appt_paid: '已收款',
  x_appt_online: '网店预约',
  x_appt_pick_service: '选服务项目…',
  x_appt_pick_staff: '选技师…',
  x_cust_beauty: '美业档案',
  x_pkg_service: '对应服务项目（收银时只能抵扣这个服务）',
  x_pkg_service_any: '不限（任何服务都可抵扣）',
  x_save_btn: '保存',
});

export default zh;